export default {
    "Dashboard": "Painel de Controle",
    "Products": "Produtos",
    "Order": "Pedido",
    "Stores": "Lojas",
    "Service Ticket": "Chamado de Suporte",
    "Pre-order Inventory": "Estoque de Pré-venda",
    "Third Bound Goods": "Produtos de Terceiros",
    "Withdrawal List": "Lista de Saques",
    "My Profile": "Meu Perfil",
    "Import List": "Lista de Importação",
    "My Products": "Meus Produtos",
    "Quotation": "Cotação",
    "Payment": "Pagamento",
    "Shipments": "Envios",
    "Shipment": "Código de Rastreamento",
    "Abnormal": "Anormal",
    "Completed": "Concluído",
    "On Hold": "Em Espera",
    "Canceled": "Cancelado",
    "All": "Todos",
    "Support": "Suporte",

    "Announcement": "Anúncio",
    "balance": "Saldo",
    "View Detail": "Ver detalhes",
    "wallet": "Carteira",
    "commission": "Comissão",
    "withdraw": "Sacar",
    "system notification": "Notificação do sistema",
    "Order Quantity": "Quantidade de Pedidos",
    "Commission": "Comissão",
    "Total commission": "Comissão total",
    "This month Orders": "Pedidos deste mês",
    "This month Revenue": "Receita deste mês",
    "This month Cost": "Custo deste mês",
    "Statistics": "Estatísticas",
    "Reference": "Referência",
    "Date": "Data",
    "Total Orders": "Total de pedidos",
    "Cost": "Custo",
    "Show More": "Mostrar mais",
    "Quick Summary": "Resumo rápido",
    "orders": "pedidos",
    "Waiting to place order": "Aguardando criação do pedido",
    "Waiting for tracking code": "Aguardando código de rastreamento",
    "Authorized": "Autorizado",
    "Share by APP": "Compartilhar pelo aplicativo",
    "Share": "Compartilhar",
    "Scan share to WeChat": "Escaneie para compartilhar no WeChat",
    "Share by link": "Compartilhar por link",
    "Share link": "Link de compartilhamento",
    "Copy Link": "Copiar link",
    "Clear": "Limpar",
    "Close": "Fechar",
    "Your vendor": "Seu fornecedor",
    "is inviting you to allocate your Orders": "está convidando você a alocar seus pedidos",
    "Your store name": "Nome da sua loja",
    "Dispatch order method": "Método de envio do pedido",
    "All my unfulfilled / partially fulfilled orders": "Todos os meus pedidos não atendidos / parcialmente atendidos",
    "Cycle time": "Tempo de ciclo",
    "Every 1 day": "A cada 1 dia",
    "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings": "Você pode modificar as regras de envio dos pedidos a qualquer momento no menu 'Meus Pedidos >> Configurações de Envio'",
    "Remind later": "Lembrar mais tarde",
    "I agree": "Concordo",
    "According to your settings, we found some data for you": "De acordo com suas configurações, encontramos alguns dados para você",
    "Shopify order": "Pedido da Shopify",
    "Dispatch in the Next Cycle": "Enviar no próximo ciclo",
    "Dispatch Immediately": "Enviar imediatamente",
    "Revenue": "Receita",
    "You can modify your store settings at any time in the menu 'My Stores'": "Você pode modificar as configurações da sua loja a qualquer momento no menu 'Minhas Lojas'",
    "Newbie": "Iniciante",
    "Guide": "Guia",
    "Complete personal information": "Completar informações pessoais",
    "Authorize to bind the store": "Autorizar a vinculação da loja",
    "Publish the push product": "Publicar o produto para envio",
    "Start pulling orders": "Começar a importar pedidos",
    "Already": "Já",
    "enter": "Entrar",
    "offline": "Offline",
    "success": "Sucesso",
    "Add vendors success": "Fornecedores adicionados com sucesso",
    "Total Revenue": "Receita total",
    "Total Cost": "Custo total",
    "Has been copied to the clipboard": "Copiado para a área de transferência",
    "Copy to clipboard failed, please copy manually": "Falha ao copiar para a área de transferência. Copie manualmente",

    "Waiting": "Aguardando",
    "Processing": "Processando",
    "Failed": "Falhou",
    "Are you sure you want to push?": "Tem certeza de que deseja enviar?",
    "Do you want to delete this task?": "Deseja excluir esta tarefa?",
    "The update  has started, it will take a while to finish.": "A atualização foi iniciada e levará algum tempo para ser concluída.",
    "Do you want to delete the product?": "Deseja excluir o produto?",
    "Do you want to Export the product?": "Deseja exportar o produto?",
    "Export success": "Exportação realizada com sucesso",
    "Please select the products": "Por favor, selecione os produtos",
    "URL required": "URL obrigatória",
    "Import success": "Importação realizada com sucesso",
    "Please select the tags": "Por favor, selecione as tags",
    "Tags added successfully": "Tags adicionadas com sucesso",
    "You can import and manage your AliExpress / Amazon products here before publishing them to your Shopify store. You can publish a product to different stores and add multiple tags to each products.": "Você pode importar e gerenciar seus produtos do AliExpress / Amazon aqui antes de publicá-los na sua loja Shopify. É possível publicar um produto em diferentes lojas e adicionar várias tags a cada produto.",
    "Import Aliexpress": "Importar do AliExpress",
    "Import Product": "Importar produto",
    "Product Name": "Nome do produto",
    "Product Type": "Tipo de produto",
    "Product Pictures": "Imagens do produto",
    "Single Value in USD": "Valor unitário em USD",
    "Gross weight for each Carton": "Peso bruto por caixa",
    "Carton Package Size L": "Comprimento da caixa",
    "Carton Package Size W": "Largura da caixa",
    "Carton Package Size H": "Altura da caixa",
    "Single Price": "Preço unitário",
    "Salesman": "Vendedor",
    "Comment": "Comentário",

    "All Stores": "Todas as lojas",
    "Filter": "Filtrar",
    "Push": "Enviar",
    "Export": "Exportar",
    "Delete": "Excluir",
    "Add Tags": "Adicionar tags",
    "Tag management": "Gerenciamento de tags",
    "Confirm": "Confirmar",
    "Push Setting": "Configurações de envio",
    "Upload Progress": "Progresso do upload",
    "Status": "Status",
    "Images": "Imagens",
    "Sold Out": "Esgotado",
    "Store Name": "Nome da loja",
    "Price": "Preço",
    "Supply Unit Price": "Preço unitário de fornecimento",
    "Your Price": "Seu preço",
    "Fail Reason": "Motivo da falha",
    "Edit": "Editar",
    "Open in Web": "Abrir no navegador",
    "no product": "nenhum produto",
    "All Action": "Todas as ações",
    "price check": "verificar preço",
    "add related products": "adicionar produtos relacionados",
    "Open in  website": "Abrir no site",
    "Retail price": "Preço de varejo",
    "Supplier price": "Preço do fornecedor",
    "NOT SET": "NÃO DEFINIDO",
    "Shopify store": "Loja Shopify",
    "vendors": "fornecedores",
    "You can only upload 5 pictures": "Você só pode enviar até 5 imagens",
    "Price units default to": "Unidades de preço padrão:",
    "Please upload pictures": "Por favor, envie as imagens",
    "Please enter title": "Por favor, insira o título",
    "Please enter price": "Por favor, insira o preço",
    "Are you sure you want to delete it?": "Tem certeza de que deseja excluir?",

    "Order Management": "Gestão de pedidos",
    "Waiting For Quote": "Aguardando cotação",
    "Pay All": "Pagar tudo",
    "SKU number/quantity/name": "SKU/Quantidade/Nome",
    "Update Order": "Atualizar pedido",
    "Export Order": "Exportar pedido",
    "Import Order": "Importar pedido",
    "Import Product Image": "Importar imagem do produto",
    "Order Number": "Número do pedido",
    "Payment Number": "Número do pagamento",
    "Today": "Hoje",
    "Create Quotation": "Criar cotação",
    "Abandon Quotation": "Abandonar cotação",
    "Bulk Payment": "Pagamento em massa",
    "Continue Pay": "Continuar pagamento",
    "Requote": "Re-cotar",
    "Product Images": "Imagens do produto",
    "Please make an offer": "Por favor, faça uma oferta",
    "Supplier Price": "Preço do fornecedor",
    "Retail Price": "Preço de varejo",
    "Action": "Ação",
    "Remove": "Remover",
    "offline order": "pedido offline",
    "Wholesale order": "pedido no atacado",
    "Order No.": "Nº do pedido",
    "Created Date": "Data de criação",
    "Shipping Address": "Endereço de envio",
    "Customer": "Cliente",
    "Shipping Method": "Método de envio",
    "Free Shipping": "Frete grátis",
    "Shipping Cost": "Custo de envio",
    "Total": "Total",
    "Pay Total": "Total a pagar",
    "Quote": "Cotação",
    "Pay": "Pagar",
    "Split Order": "Dividir pedido",
    "Manually Sync": "Sincronizar manualmente",
    "After-sales": "Pós-venda",
    "Cancel Order": "Cancelar pedido",
    "Sku/Quantity/Name": "SKU/Quantidade/Nome",
    "Unable to be sourced": "Não disponível para compra",
    "Attribute Value": "Valor do atributo",
    "Payment No.": "Nº do pagamento",
    "Payment Time": "Data do pagamento",
    "Amount": "Valor",
    "Countdown": "Contagem regressiva",
    "Cancel Payment": "Cancelar pagamento",
    "Repay": "Pagar novamente",
    "To Complete Payment": "Para concluir o pagamento",
    "Supplier Unit Price": "Preço unitário do fornecedor",
    "Removed": "Removido",
    "Shipping Type": "Tipo de envio",
    "LOGISTICS": "LOGÍSTICA",
    "SELF PICKUP": "RETIRADA",
    "PREPURCHASE": "PRÉ-COMPRA",
    "Order ID": "ID do pedido",
    "Recover": "Restaurar",
    "RecoverAll": "Restaurar tudo",
    "Pay with": "Pagar com",
    "Bonus": "Bônus",
    "There is no alternative method of payment": "Não há outro método de pagamento disponível",
    "Please do not close the page during payment": "Por favor, não feche a página durante o pagamento",
    "Close pay": "Fechar pagamento",
    "Your order has been successfully paid": "Seu pedido foi pago com sucesso",
    "The selected orders are abnormal and payment cannot be continued": "Os pedidos selecionados apresentam problemas e o pagamento não pode continuar",
    "Payment can continue after excluding the following goods": "O pagamento pode continuar após excluir os seguintes produtos",
    "After removing the off shelf goods, the order will be returned to the": "Após remover os produtos fora de estoque, o pedido será retornado para",
    "price to be quoted": "preço a ser cotado",
    "Select file": "Selecionar arquivo",
    "Click to download": "Clique para baixar",
    "Order Import Template": "Modelo de importação de pedidos",
    "Please fill in the form according to the specification, only xlsx format files are supported": "Por favor, preencha o formulário conforme a especificação. Apenas arquivos no formato XLSX são suportados",
    "The uploaded file cannot exceed 2M, and only the first 99 data are processed": "O arquivo enviado não pode exceder 2 MB e apenas os primeiros 99 registros serão processados",
    "submit": "enviar",
    "Created At": "Criado em",
    "Cancel": "Cancelar",
    "Waiting for quotation": "Aguardando cotação",
    "Supplier Quote": "Cotação do fornecedor",
    "Payment Not Received": "Pagamento não recebido",
    "Pending payment": "Pagamento pendente",
    "Waiting For Fulfill": "Aguardando envio",
    "Fulfilled": "Enviado",
    "Logistics sync failed": "Falha na sincronização logística",
    "Unable to purchase": "Não foi possível comprar",
    "Products off shelf": "Produtos fora de estoque",
    "Payment unfinished": "Pagamento não concluído",
    "Payment to be completed": "Pagamento a ser concluído",
    "Unshipped": "Não enviado",
    "Quit quotation": "Cancelar cotação",
    "Payment failed": "Falha no pagamento",
    "Vendor Verifying Payment": "Fornecedor verificando o pagamento",
    "Payment result to be returned": "Resultado do pagamento pendente",
    "Remove the product": "Remover o produto",
    "Removed the product successful": "Produto removido com sucesso",
    "Delete Successful": "Exclusão realizada com sucesso",
    "Please select an order first": "Por favor, selecione um pedido primeiro",
    "Sure to delete this item?": "Tem certeza de que deseja excluir este item?",
    "Delete Successful!": "Exclusão realizada com sucesso!",
    "Please select an order": "Por favor, selecione um pedido",
    "Please choose file": "Por favor, escolha um arquivo",
    "Create Success": "Criado com sucesso",

    "No goods need to be eliminated": "Não há produtos a serem eliminados",
    "No logistics": "Sem logística",
    "Are you sure to abandon payment for the selected order? After abandoning, the order will disappear from the list, which cannot be restored, please operate with caution": "Tem certeza de que deseja abandonar o pagamento do pedido selecionado? Depois disso, o pedido desaparecerá da lista e não poderá ser restaurado. Por favor, proceda com cuidado.",
    "No Purchase": "Cotação cancelada",
    "Unpaid Order": "Pedido não pago",
    "Payment Initiated but Unpaid": "Pagamento iniciado, mas não concluído",
    "Payment Made but Not Received": "Pagamento realizado, mas não recebido",
    "The receiving address has no logistics method set": "O endereço de entrega não possui método logístico definido",
    "The order is below the minimum deliverable weight": "O pedido está abaixo do peso mínimo para entrega",
    "The order is below the minimum deliverable volume": "O pedido está abaixo do volume mínimo para entrega",
    "The order is higher than the maximum deliverable weight": "O pedido excede o peso máximo permitido para entrega",
    "The order is higher than the maximum deliverable volume": "O pedido excede o volume máximo permitido para entrega",
    "The following product attributes of this order do not meet the attribute requirements of deliverable products": "Os seguintes atributos de produto deste pedido não atendem aos requisitos de entrega",
    "The total weight of the goods in this order does not meet the deliverable requirements": "O peso total dos produtos deste pedido não atende aos requisitos de entrega",
    "Weight": "Peso",
    "Quantity": "Quantidade",
    "Total weight": "Peso total",
    "Attribute": "Atributo",
    "I Know": "Entendi",
    "Card Number": "Número do cartão",
    "Expiration": "Validade",
    "Payment amount": "Valor do pagamento",
    "Payment instructions": "Instruções de pagamento",
    "Other details": "Outros detalhes",
    "Payment account": "Conta de pagamento",
    "Payment voucher": "Comprovante de pagamento",
    "Add Tracking": "Adicionar rastreamento",
    "Track number": "Número de rastreio",
    "Please input the tracking number": "Por favor, insira o número de rastreio",
    "Track company": "Empresa de rastreamento",
    "Please select logistics company": "Por favor, selecione a empresa de logística",
    "Your request has been sent": "Sua solicitação foi enviada",
    "My Stores": "Minhas lojas",
    "Add a new store": "Adicionar nova loja",
    "Creation date": "Data de criação",
    "Auth date": "Data de autorização",
    "Remove entrusted vendor": "Remover fornecedor confiável",
    "Reauthorize": "Reautorizar",
    "Coming Soon": "Em breve",
    "vendor is authorizing the store on BCNDropshipping App, please be noted.": "O fornecedor está autorizando a loja no aplicativo BCNDropshipping. Fique atento.",
    "If you do not check the relevant permissions, it will affect the use of related functions, please operate with caution": "Se você não conceder as permissões necessárias, isso poderá afetar o uso das funções relacionadas. Proceda com cuidado.",
    "Connect": "Conectar",
    "Are you sure you want to cancel the hosting store": "Tem certeza de que deseja cancelar a hospedagem da loja?",
    "after you close the hosting, the supplier will not be able to actively quote your order!": "Após cancelar a hospedagem, o fornecedor não poderá cotar ativamente seus pedidos!",
    "Sure": "Confirmar",
    "You have successfully hosted the store": "Loja hospedada com sucesso",
    "After the successful hosting, your supplier will take the initiative to quote for your pending orders!": "Após a hospedagem bem-sucedida, seu fornecedor passará a cotar seus pedidos pendentes!",
    "Choose a vendor": "Escolha um fornecedor",
    "Select": "Selecionar",
    "No Data": "Sem dados",
    "Save": "Salvar",
    "Add a new vendor": "Adicionar novo fornecedor",
    "Customer name required": "Nome do cliente obrigatório",
    "customers successfully added": "Clientes adicionados com sucesso",
    "Are you sure you want to remove entrusted vendor?": "Tem certeza de que deseja remover o fornecedor confiável?",

    "After-sales Ticket": "Solicitação de Pós-venda",
    "Ticket Type": "Tipo de Solicitação",
    "Customer Name": "Nome do Cliente",
    "Approval": "Aprovação",
    "Transaction Type": "Tipo de Transação",
    "Question Type": "Tipo de Pergunta",
    "Problem Description": "Descrição do Problema",
    "Refund": "Reembolso",
    "Replacement": "Substituição",
    "modify the related information for customer": "Modificar informações relacionadas ao cliente",
    "cancel order": "Cancelar Pedido",
    "No tracking information": "Sem informações de rastreio",
    "Tracking information not update too long time": "Informações de rastreio desatualizadas há muito tempo",
    "Item damage": "Produto Danificado",
    "Item missing": "Produto Faltando",
    "Send wrong product": "Produto Enviado Incorreto",
    "Send wrong address": "Endereço Incorreto",
    "On hold order": "Pedido em Espera",
    "optional": "Opcional",
    "Order Information": "Informações do Pedido",
    "Third party order number": "Número do Pedido de Terceiros",
    "Creation time": "Data de Criação",
    "On Hold Order": "Pedido em Espera",
    "Resend Item": "Reenviar Produto",
    "Refund Item": "Reembolsar Produto",
    "agree": "Concordar",
    "Ticket No.": "Nº da Solicitação",
    "please enter": "Por favor, insira",
    "Approval Status": "Status de Aprovação",
    "Await Review": "Aguardando Revisão",
    "Reject": "Rejeitar",
    "Pass": "Aprovar",
    "Missing Item": "Produto Faltando",
    "Wrong Product": "Produto Incorreto",
    "Modify the related information for customer": "Modificar informações do cliente",
    "Change color/size": "Alterar Cor/Tamanho",
    "Change Product": "Alterar Produto",
    "Payment Issues": "Problemas de Pagamento",

    "Pre-order stock order": "Pedido de Estoque Pré-encomendado",
    "pleaseCusName": "Por favor, informe o Nome do Cliente",
    "Withdrawal list": "Lista de Retirada",
    "Withdrawal method": "Método de Retirada",
    "CreateDate": "Data de Criação",
    "startDate": "Data de Início",
    "endDate": "Data de Término",
    "accountPayee": "Beneficiário da Conta",
    "customersName": "Nome do Cliente",
    "Warning Tips": "Avisos",
    "Withdrawal Amount": "Valor de Retirada",
    "reject": "Rejeitar",
    "Pending": "Pendente",
    "Approved": "Aprovado",
    "GENERAL INFORMATION": "INFORMAÇÕES GERAIS",
    "CONTACT": "CONTATO",
    "Change": "Alterar",
    "ADD": "ADICIONAR",
    "SOCIAL": "SOCIAL",
    "Notification Settings": "Configurações de Notificação",
    "I want to receive notfications by": "Desejo receber notificações por",
    "Mobile phone": "Telefone Celular",
    "Allow system notifhcations": "Permitir notificações do sistema",
    "Allow Customer Services from": "Permitir atendimento ao cliente via",
    "Allow Dropshipping News": "Permitir Notícias de Dropshipping",
    "Reset All": "Redefinir Tudo",
    "Save Changes": "Salvar Alterações",
    "try again in": "Tente novamente em",
    "seconds": "segundos",
    "Discard": "Descartar",
    "Voucher": "Comprovante",
    "abnormal bill": "Fatura Anormal",
    "View detail": "Ver Detalhes",
    "download PDF": "Baixar PDF",
    "Petitioner": "Solicitante",
    "Invoice Pay": "Pagamento de Fatura",
    "Refund Order": "Reembolso de Pedido",
    "Bonus Recharge": "Recarga de Bônus",
    "Bonus Deduction": "Dedução de Bônus",
    "unpaid": "Pendente",
    "paid": "Pago",
    "refund": "Reembolsado",
    "canceled": "Cancelado",

    "Login/Register": "Entrar/Registrar",
    "Logout": "Sair",
    "Powered by COMEXBCN-BCN DROPSHIPPING": "Desenvolvido por COMEXBCN-BCN DROPSHIPPING",
    "Home": "Início",
    "PRIVACY POLICY": "POLÍTICA DE PRIVACIDADE",
    "SHIPPING POLICY": "POLÍTICA DE ENVIO",
    "TERMS AND CONDITIONS OF USE": "TERMOS E CONDIÇÕES DE USO",
    "RETURN AND REFUND POLICY": "POLÍTICA DE DEVOLUÇÃO E REEMBOLSO",
    "CONTACT US": "CONTATE-NOS",
    "Category Name": "Nome da Categoria",
    "More": "Mais",
    "Product category name": "Nome da Categoria do Produto",
    "Waiting for the payment result to be returned.": "Aguardando retorno do resultado do pagamento.",
    "You may need to wait a little while": "Você precisará aguardar um pouco",
    "Payment successful": "Pagamento realizado com sucesso",
    "You have successfully completed your order": "Você concluiu seu pedido com sucesso",
    "View order": "Ver Pedido",
    "Sorry, we can't complete the payment.": "Desculpe, não foi possível concluir o pagamento.",
    "Add New Address": "Adicionar Novo Endereço",
    "Product Details": "Detalhes do Produto",
    "Please check the purchase produc": "Por favor, verifique o produto comprado",
    "out of stock": "Fora de estoque",
    "Inventory": "Estoque",
    "Subtotal": "Subtotal",
    "Freight": "Frete",
    "Credits": "Créditos",
    "Combination payment": "Pagamento Combinado",
    "Please enter the balance to be used": "Por favor, insira o saldo a ser usado",
    "Rules: The input amount should be less than the order amount, and only two decimal places": "Regras: O valor inserido deve ser menor que o valor do pedido e com apenas duas casas decimais",
    "Payment method": "Método de Pagamento",
    "Amount due (including freight)": "Valor a Pagar (incluindo frete)",
    "Submit orders": "Enviar Pedidos",
    "Please select payment method": "Selecione o Método de Pagamento",
    "First Name": "Nome",
    "Please enter the first name": "Por favor, insira o nome",
    "Last Name": "Sobrenome",
    "Please enter the last name": "Por favor, insira o sobrenome",
    "Please enter the address": "Por favor, insira o endereço",
    "Please enter the country": "Por favor, insira o país",
    "Please enter the province": "Por favor, insira a província",
    "Please enter the city": "Por favor, insira a cidade",
    "Please enter the phone": "Por favor, insira o telefone",
    "Please enter the postcode": "Por favor, insira o código postal",
    "Set as default shipping address": "Definir como endereço de envio padrão",
    "Reset": "Reiniciar",
    "Search Product": "Pesquisar Produto",
    "History": "Histórico",
    "Publish": "Publicar",
    "No Account?": "Não tem conta?",
    "Sign up here": "Cadastre-se aqui",
    "Sign in": "Entrar",
    "Forgot your password?": "Esqueceu sua senha?",
    "or Sign in with": "ou entre com",
    "Already have an account?": "Já possui uma conta?",
    "Products Market": "Mercado de Produtos",
    "Unit Price": "Preço Unitário",
    "GO": "IR",
    "Qty Available": "Quantidade Disponível",
    "First Available": "Primeiro Disponível",
    "Last 7 days": "Últimos 7 dias",
    "Last 14 days": "Últimos 14 dias",
    "Last 30 days": "Últimos 30 dias",
    "Sort by": "Ordenar por",
    "There are no products in this category": "Não há produtos nesta categoria",
    "Please enter your shopify store name to connect the dashboard page": "Insira o nome da sua loja Shopify para conectar ao painel",
    "Stock Qty": "Quantidade em Estoque",
    "VAT information": "Informações sobre IVA",
    "you can click": "você pode clicar",
    "for VAT information": "para informações sobre IVA",
    "Shipping": "Envio",
    "Shipping to": "Enviar para",
    "Please select": "Por favor, selecione",
    "Shipping fee": "Taxa de Envio",
    "Quality": "Qualidade",
    "inventory": "estoque",
    "Add to List": "Adicionar à Lista",
    "Add to Cart": "Adicionar ao Carrinho",
    "Specifications": "Especificações",
    "Download the attachment": "Baixar Anexo",
    "product information": "Informações do Produto",
    "Product category": "Categoria do Produto",
    "product name": "Nome do Produto",
    "Specification": "Especificação",
    "material": "Material",
    "size": "Tamanho",
    "weight": "Peso",
    "The tax-inclusive price of an item is calculated based on the item price set by the seller and the applicable tax rate. You can contact the seller for more details.": "O preço com impostos incluídos é calculado com base no preço definido pelo vendedor e na taxa de imposto aplicável. Entre em contato com o vendedor para mais detalhes.",
    "You have authorized a Shopify store，you could": "Você autorizou uma loja Shopify, você pode",
    "to view details": "para ver detalhes",
    "authorize to login": "autorizar login",
    "If it is necessary to process your shopify order or to achieve an automatically update for the shipping information to shopify, you could": "Se necessário processar seu pedido Shopify ou atualizar automaticamente informações de envio, você pode",
    "connect your Shopify store": "conectar sua loja Shopify",
    "and let us help you": "e deixar-nos ajudá-lo",
    "If you have authorized a Shopify store, after the vendor delivers the items, the shipping information will been synchronized to your Shopify store which you had authorized.": "Se você autorizou uma loja Shopify, após o fornecedor entregar os itens, as informações de envio serão sincronizadas com sua loja Shopify autorizada.",
    "If there are some Shopify stores in the order list below that have not been authorized, you can": "Se houver lojas Shopify na lista de pedidos abaixo que não foram autorizadas, você pode",
    "authorize a new one": "autorizar uma nova",
    "If you need to view your recent orders, please click": "Se precisar ver seus pedidos recentes, clique em",
    "Cancelled": "Cancelado",
    "Purchase Order": "Ordem de Compra",
    "Tell us more about your request": "Conte-nos mais sobre sua solicitação",
    "Attach image file": "Anexar Arquivo de Imagem",
    "Browse": "Procurar",
    "What is your store name?": "Qual é o nome da sua loja?",
    "Customer Support Email": "E-mail de Suporte ao Cliente",
    "Send your request": "Enviar Solicitação",
    "Getting Started": "Primeiros Passos",
    "Main Features": "Principais Recursos",
    "Please enter Shopify store name": "Insira o nome da loja Shopify",
    "The email must not be empty": "O e-mail não pode estar vazio",
    "Send Success,We will contact you soon.": "Envio realizado com sucesso, entraremos em contato em breve",

    'Total Payment': 'Pagamento Total',
    'Total Merchandise': 'Total de Mercadorias',
    'SKU Details': 'Detalhes do SKU',
    'Commodity Price': 'Preço do Produto',
    'Subscribe to our newsletter': 'Assine nossa newsletter',
    'Promotions, new products and sales. Directly to your inbox.': 'Promoções, novos produtos e ofertas. Direto na sua caixa de entrada.',
    'Your email': 'Seu e-mail',
    'Subscribe': 'Inscrever-se',
    'Company Information': 'Informações da Empresa',
    'OUR SOCIAL MEDIA': 'Nossas Redes Sociais',
    'PRIVACY STATEMENT': 'Declaração de Privacidade',
    'Terms and Conditions': 'Termos e Condições',
    "Login": "Entrar",
    'Maximum recommended size 200px * 200px, image can be adaptive': 'Tamanho máximo recomendado 200px * 200px, a imagem pode ser adaptável',
    'add image': 'Adicionar imagem',
    'change': 'Alterar',
    'delete': 'Excluir',
    'Back': 'Voltar',
    'Please contact the supplier to improve the external number of the webmaster': 'Por favor, entre em contato com o fornecedor para ajustar o número externo do webmaster',
    'Black': 'Preto',
    'There are currently no products under this category': 'Atualmente não há produtos nesta categoria',
    'Logo': 'Logo',
    'You can find the recent quotationsand check offers': 'Você pode consultar cotações recentes e verificar ofertas',
    'Maximum recommended size 200px * 200px, image can be adapted': 'Tamanho máximo recomendado 200px * 200px, a imagem pode ser adaptada',
    'Add image': 'Adicionar imagem',
    'Change image': 'Alterar imagem',
    'Shopify tags': 'Tags Shopify',
    'New Tag': 'Nova Tag',
    'Shopify type': 'Tipo de Produto',
    'Loading': 'Carregando',
    'Compare Price': 'Preço de Comparação',
    'Cost Price': 'Preço de Custo',
    'Sale Price': 'Preço de Venda',
    'Product Cost': 'Custo do Produto',
    'incorrect input': 'Entrada incorreta',
    'Tag name': 'Nome da Tag',
    'Distributor commission withdrawal': 'Retirada de Comissão do Distribuidor',
    'Please enter the commission withdrawal amount': 'Por favor, insira o valor da retirada da comissão',
    'Remark': 'Observação',
    'Please enter content': 'Por favor, insira o conteúdo',
    'application time': 'Data da Solicitação',
    'start': 'Início',
    'end': 'Fim',
    'to': 'até',
    'Selected stores': 'Lojas Selecionadas',
    'Please select the Shopify stores': 'Por favor, selecione as lojas Shopify',
    'Shopify': 'Shopify',
    'Woocommerce': 'WooCommerce',
    'Lazada': 'Lazada',
    'Shopee': 'Shopee',
    'Change All': 'Alterar Tudo',
    'Multiply Price': 'Multiplicar Preço',
    'Add Price': 'Adicionar Preço',
    'Wayfair': 'Wayfair',
    'Push to Store': 'Enviar para Loja',
    'Add Cost Range': 'Adicionar Intervalo de Custo',
    'Rest of the price ranges': 'Restante dos intervalos de preço',
    'Plus': 'Adicionar',
    'Multiply': 'Multiplicar',
    'Fixed Price': 'Preço Fixo',
    'You can set a specific cent value for your price or comparison': 'Você pode definir um valor específico de centavos para o seu preço ou comparação',
    'price.': 'Preço',
    'Assign Cent': 'Definir Centavos',
    'Assign compare at Cent': 'Definir comparação em centavos',
    'According to store currency': 'De acordo com a moeda da loja',
    'Apply for products in Import List': 'Aplicar para produtos na Lista de Importação',
    'Add New Tags': 'Adicionar Novas Tags',
    'Are you sure to delete it??': 'Tem certeza de que deseja excluir??',
    'Please enter the New tag': 'Por favor, insira a nova tag',
    'Do you want to delete this task? Tips': 'Deseja excluir esta tarefa? Dicas',
    'error': 'Erro',
    'The update has started, it will take a while to finish.': 'A atualização foi iniciada, levará algum tempo para concluir.',
    'save successfully': 'Salvo com sucesso',
    'Do you want these?': 'Deseja estes',
    'product(s)?': 'produto(s)?',
    'Delete success': 'Exclusão realizada com sucesso',
    'Would you like to export ?': 'Deseja exportar?',
    'Unit Cost': 'Custo Unitário',
    'Import Aliexpress / Amazon product URL here and click': 'Importe o URL do produto Aliexpress / Amazon aqui e clique',
    'Product SKU': 'SKU do Produto',
    'Not purchased': 'Não comprado',
    'Cost per unit': 'Custo por unidade',
    'Clear selection': 'Limpar Seleção',
    'Total Quantity selected': 'Quantidade Total Selecionada',
    'Total Quantity': 'Quantidade Total',
    'Total Cartons': 'Total de Caixas',
    'Total CBM': 'Total CBM',
    "Single": "Único",
    "Multiple": "Múltiplos",
    "Sale name": "Nome da Venda",
    "Description": "Descrição",
    "Inculding supplier PL or PI": "Incluindo PL ou PI do fornecedor",
    "Attachment file": "Arquivo Anexo",

    'You can find the recent quotations and check offers': 'Você pode consultar as cotações recentes e verificar ofertas',
    'Waiting for vendors respond': 'Aguardando resposta dos fornecedores',
    'Vendors responding quotations': 'Fornecedores respondendo às cotações',
    'Archived quotations': 'Cotações arquivadas',
    'Unfulfilled': 'Não atendido',
    'Partially Fulfilled': 'Parcialmente atendido',
    'Refunded': 'Reembolsado',
    'Last 90 days': 'Últimos 90 dias',
    'Last 12 months': 'Últimos 12 meses',
    'Custom': 'Personalizado',
    'Order number (ascending)': 'Número do pedido (crescente)',
    'Order number (descending)': 'Número do pedido (decrescente)',
    'Order number': 'Número do pedido',
    'Date (oldest first)': 'Data (mais antiga primeiro)',
    'Date (newest first)': 'Data (mais recente primeiro)',
    'Partially refunded': 'Parcialmente reembolsado',
    'orders selected': 'Pedidos selecionados',
    'orders selected, uncheck': 'Pedidos selecionados, desmarcar',
    'orders selected, select all': 'Pedidos selecionados, selecionar todos',
    'Request Quotation': 'Solicitar Cotação',
    'Only orders in': 'Apenas pedidos em',
    'Paid': 'Pago',
    'No order selected': 'Nenhum pedido selecionado',
    'Create quotation request': 'Criar solicitação de cotação',
    'can': 'Pode',
    'waiting for responding': 'Aguardando resposta',
    'Confirmed': 'Confirmado',
    'ID Range': 'Intervalo de ID',
    'Order Includes': 'Pedido Inclui',
    'View offers': 'Ver ofertas',
    'Cancel offers': 'Cancelar ofertas',
    'Check offers': 'Verificar ofertas',
    'View offer detail': 'Visualizar detalhes da oferta',
    'Fulfillment': 'Atendimento',
    'My Store': 'Minha Loja',
    'Allocate all to vendor': 'Alocar tudo para o fornecedor',
    'Allocate': 'Alocar',
    'button of the page,you can also allocate items from the same SPU to the same vendor': 'Botão da página, você também pode alocar itens do mesmo SPU para o mesmo fornecedor',
    'Items': 'Itens',
    'Details': 'Detalhes',
    'Expected price (US$)': 'Preço esperado (US$)',
    'Vendors respond': 'Fornecedores respondem',
    'Purchase Order Reconfirm': 'Reconfirmar Pedido de Compra',
    'Vendor name:': 'Nome do fornecedor:',
    'AilExpress shop': 'Loja AliExpress:',
    'Invite Vendor': 'Convidar Fornecedor',
    'Invite Link:': 'Link de Convite:',
    'Bonus Detail': 'Detalhes do Bônus',
    'Amount($)': 'Valor (US$)',
    'Product name': 'Nome do Produto',
    'Enter order number': 'Digite o número do pedido',
    'Product information': 'Informações do Produto',
    'Edit Product': 'Editar Produto',
    'Shopify vendor': 'Fornecedor Shopify',
    'What is your Email?': 'Qual é o seu e-mail?',
    'Cancel purchase order': 'Cancelar pedido de compra',
    'Use this button to update if missing orders.The process may take a while to finish.': 'Use este botão para atualizar pedidos faltantes. O processo pode levar algum tempo para concluir.',
    'Offered Orders': 'Pedidos Oferecidos',
    'Offered Products': 'Produtos Oferecidos',
    'Offer price': 'Preço da Oferta',
    'Hold down the slider and drag to the right': 'Segure o controle deslizante e arraste para a direita',
    'In order to keep you informed of the update of the order, we suggest you verify the email': 'Para mantê-lo informado sobre atualizações do pedido, sugerimos que verifique seu e-mail',
    'orders can be process, what do you want to do now?': 'Os pedidos podem ser processados, o que deseja fazer agora?',
    'Need new quotation for my orders': 'Preciso de uma nova cotação para meus pedidos',
    'Over 30000+ vendors waiting for offer you price': 'Mais de 30.000 fornecedores esperando para oferecer um preço a você',
    'Allocate my exist vendors': 'Alocar aos meus fornecedores existentes',
    'Just check my orders': 'Apenas verificar meus pedidos',
    'If you already have cooperative vendors, you can allocate orders to them': 'Se já possui fornecedores cooperativos, pode alocar pedidos a eles.',
    'How to process your orders?': 'Como processar seus pedidos?',
    'Please select at least one order and quote for your order': 'Por favor, selecione pelo menos um pedido e solicite uma cotação para ele',
    'Confirm this Offer': 'Confirmar esta Oferta',
    'All Products': 'Todos os Produtos',
    'Yes, I want to CANCEL this offer': 'Sim, quero CANCELAR esta oferta',
    'Cancel the success': 'Cancelamento realizado com sucesso',
    'Volume(cm)': 'Volume (cm)',
    'Total volume(cm)': 'Volume total (cm)',
    'Kaieteur Bank Payment': 'Pagamento via Kaieteur Bank',
    'You have successfully completed your order.': 'Você concluiu seu pedido com sucesso.',
    'Sorry, we can': 'Desculpe, não podemos',
    'Pay again': 'Pagar novamente',
    'Receiving': 'Recebimento',
    'days': 'dias',

    'Your Orders are exporting</strong><br/>Your export will be delivered by email to': 'Seus pedidos estão exportando</strong><br/>Sua exportação será entregue por e-mail para',
    'Depending on how many Orders you’re exporting, this could take some time.': 'Dependendo de quantos pedidos você está exportando, isso pode levar algum tempo.',
    '<strong>Your Orders are exporting</strong><br/>Your export will be delivered by email to: . <br/>Depending on how many Orders you’re exporting, this could take some time.': '<strong>Seus pedidos estão exportando</strong><br/>Sua exportação será entregue por e-mail para: . <br/>Dependendo de quantos pedidos você está exportando, isso pode levar a',

    'Shipping days': 'Dias de envio',
    'Discount': 'Desconto',
    'Exchange': 'Câmbio',
    'The supplier has opened a credit limit for you. When your account balance is insufficient, you can deduct the credit limit': 'O fornecedor abriu um limite de crédito para você. Quando o saldo da sua conta for insuficiente, você pode usar o limite de crédito.',
    'Quantity of order': 'Quantidade do pedido',
    'Total amount of goods': 'Valor total dos produtos',
    'Tax Amount': 'Valor do imposto',
    'Discounted price of goods': 'Preço com desconto dos produtos',
    'Total freight amount': 'Valor total do frete',
    'Shop discount': 'Desconto da loja',
    'This document is free of freight': 'Este documento está isento de frete',
    'credit&debit card': 'Cartão de crédito e débito',
    'qr payment': 'Pagamento por QR Code',
    'Your No.': 'Seu Nº',
    'Create Quote': 'Criar Cotação',
    'Quit Quotation': 'Cancelar Cotação',
    'Bulk payment': 'Pagamento em massa',
    'Cancel payment': 'Cancelar Pagamento',
    'Manually synced': 'Sincronizado manualmente',
    'Shop price': 'Preço da loja',
    'customer Name': 'Nome do Cliente',
    'Not reviewed': 'Não revisado',
    'pass': 'Aprovar',
    'warehouse': 'Armazém',
    'address': 'Endereço',
    'Product': 'Produto',
    'Payment time': 'Data do Pagamento',
    'Inventory lock remaining time': 'Tempo restante do bloqueio de estoque',
    'Order quantity': 'Quantidade do Pedido',
    'Shipping address': 'Endereço de Envio',
    'Request Fullfill': 'Solicitar Atendimento Completo',
    'Select Payment Method': 'Selecionar Método de Pagamento',
    'All transactions are secure and encrypted': 'Todas as transações são seguras e criptografadas',
    'Quotation to be submitted': 'Cotação a ser submetida',
    'Quoted': 'Cotado',
    'danger': 'Perigo',
    'Delivery Address': 'Endereço de Entrega',
    'warning': 'Aviso',
    'OK': 'OK',
    'cancel': 'Cancelar',
    'Binding succeeded!': 'Vinculação realizada com sucesso!',
    'There is no warehouse, please go to add!': 'Não há armazém, por favor, adicione um!',
    'file cannot over 2MB': 'O arquivo não pode exceder 2MB',
    'Please select an order firs': 'Por favor, selecione um pedido primeiro',
    'Successfully': 'Com sucesso',
    'Are you sure to initiate a quotation for the selected order?': 'Tem certeza de iniciar uma cotação para o pedido selecionado?',
    'Are you sure to abandon the quotation for the selected order? After giving up, it cannot be restored, please operate with caution': 'Tem certeza de abandonar a cotação para o pedido selecionado? Depois de desistir, não poderá ser restaurada, por favor, proceda com cautela.',
    'Payment has not arrived': 'Pagamento não recebido',
    'Awaiting Fulfillment': 'Aguardando Atendimento',
    'SortBy': 'Ordenar por',
    'Date Ranges': 'Intervalos de datas',
    'Fulfillment Status': 'Status de Atendimento',
    'Export to': 'Exportar para',
    'Selected': 'Selecionado',
    'Some orders had been fulfilled or refunded': 'Alguns pedidos já foram atendidos ou reembolsados',
    'Export orders': 'Exportar Pedidos',
    'Abnormal reason': 'Motivo Anormal',
    'Date type': 'Tipo de Data',
    'Download tracking information': 'Baixar Informações de Rastreamento',
    'Notice': 'Aviso',
    'You have': 'Você tem',
    'purchase order(s) need your reconfirm,': 'pedido(s) de compra precisam da sua reconfirmação,',
    'click here': 'clique aqui',
    'to view details.': 'para ver detalhes.',
    'Vendor shipped': 'Fornecedor enviou',
    'unfulfilled / partially fulfilled)': 'não cumprido / parcialmente cumprido)',
    'But': 'Mas',
    'You may download these tracking information and fulfilled these orders in your Shopify store manualy.': 'Você pode baixar essas informações de rastreamento e atender a esses pedidos manualmente em sua loja Shopify.',
    'Download ALL tracking information': 'Baixar TODAS as informações de rastreamento',
    'sync failed': 'Sincronização falhou',
    'Reconfirm': 'Reconfirmar',
    'View Details': 'Ver Detalhes',
    'Change another vendor': 'Mudar de fornecedor',
    'Cancel this order': 'Cancelar este pedido',
    'NOT Joined': 'NÃO ADERIDO',
    'Amount Due': 'Valor devido',
    'Not set up': 'Não configurado',
    'Send to vendor': 'Enviar ao fornecedor',
    'Title': 'Título',
    'Order Title': 'Título do Pedido',
    'Desc': 'Descrição',
    'Feedback': 'Feedback',
    'Includes': 'Inclui',
    'Shopify orders': 'Pedidos da Shopify',
    'products': 'Produtos',
    'invalid': 'Inválido',
    'Income': 'Rendimento',
    'Income will only visible to you': 'A renda será visível apenas para você',
    'Allow vendor to process these orders': 'Permitir que o fornecedor processe estes pedidos',
    'Do you want to cancel this order?': 'Deseja cancelar este pedido?',
    'Don': 'Don',
    'Shopify orders in the': 'Pedidos da Shopify no',
    'Change purchase order to another vendor': 'Alterar pedido de compra para outro fornecedor',
    'Current vendor:': 'Fornecedor atual:',
    'Change to new vendor': 'Mudar para um novo fornecedor',
    'All my vendors': 'Todos os meus fornecedores',
    'Also allocate the products in this purchase order to the new supplier': 'Também alocar os produtos deste pedido de compra para o novo fornecedor',
    'Order created': 'Pedido criado',
    'Order paid': 'Pedido pago',
    'Login to your': 'Faça login no seu',
    'Order confirmed': 'Pedido confirmado',
    'Your request is been submitted, please wait one moment.': 'Sua solicitação foi enviada, por favor, aguarde um momento.',
    'The update process has started, it will take a while to finish.': 'O processo de atualização foi iniciado, levará algum tempo para ser concluído.',
    'purchase orders': 'pedidos de compra',
    'NEED to finish payment': 'NECESSÁRIO concluir o pagamento',
    'Waiting for allocated': 'Aguardando alocação',
    'Waiting for sourcing': 'Aguardando abastecimento',
    'Orders processing': 'Processamento de pedidos',
    'Abnormal order': 'Pedido anormal',
    'Quote for Orders': 'Cotação para pedidos',
    'Quote for Product': 'Cotação para produto',
    'Recent Quotations': 'Cotações recentes',
    'orders matching your search': 'pedidos que correspondem à sua pesquisa',
    'Email': 'E-mail',
    'Get captcha': 'Obter captcha',
    'Please fill in the correct Email address': 'Por favor, insira um endereço de e-mail válido',
    'User Email modified successfully': 'E-mail do usuário modificado com sucesso',
    'Show cancelled orders': 'Mostrar pedidos cancelados',
    'Show all valid orders': 'Mostrar todos os pedidos válidos',
    'unfulfilled / partially fulfilled': 'não cumprido / parcialmente cumprido',
    'Download NOT FULFILLED tracking information': 'Baixar informações de rastreamento NÃO CUMPRIDAS',
    'Invite vendor to process': 'Convidar fornecedor para processar',
    'More Action': 'Mais ações',
    'Selected saved! Now you can Check the purchase orders': 'Selecionado salvo! Agora você pode verificar os pedidos de compra',
    'After your confirmation for the payment, we will notify the vendor by email. You can also proactively notify the vendor to speed the delivery up': 'Após a confirmação do pagamento, notificaremos o fornecedor por e-mail. Você também pode notificá-lo proativamente para agilizar a entrega',
    'Have you finished the payment?': 'Você concluiu o pagamento?',
    'Confirm the payment': 'Confirmar pagamento',
    'The reason must be entered': 'O motivo deve ser informado',
    'In this tab, we will only filter your': 'Nesta aba, vamos filtrar apenas os seus',
    'Orders which you can allocate to your vendor to process.': 'Pedidos que você pode alocar para o fornecedor processar.',
    'Shop name': 'Nome da loja',
    'Partially fulfilled': 'Parcialmente cumprido',
    'purchased items are delivered': 'itens comprados foram entregues',
    'Select a vendor': 'Selecionar um fornecedor',
    'Product has been allocated': 'O produto foi alocado',
    'Vendor name / contact / shop name etc.': 'Nome do fornecedor / contato / nome da loja etc.',
    'Here are some other products seems can been allocated to the vendor too, do you want to do it now?': 'Aqui estão outros produtos que também podem ser alocados ao fornecedor, deseja fazer isso agora?',
    'Selected products': 'Produtos selecionados',
    'Allocate NOW': 'Alocar AGORA',
    'No thanks': 'Não, obrigado',
    'Please select at least one order': 'Por favor, selecione pelo menos um pedido',
    'Create quotation request?': 'Criar solicitação de cotação?',
    'Order ID From:': 'ID do pedido de:',
    'Order ID To:': 'ID do pedido até:',
    'You': 'Você',
    'orders to': 'pedidos para',
    'responded': 'responderam',
    'You can choose the payment method you can accept, we will submit your': 'Você pode escolher o método de pagamento que pode aceitar, nós enviaremos seus',
    'orders and options to your vendors': 'pedidos e opções aos seus fornecedores',
    'Warm tips': 'Dicas importantes',
    'orders NOW': 'pedidos agora',
    'Place': 'Local',
    'You have set the following products to be allocated to the vendors': 'Você definiu os seguintes produtos para serem alocados aos fornecedores',
    'only once. Therefore, the following items will need to be': 'apenas uma vez. Portanto, os seguintes itens precisarão ser',
    're-allocated after the orders are generated again.': 're-alocados após os pedidos serem gerados novamente.',
    'By AliExpress VIP link': 'Por link VIP do AliExpress',
    'Please enter the single number range': 'Por favor, insira o intervalo de número único',
    'The starting order number must be less than the ending order number': 'O número inicial do pedido deve ser menor que o número final',
    'Product title': 'Título do produto',
    'Expected price': 'Preço esperado',
    'Current price': 'Preço atual',
    'Reply price': 'Preço de resposta',
    'Reply link': 'Link de resposta',
    'published': 'Publicado',
    'Yesterday': 'Ontem',
    'My support': 'Meu suporte',
    'You have successfully hosted the': 'Você hospedou com sucesso',
    'Failure reason': 'Motivo da falha',
    'Store products': 'Produtos da loja',
    'SPU': 'SPU',
    'Store': 'Loja',
    'Query': 'Consulta',
    'Please enter': 'Por favor, insira',
    'State': 'Estado',
    'Description:': 'Descrição:',
    'Add Vendor': 'Adicionar Fornecedor',
    'Edit Vendor': 'Editar Fornecedor',
    'Destination Country:': 'País de destino:',
    'My sourcing products': 'Meus produtos de abastecimento',
    'Vendor information': 'Informações do fornecedor',
    'Vendor Contact': 'Contato do Fornecedor',
    'Bonus Balance': 'Saldo de Bônus',
    'Sales statistics': 'Estatísticas de Vendas',
    'Please enter description': 'Por favor, insira a descrição',
    'Please enter IOSS ID': 'Por favor, insira o IOSS ID',
    'Please select destination country': 'Selecione o país de destino',
    'Please select at least 1 destination country.': 'Selecione pelo menos um país de destino.',
    'Please enter an IOSS ID with 12 alphanumeric characters.': 'Por favor, insira um IOSS ID com 12 caracteres alfanuméricos.',
    'After saving, your IOSS will be updated to the corresponding order. Are you sure to save?': 'Após salvar, seu IOSS será atualizado para o pedido correspondente. Tem certeza que deseja salvar?',

    'Settings': 'Configurações',
    'According to the new European VAT e-commerce rules, declaration without lOSS will result in a delay in customs clearance and the recipient will be required to pay VAT, as the parcel will be detained when contact of the recipient is incorrect.': 'De acordo com as novas regras europeias de IVA para comércio eletrônico, a declaração sem IOSS resultará em atraso na liberação aduaneira e o destinatário será obrigado a pagar IVA, pois o pacote será retido se o contato do destinatário estiver incorreto.',
    'IOSS Option': 'Opção IOSS',
    'No IOSS': 'Sem IOSS',
    'The amount of the orders (shipping cost included) will be declared and recipients will be required by the customs to pay VAT when parcels arrive in the destination countries of EU': 'O valor dos pedidos (incluindo frete) será declarado e os destinatários deverão pagar IVA quando as encomendas chegarem aos países de destino da UE',
    'Please enter correct and valid IOSS IDs, which should be linked to corresponding destination countries. IOSS ID will not be applied if the destination country is not linked to a correct IOSS ID': 'Insira IOSS IDs corretos e válidos, vinculados aos países de destino correspondentes. O IOSS ID não será aplicado se o país de destino não estiver vinculado a um ID correto',
    'My IOSS Settings': 'Minhas Configurações IOSS',
    'Declare with my own IOSS': 'Declarar com meu próprio IOSS',
    'Linked Countries': 'Países Vinculados',
    'Add IOSSou sure to delete the IO': 'Adicionar IOSS ou confirmar exclusão do IOSS',
    'Unlinked Countries:': 'Países Não Vinculados:',
    'Are you sure to delete the IOSS?': 'Tem certeza que deseja excluir o IOSS?',

    'More categories': 'Mais Categorias',
    'Excluding VAT amount': 'Excluindo Valor do IVA',
    'Vat Amount': 'Valor do IVA',
    'Amount including VAT': 'Valor Incluindo IVA',
    'AliExpress store information': 'Informações da Loja Aliexpress',
    'Detailed seller ratings': 'Avaliações Detalhadas do Vendedor',
    'Recent Products': 'Produtos Recentes',
    'Store No.': 'Loja Nº',
    'This store has been open since': 'Esta loja está aberta desde',
    'Positive feedback': 'Feedback Positivo',
    'Business License': 'Licença Comercial',
    'Item as Described': 'Item Conforme Descrito',
    'Above': 'Acima',
    'Below': 'Abaixo',
    'Average': 'Média',
    'Shipping Speed': 'Velocidade de Envio',
    'Detailed Seller Ratings information is unavailable when there': 'Informações detalhadas das avaliações do vendedor não estão disponíveis quando',

    'My Vendors': 'Meus Fornecedores',
    'By Vendor Name': 'Por Nome do Fornecedor',
    'By AliExpress Url': 'Por URL do AliExpress',
    'Please enter your vendor': 'Por favor, insira seu fornecedor',
    'Vendor': 'Fornecedor',
    'How to get the vendor': 'Como obter o fornecedor',
    'Transaction Flow Line': 'Fluxo de Transação',
    'Recharge Time': 'Tempo de Recarga',
    'customer successfully edited': 'Cliente editado com sucesso',
    'customer successfully added': 'Cliente adicionado com sucesso',
    'Address Management': 'Gerenciamento de Endereços',

    'Default Shipping Address': 'Endereço de entrega padrão',
    'First name': 'Nome',
    'Last name': 'Sobrenome',
    'Phone': 'Telefone',
    'Receipt': 'Recibo',
    'Address': 'Endereço',
    'City': 'Cidade',
    'Postcode': 'CEP',
    'Province': 'Estado',
    'Country': 'País',
    'No address': 'Sem endereço',
    'Do you want to delete?': 'Deseja excluir?',
    'delete successfully': 'Excluído com sucesso',
    'My Allocated Products': 'Meus produtos alocados',
    'My Allocated Product': 'Meu produto alocado',
    'Batch Re-allocate': 'Realocar em lote',
    'Batch Un-allocate': 'Desalocar em lote',
    'All my stores': 'Todas as minhas lojas',
    'UN-allocate Success': 'Desalocação realizada com sucesso',
    'LOGIN': 'LOGIN',
    'Powered by Comexbcn': 'Desenvolvido por Comexbcn',
    'Privacy policy': 'Política de Privacidade',
    'Terms of use': 'Termos de Uso',
    'Refund Policy': 'Política de Reembolso',
    'FAQs': 'Perguntas Frequentes',
    'This file format is not supported': 'Formato de arquivo não suportado',
    'The file size can not over 2MB': 'O tamanho do arquivo não pode exceder 2MB',
    'Please input your message': 'Por favor, insira sua mensagem',
    'BCNDropshipping - Easy Dropshipping': 'BCNDropshipping - Dropshipping Fácil',
    'The question must not be empty': 'A pergunta não deve estar vazia',
    'Shopify store name': 'Nome da Loja Shopify',
    'Current Unit Cost': 'Custo Unitário Atual',
    'Welcome to': 'Bem-vindo ao',
    'Please sign in or register an account to start the chat.': 'Por favor, entre ou registre uma conta para iniciar o chat.',
    'All Items': 'Todos os Itens',
    'back': 'Voltar',
    'Check All': 'Selecionar Todos',
    'Digital Themrmometer Hygrometer Living Ro Digital Themrmometer Hygrometer Living Ro': 'Alta Qualidade Digital Thermometer Hygrometer Living Ro',
    'Bulk Purchase': 'Compra em Massa',
    'Do you want to delete selected items?': 'Deseja excluir os itens selecionados?',
    'Product list page': 'Página de Lista de Produtos',
    'Bottom': 'Rodapé',
    'Top': 'Topo',
    'Hi, welcome to': 'Olá, bem-vindo ao',
    'Welcome to ()! Please sign in or register an account to': 'Bem-vindo ao ()! Por favor, entre ou registre uma conta para',
    'start the chat.': 'iniciar o chat.',
    'Register': 'Registrar',
    'Recall': 'Recordar',
    'Trade name': 'Nome Comercial',
    'Purchase price:': 'Preço de Compra:',
    'Start date': 'Data de Início',
    'End date': 'Data Final',
    'Expected Price': 'Preço Esperado',
    'Product link': 'Link do Produto',
    'Product note': 'Observação',
    'Dispatched Items': 'Itens Despachados',
    'Valid Invoices': 'Faturas Válidas',
    'Valid Amount Due': 'Valor Válido a Pagar',
    'Order’s items that you can dispatch to vendors': 'Itens do pedido que você pode enviar para fornecedores',
    'No Picture': 'Sem Imagem',
    'You can modify your order dispatch rules at any time in the menu': 'Você pode modificar as regras de envio do seu pedido a qualquer momento no menu',
    'Dispatch to': 'Enviar para',
    'vendor(s)': 'Fornecedor(es)',
    'Please select the vendor': 'Por favor, selecione o fornecedor',
    'Please select the circle period': 'Selecione o período do ciclo',
    'Are you sure you want to cancel it?': 'Tem certeza de que deseja cancelar?',
    'Disputed order': 'Pedido em disputa',
    'Awaiting Response': 'Aguardando Resposta',
    'Tracking Number': 'Número de Rastreamento',
    'Dispute Type': 'Tipo de Disputa',
    'Expected Solution': 'Solução Esperada',
    'Create Time': 'Data de Criação',
    'Last week': 'Última Semana',
    'Last month': 'Último Mês',
    'Type': 'Tipo',
    'Select country': 'Selecione o País',
    'Last three months': 'Últimos Três Meses',
    'The page you are looking for can': 'A página que você procura pode',
    'BACK TO HOMEPAGE': 'VOLTAR À PÁGINA INICIAL',
    'Transform Your eCommerce business Into a Powerhouse': 'Transforme seu negócio de e-commerce em uma potência',
    'Importify helps people like you to automate their dropshipping business.': 'A Importify ajuda pessoas como você a automatizar seus negócios de dropshipping.',
    'Product Research': 'Pesquisa de Produto',
    'Are you tired of searching the millions o products on AliExpress for potential winners?': 'Está cansado de procurar entre milhões de produtos no AliExpress por possíveis vencedores?',
    'One-click import products': 'Importar produtos com um clique',
    'Profit': 'Lucro',
    'Import products from 30+ top dropshipping vendors, Aliexpress, Alibaba, Amazon, Etsy, Dhgate, Lazada, Shopee, Banggood, Taobao, 1688, Gearbest, Walmart, and many more.': 'Importe produtos de mais de 30 fornecedores de dropshipping, incluindo Aliexpress, Alibaba, Amazon, Etsy, Dhgate, Lazada, Shopee, Banggood, Taobao, 1688, Gearbest, Walmart e muitos outros.',
    'Pricing Rules': 'Regras de Preço',
    'Tired of calculating your target profit margin? Create pricing rules before importing, quickly adjust prices for sales.': 'Cansado de calcular sua margem de lucro alvo? Crie regras de preço antes de importar e ajuste rapidamente os preços para promoções.',
    'Product Customization': 'Personalização de Produto',
    'Use our chrome extension to modify the title, description, images, variants, pricing of the imported products.': 'Use nossa extensão Chrome para modificar título, descrição, imagens, variantes e preços dos produtos importados.',
    'Automate your orders': 'Automatize seus Pedidos',
    'The Importify Chrome Extension allows you to fulfill your orders quickly by placing the customer address automatically on the checkout page.': 'A extensão Chrome da Importify permite atender seus pedidos rapidamente, preenchendo automaticamente o endereço do cliente na página de checkout.',
    'Easy vendor Change': 'Troca Fácil de Fornecedor',
    'Replace your product vendor with a new vendor and connect them to your store with a click.': 'Substitua o fornecedor do produto por um novo e conecte-o à sua loja com um clique.',
    'Auto Dispatch Collections': 'Envio Automático de Coleções',
    'Auto-dispatch products to your Store collections supported on Shopify, WooCommerce, and Jumpseller.': 'Envie automaticamente produtos para suas coleções da loja, compatível com Shopify, WooCommerce e Jumpseller.',
    'Split Variants': 'Dividir Variantes',
    'Variants': 'Variantes',
    'Importify gives you the ability to Split variants into Separate products.': 'O Importify permite dividir variantes em produtos separados.',
    'Connect Existing Products': 'Conectar Produtos Existentes',
    'If you have products that are already on a Shopify, Woocommerce or Jumpseller store, you can connect and manage them in Importify.': 'Se você tiver produtos já em uma loja Shopify, WooCommerce ou Jumpseller, pode conectá-los e gerenciá-los no Importify.',
    'Add to Import List': 'Adicionar à Lista de Importação',
    'View More': 'Ver Mais',
    'MORE': 'MAIS',
    'Categories': 'Categorias',
    'Tag': 'Etiqueta',
    'Returnable with in': 'Retornável dentro de',
    'Find Products': 'Encontrar Produtos',
    'My Import List': 'Minha Lista de Importação',
    'Please select a shipping address': 'Por favor, selecione um endereço de envio',
    'Please select a shipping method': 'Selecione um método de envio',
    'How to find products? Find products in': 'Como encontrar produtos? Encontre produtos em',
    'Products Market! Dropshipping from Worldwide to Worldwide! :': 'Mercado de Produtos! Dropshipping de todo o mundo para todo o mundo!',
    'Email must be filled in': 'O e-mail deve ser preenchido',
    'CAPTCHA must be filled in': 'O CAPTCHA deve ser preenchido',
    'New password must be filled in': 'A nova senha deve ser preenchida',
    'The new password and confirm password must be the same': 'A nova senha e a confirmação devem ser iguais',
    'The password must contain letters, and numbers, Minimum 8 characters': 'A senha deve conter letras e números, com no mínimo 8 caracteres',
    'Password reset successful': 'Redefinição de senha bem-sucedida',
    'Password must be filled in': 'A senha deve ser preenchida',
    'IN ALL CATEGORIES': 'EM TODAS AS CATEGORIAS',
    'Place Order': 'Fazer Pedido',
    'Choose orders': 'Escolher pedidos',
    'Manage-Addresses': 'Gerenciar Endereços',
    'Default Address': 'Endereço Padrão',
    'There is no Shipping method to reach the current address': 'Não há método de envio para chegar ao endereço atual',
    'Please select address': 'Por favor, selecione o endereço',
    'Product Price': 'Preço do Produto',
    'Choose the products from your Shopify orders to allocated to your vendor': 'Escolha os produtos dos seus pedidos da Shopify para alocar ao seu fornecedor',
    'Click the Allocate to vendo button on the bottom of the page.': 'Clique no botão "Alocar ao Fornecedor" na parte inferior da página.',
    'Tips: You can filter your orders here.': 'Dica: você pode filtrar seus pedidos aqui.',
    'Choose or create a new vendor.': 'Escolha ou crie um novo fornecedor.',
    'Click the Allocate button of the page,you can also allocate items from the same SPU to the same vendor': 'Clique no botão "Alocar" da página; você também pode alocar itens do mesmo SPU para o mesmo fornecedor.',
    'Un-allocate selected products': 'Desalocar produtos selecionados',
    'Total vendors': 'Total de Fornecedores',
    'Total orders': 'Total de Pedidos',
    'Click the': 'Clique no',
    'Allocate to vendor': 'Alocar ao Fornecedor',
    'button on the bottom of the page.': 'botão na parte inferior da página.',
    'Total Product': 'Total de Produtos',
    'Previous': 'Anterior',
    'Next': 'Próximo',
    'and Automate': 'e automatizar',
    'your entire dropshipping process': 'todo o seu processo de dropshipping',
    'Place 1 purchase orders': 'Colocar 1 pedido de compra',
    'With just one click, you can easily allocate your stores orders to your vendors and the entire shipping process will be automatically completed.': 'Com apenas um clique, você pode facilmente alocar os pedidos da sua loja para seus fornecedores, e todo o processo de envio será concluído automaticamente.',
    'Create a purchase orders to your vendor.': 'Crie pedidos de compra para seu fornecedor.',
    'Choose the Shopify orders you want to sourcing,and click the Make a purchase order button of the page.': 'Escolha os pedidos da Shopify que deseja abastecer e clique no botão "Fazer Pedido de Compra" da página.',
    'After confirming the operation,The purchase orders will be created successfully.': 'Após confirmar a operação, os pedidos de compra serão criados com sucesso.',
    'Share purchase orders URL to your vendor and wait your vendor finish the invoice for you.': 'Compartilhe o URL dos pedidos de compra com seu fornecedor e aguarde até que ele finalize a fatura para você.',
    'Click the <b>Invite vendor to process</b> button on the bottom of the page.': 'Clique no botão <b>Convidar fornecedor para processar</b> na parte inferior da página.',
    'You can send the purchase orders by Skype, WeChat or share by URL link.': 'Você pode enviar os pedidos de compra via Skype, WeChat ou compartilhar por link URL.',
    'I have finished the payment': 'Eu finalizei o pagamento',
    '<b>Invite vendor to process</b>': '<b>Convidar fornecedor para processar</b>',
    'Items total': 'Total de Itens',
    'You can create a new vendor or select an exist one.': 'Você pode criar um novo fornecedor ou selecionar um existente.',
    'Click the button': 'Clique no botão',
    'on the PO page when you finished your payment.': 'na página do pedido de compra quando você finalizar o pagamento.',
    'Through AliExpress proxy payment link': 'Através do link de pagamento proxy do AliExpress',
    'Invite vendor to proess purchase order': 'Convidar fornecedor para processar o pedido de compra',
    'After you receive the vendor': 'Após receber o fornecedor',
    'Click the button <b>I have finished the payment</b> on the PO page when you finished your payment.': 'Clique no botão <b>Eu finalizei o pagamento</b> na página do pedido de compra quando você terminar o pagamento.',
    'After vendor shipped, Shopify order will be fulfilled automatically.': 'Após o envio pelo fornecedor, o pedido da Shopify será atendido automaticamente.',
    'After your vendor shipped your order, the shipping information will be sync to your Shopify store automatically.': 'Após o envio do fornecedor, as informações de envio serão sincronizadas automaticamente com sua loja Shopify.',
    'Billing History': 'Histórico de Faturamento',
    'Billing': 'Faturamento',
    'Search by bill number or order number': 'Pesquisar por número da fatura ou pedido',
    'Order Code': 'Código do Pedido',
    'Payment Method': 'Método de Pagamento',
    'Request for Quote': 'Solicitar Cotação',
    'Wait for import': 'Aguardar importação',
    'Allocate Orders for vendors': 'Alocar pedidos para fornecedores',
    'and Automate <br />your entire dropshipping process': 'e automatize <br />todo o seu processo de dropshipping',
    'With just one click, you can easily allocate your stores orders to': 'Com apenas um clique, você pode facilmente alocar os pedidos da sua loja para',
    'your vendors and the entire shipping process will be automatically': 'seus fornecedores, e todo o processo de envio será automaticamente',
    'completed.': 'concluído.',
    'How does it work?': 'Como funciona?',
    'Connect to your store': 'Conecte-se à sua loja',
    'Allocate orders to your vendors': 'Alocar pedidos para seus fornecedores',
    'The vendor arranges the delivery': 'O fornecedor organiza a entrega',
    'Automatic fulfillment of your orders by': 'Atendimento automático dos seus pedidos por',
    'See what our': 'Veja o que nossos',
    'customers talk about us.': 'clientes dizem sobre nós.',
    'More than 10,000+ customers around the world rely on us!': 'Mais de 10.000 clientes em todo o mundo confiam em nós!',
    'about': 'sobre',
    'Inquiry': 'Consulta',
    'Trial calculation of shipping costs': 'Cálculo experimental dos custos de envio',
    'Return able with in': 'Retornável dentro de',
    'You can import and manage your AliExpress / Amazon products here': 'Você pode importar e gerenciar seus produtos do AliExpress / Amazon aqui',
    'before publishing them to your Shopify store. You can publish a': 'antes de publicá-los na sua loja Shopify. Você pode',
    'product to different stores and add multiple tags to each products.': 'publicar produtos em diferentes lojas e adicionar várias tags a cada produto.',
    'The Shopify orders still unfulfilled / partially fulfilled even if the vendor had upload tracking information.': 'Os pedidos da Shopify ainda estão não atendidos / parcialmente atendidos, mesmo que o fornecedor tenha enviado informações de rastreamento.',
    'You may download these tracking information and fulfilled these order in your Shopify store manually.': 'Você pode baixar essas informações de rastreamento e atender a esses pedidos manualmente em sua loja Shopify.',
    'Click': 'Clique',
    'New Type': 'Novo Tipo',
    'need your reconfirm,': 'precisa da sua reconfirmação,',
    'here': 'aqui',
    'Operate': 'Operar',
    'to leam more': 'para saber mais',
    'Current Import Task': 'Tarefa de Importação Atual',
    'Import Task': 'Tarefa de Importação',
    'Filter by stores': 'Filtrar por lojas',
    'Upload Progress:': 'Progresso de Upload:',
    'Filter by tags': 'Filtrar por tags',
    'Select an image': 'Selecionar uma imagem',
    'Also publish to Online Store': 'Também publicar na loja online',
    'Loading time to long, check detailed progress': 'Tempo de carregamento muito longo, verifique o progresso detalhado',
    'Delete Completed': 'Excluir Concluídos',
    'Please select the stores': 'Por favor, selecione as lojas',
    'Please enter the tag': 'Por favor, insira a tag',
    'Do you want to delete the product(s)?': 'Deseja excluir o(s) produto(s)?',
    'Please enter your store name to connect the dashboard page:': 'Por favor, insira o nome da sua loja para conectar à página do painel:',
    'Coming soon': 'Em breve',
    'Track Number': 'Número de Rastreamento',
    'Shopify order number': 'Número do Pedido Shopify',
    'Shopify store Name': 'Nome da Loja Shopify',
    'Keywords': 'Palavras-chave',
    'results': 'Resultados',
    'Assign orders to vender': 'Atribuir pedidos ao fornecedor',
    'Step One: Select not shipped orders': 'Passo 1: Selecionar pedidos não enviados',
    'Step Two: Confirm and send these orders to the vendor': 'Passo 2: Confirmar e enviar esses pedidos ao fornecedor',
    'Choose one vendor': 'Escolher um fornecedor',
    'Please choose one vendor first': 'Por favor, escolha um fornecedor primeiro',
    'Abort to assign': 'Abortar atribuição',
    'Go to Next': 'Ir para o próximo',
    'Go': 'Ir',
    'Confirm and send these orders to this vendor': 'Confirmar e enviar esses pedidos para este fornecedor',
    'You can check the invoice by scan this QR Code or visit this URL by your web browser': 'Você pode verificar a fatura escaneando este código QR ou visitando este URL pelo navegador',
    'Time Created': 'Data de Criação',
    'Receiver': 'Destinatário',
    'Company': 'Empresa',
    'Save and change the vendor': 'Salvar e alterar o fornecedor',
    'Selected saved': 'Selecionado salvo',
    'Now you can': 'Agora você pode',
    'Send purchase orders to the vendor': 'Enviar pedidos de compra para o fornecedor',
    'Check the list again': 'Verificar a lista novamente',
    'A new order successfully created': 'Novo pedido criado com sucesso',
    'All Unfulfilled Shopify Orders': 'Todos os pedidos não atendidos da Shopify',
    'Quick select of Shopify order items': 'Seleção rápida de itens de pedidos Shopify',
    'Shopify order total': 'Total de pedidos Shopify',
    'Order Date': 'Data do Pedido',
    'Periods of orders:': 'Períodos de pedidos:',
    'shopify orders have been selected and can now be dispatched to your vendor': 'Os pedidos da Shopify foram selecionados e agora podem ser enviados ao seu fornecedor',
    'Dispatch to the vendor': 'Enviar para o fornecedor',
    'Please choose an vendor': 'Por favor, escolha um fornecedor',
    'Please choose an item': 'Por favor, escolha um item',
    'All shopify unshipped orders': 'Todos os pedidos não enviados da Shopify',
    'All undelivered shopify orders': 'Todos os pedidos não entregues da Shopify',
    'shopify orders have been selected and can now be assigned to your suppliers': 'Os pedidos da Shopify foram selecionados e agora podem ser atribuídos aos seus fornecedores',
    'Payment Record': 'Registro de Pagamento',
    'Recharge': 'Recarregar',
    'trade code': 'Código Comercial',
    'Payment Amount': 'Valor do Pagamento',
    'Payment Status': 'Status do Pagamento',
    'Payment Date': 'Data do Pagamento',
    'If it is necessary to process your shopify order or to achieve an automatically update for the shipping information toshopify, you could': 'Se for necessário processar seu pedido Shopify ou obter atualização automática das informações de envio para Shopify, você pode',
    'and let us help you.': 'e deixar-nos ajudá-lo.',
    'My to view details.': 'Para ver detalhes.',
    'The vendor has shipped the product(s), but the shipping information has not been sync to your Shopify store.': 'O fornecedor enviou o(s) produto(s), mas as informações de envio não foram sincronizadas com sua loja Shopify.',
    'Will not ship': 'Não será enviado',
    'Not shipped': 'Não enviado',
    'Logistics fee': 'Taxa de Logística',
    'The webmaster has confirmed the payment': 'O webmaster confirmou o pagamento',
    'The vendor has confirmed the payment': 'O fornecedor confirmou o pagamento',
    'The vendor start delivery the orders': 'O fornecedor iniciou a entrega dos pedidos',
    'Via paypal': 'Via PayPal',
    'Through a bank transfer': 'Através de transferência bancária',
    'According to the vendor’s setting you can go to': 'De acordo com as configurações do fornecedor, você pode acessar',
    'Aliexpress to buy the item in the vendor’s store': 'AliExpress para comprar o item na loja do fornecedor',
    'Go to AliExpress NOW': 'Ir para AliExpress AGORA',
    'Invite vendor to process purchase order': 'Convidar fornecedor para processar pedido de compra',
    'webmaster has confirmed the payment': 'O webmaster confirmou o pagamento',
    'Invite vendor': 'Convidar fornecedor',
    'You can download order': 'Você pode baixar o pedido',
    'Timeline': 'Cronograma',
    'No more comment': 'Sem mais comentários',
    'You have connected a Shopify store before, for your data security, please': 'Você já conectou uma loja Shopify antes. Para a segurança dos seus dados, por favor',
    'log in the Shopify account': 'faça login na conta da Shopify',
    'you connected and view this invoice': 'que você conectou e visualize esta fatura',
    'The current invoice page is for preview purposes only, if you are sending to a customer please use the': 'A página atual da fatura é apenas para visualização. Se for enviar a um cliente, utilize o',
    'Invoice Preview': 'Visualização da Fatura',
    'As shown in Figure 1:': 'Como mostrado na Figura 1:',
    'As shown in Figure 2:': 'Como mostrado na Figura 2:',
    'I knew it': 'Eu sabia',
    'Connect your Shopify store': 'Conecte sua loja Shopify',
    'you can dispatch the Shopify orders to your vendors after the authorization and the shipping information will be automatically synchronized to your Shopify Store.': 'você poderá enviar os pedidos da Shopify aos fornecedores após a autorização, e as informações de envio serão sincronizadas automaticamente com sua loja Shopify.',
    'Enter your existing Shopify URL bellow and click “connect”, you will be redirect to Shopify to connect your account to (the authorization will be also completed).': 'Digite o URL da sua loja Shopify existente abaixo e clique em "conectar". Você será redirecionado à Shopify para conectar sua conta (a autorização também será concluída).',
    'Connect a store and fulfill your Shopify orders, sync logistics information to your Shopify store automatically.': 'Conecte uma loja e atenda seus pedidos da Shopify, sincronizando automaticamente as informações de logística com sua loja Shopify.',
    'Enter your existing Shopify store URL bellow and you': 'Digite o URL da sua loja Shopify existente abaixo e você',
    'Purchase order base information': 'Informações básicas do pedido de compra',
    'Total number of orders': 'Número total de pedidos',
    'Order items': 'Itens do pedido',
    'Total goods': 'Total de produtos',
    'Total purchase amount': 'Valor total da compra',
    'Shipment statistics': 'Estatísticas de envio',
    'Number of items shipped': 'Número de itens enviados',
    'Amount of goods shipped': 'Quantidade de produtos enviados',
    'Number of items not shipped': 'Número de itens não enviados',
    'Amount of unshipped goods': 'Quantidade de produtos não enviados',
    'Shipment rate': 'Taxa de envio',
    'Amount of non-delivery items': 'Quantidade de itens não entregues',
    'Set the vendor’s SKU': 'Definir SKU do fornecedor',
    'Set the supply price': 'Definir preço de fornecimento',
    'Set up payment methods': 'Configurar métodos de pagamento',
    'Payment Methods': 'Métodos de Pagamento',
    'Send the invoice to the customer': 'Enviar a fatura ao cliente',
    'The fields to be exported': 'Campos a serem exportados',
    'the sequence is adjustable by dragging forward and backward': 'A sequência pode ser ajustada arrastando para frente ou para trás',
    'You have not yet selected the fields that can be exported. Please select below.': 'Você ainda não selecionou os campos que podem ser exportados. Por favor, selecione abaixo.',
    'optional fields': 'Campos opcionais',
    'unexported fields': 'Campos não exportados',
    'custom field name': 'Nome de campo personalizado',
    'is displayed as': 'é exibido como',
    'BILL To': 'FATURA PARA',
    'Invoice Number': 'Número da Fatura',
    'Invoice Date': 'Data da Fatura',
    'Amount Due (US$)': 'Valor Devido (US$)',
    'The supplier has shipped, but the logistics information has not been synced to the Shopify shop.': 'O fornecedor enviou os produtos, mas as informações de logística não foram sincronizadas com a loja Shopify.',
    'Reason': 'Motivo',
    'The supplier has shipped and the logistics information has been synced to the Shopify shop.': 'O fornecedor enviou os produtos e as informações de logística foram sincronizadas com a loja Shopify.',
    'Mark as shipped': 'Marcar como enviado',
    'to finish the payment': 'para concluir o pagamento',
    'The vender has confirmed the payment.': 'O fornecedor confirmou o pagamento.',
    'Remove from order': 'Remover do pedido',
    'You are deleting this product from purchase order. You can still find it': 'Você está excluindo este produto do pedido de compra. Ainda poderá encontrá-lo',
    'in your': 'em seu',
    'Total Amount:': 'Valor Total:',
    'Your order has been successfully paid and the order amount is': 'Seu pedido foi pago com sucesso e o valor do pedido é',
    'Close Pay': 'Fechar Pagamento',
    'Remove success': 'Removido com sucesso',
    'Track number must be entered': 'O número de rastreamento deve ser informado',
    'Track company must be entered': 'A empresa de rastreamento deve ser informada',
    'Track Url must be entered': 'O URL de rastreamento deve ser informado',
    'Please enter Shopify store URL': 'Por favor, insira o URL da loja Shopify',
    'Under authorization, please wait…': 'Aguardando autorização, por favor, aguarde...',
    'Have you finished the payment': 'Você concluiu o pagamento?',
    'At least one field must be selected': 'Pelo menos um campo deve ser selecionado',
    'The name of the customized header cannot be empty': 'O nome do cabeçalho personalizado não pode estar vazio',
    'Export the order information': 'Exportar informações do pedido',
    'The size of the uploaded image should not exceed 500kb!': 'O tamanho da imagem enviada não deve exceder 500kb!',
    'Simple, Transparent Pricing': 'Preços Simples e Transparentes',
    'mportify offers three types of plans; Basic plan, Premium plan, and Gold plan.': 'A Importify oferece três tipos de planos: Básico, Premium e Gold.',
    'Each account starts with a day trial, and your billing cycle begins after the free trial period has ended.': 'Cada conta começa com um teste de um dia, e seu ciclo de cobrança inicia após o término do período de teste gratuito.',
    'Importify Plans<': 'Planos Importify<',
    'Basics': 'Básico',
    'Premium': 'Premium',
    'Gold': 'Gold',
    'Offers': 'Ofertas',
    'Amazon & Aliexpress importer': 'Importador Amazon & Aliexpress',
    'Semi-automatic order fulfillment (Supported on Aliexpress, Amazon, Dhgate & Wonify)': 'Atendimento semi-automático de pedidos (Suportado em Aliexpress, Amazon, Dhgate & Wonify)',
    'Product Customisation': 'Personalização do Produto',
    'Description text': 'Texto descritivo',
    'VAT rate(Destination only in Germany)': 'Taxa de IVA (Destino apenas na Alemanha)',
    'Shipping options': 'Opções de envio',
    'Fulfilment costs': 'Custos de execução',
    'Fulfillment Costs': 'Custos de atendimento',
    'Shipping time': 'Prazo de envio',
    'Update Product': 'Atualizar Produto',
    'Shipping Time': 'Prazo de envio',
    'After Sales Service': 'Serviço pós-venda',
    'product description': 'Descrição do produto',
    'Store price': 'Preço da loja',
    'Delivery: Varies for items shipped from an international location': 'Entrega: Pode variar para itens enviados de local internacional',
    'This product has been removed from the shelves': 'Este produto foi retirado das prateleiras',
    'Return': 'Devolução',
    'Enter Store name': 'Digite o nome da loja',
    'Enter vendor name': 'Digite o nome do fornecedor',
    'Open in website': 'Abrir no site',
    'Edit on Dashboard': 'Editar no painel',
    'Purchase List': 'Lista de Compras',
    'Complete your Skype or WhatsApp details to get rewards': 'Complete seus dados do Skype ou WhatsApp para receber recompensas',
    'You have completed the Skype or WhatsApp, you can receive a free gift package.': 'Você completou o Skype ou WhatsApp e pode receber um pacote de presente gratuito.',
    'The captcha was sent successfully': 'O captcha foi enviado com sucesso',
    'Order Details': 'Detalhes do Pedido',
    'Sub Order NO': 'Subpedido Nº',
    'Product Information': 'Informações do Produto',
    'Sub Total': 'Subtotal',
    'Grand Total': 'Total Geral',
    'Tracking Number:': 'Número de Rastreamento:',
    'Total Amount': 'Valor Total',
    'Products Cost': 'Custo dos Produtos',
    'Enter SKU': 'Digite o SKU',
    'Package': 'Pacote',
    'I agree the': 'Concordo com a',
    'Pay NOW': 'Pagar AGORA',
    'All vendors': 'Todos os fornecedores',
    'Dispatch Status': 'Status de Envio',
    'You could select multiple vendors': 'Você pode selecionar vários fornecedores',
    'Shipping Cost Included': 'Custo de Envio Incluído',
    'Do you want to cancel the order?': 'Deseja cancelar o pedido?',
    'Order was successfully cancelled': 'Pedido cancelado com sucesso',
    'Choose your recharge package': 'Escolha seu pacote de recarga',
    'Choose your payment method': 'Escolha seu método de pagamento',
    'Platform Reply': 'Resposta da Plataforma',
    'Picture': 'Imagem',
    'Product Title:': 'Título do Produto:',
    'Price Range:': 'Faixa de Preço:',
    'Base Information': 'Informações Básicas',
    'Product Links:': 'Links do Produto:',
    'Product Description:': 'Descrição do Produto:',
    'Trade Name': 'Nome Comercial',
    'Only matching last': 'Apenas correspondência final',
    'Save Rule': 'Salvar Regra',
    'Please select the Period': 'Por favor, selecione o Período',
    'Please select the vendor visibility': 'Selecione a visibilidade do fornecedor',
    'Automatic dispatch orders setting': 'Configuração de envio automático de pedidos',
    'Show hidden orders': 'Mostrar pedidos ocultos',
    'Choose my all Shopify products': 'Escolher todos os meus produtos Shopify',
    'shopify orders have been selected and can now be dispatched to your vendors': 'Pedidos da Shopify selecionados e prontos para envio aos fornecedores',
    'My all Shopify products': 'Todos os meus produtos Shopify',
    'days unfulfilled orders': 'dias de pedidos não atendidos',
    'Dispatch rule TEST': 'Regra de Envio TESTE',
    'THE BRIDGE CONNECTING SUPPLIERS AND YOU, MAKING DROPSHIPPING BUSINESS MORE CONVENIENT': 'A PONTE ENTRE FORNECEDORES E VOCÊ, TORNANDO O DROPSHIPPING MAIS PRÁTICO',
    'Your supplier only needs to register an account to quickly build the system': 'Seu fornecedor só precisa registrar uma conta para configurar rapidamente o sistema',
    'One-click hosting of stores, fast synchronization of orders': 'Hospedagem de lojas com um clique, sincronização rápida de pedidos',
    'Automatically synchronize logistics information': 'Sincronização automática das informações de logística',
    'Quick Access': 'Acesso Rápido',
    'Do you have an BCN supplier for you': 'Você tem um fornecedor BCN?',
    'Already have a supplier': 'Já possui um fornecedor',
    'I don': 'Eu não',
    'Let your supplier fulfill your order more systematically, copy the link and send it to your supplier, and immediately invite your supplier to settle in,': 'Permita que seu fornecedor cumpra seus pedidos de forma mais organizada, copie o link e envie ao fornecedor, convidando-o imediatamente a se integrar,',
    '2024-2024BCN All Rights Reserved': '2024-2024BCN Todos os direitos reservados',
    'Waiting for the payment result to be returned': 'Aguardando o resultado do pagamento',
    'Please check the purchase products': 'Por favor, verifique os produtos da compra',
    'After the combination payment is enabled, the account balance will be deducted first, and the rest will be paid by other selected methods': 'Com o pagamento combinado habilitado, o saldo da conta será deduzido primeiro e o restante pago pelos métodos selecionados',
    'Please select the goods first!': 'Por favor, selecione os produtos primeiro!',
    'Please choose the logistics channel': 'Por favor, escolha o canal de logística',
    'Please try again later ~': 'Por favor, tente novamente mais tarde ~',
    'User Name': 'Nome de Usuário',
    'Users login': 'Login de Usuários',
    'Password': 'Senha',
    'Auth Status': 'Status de Autorização',
    'All Status': 'Todos os Status',
    'Unauthorized': 'Não autorizado',
    'Delete Task': 'Excluir Tarefa',
    'Sale price': 'Preço de Venda',
    'Select the task': 'Selecione a Tarefa',
    'Create a ticket': 'Criar um Ticket',
    'Request': 'Solicitação',
    'Store name:': 'Nome da Loja:',
    'Alias Name': 'Nome Alternativo',
    'No Message': 'Sem Mensagem',
    'Send': 'Enviar',
    'Please enter a value greater than 0': 'Insira um valor maior que 0',
    'Please enter a value less than the total amount of the order': 'Insira um valor menor que o total do pedido',
    'What is your Shopify store name?': 'Qual é o nome da sua loja Shopify?',
    'Transaction': 'Transação',
    'normal bill': 'Conta normal',
    'Account payee': 'Beneficiário da conta',
    'Payment Code': 'Código de pagamento',
    'Third Party Number': 'Número de Terceiros',
    'The export of time': 'Exportação por data',
    'Trade type': 'Tipo de transação',
    'Rewards QTY left': 'Recompensas restantes',
    'Trade amount': 'Valor da transação',
    'Payment type': 'Tipo de pagamento',
    'Amount paid/Credit payment': 'Valor pago/Pagamento a crédito',
    'Payment order': 'Ordem de pagamento',
    'Refund order': 'Ordem de reembolso',
    'Wallet card': 'Carteira',
    'Manual deduction': 'Dedução manual',
    'Paying': 'Em pagamento',
    'Account paid': 'Conta paga',
    'Vender Name': 'Nome do fornecedor',
    'AliExpress Shop Name': 'Nome da loja AliExpress',
    'Product allocated': 'Produto atribuído',
    'Purchase amount:': 'Valor da compra:',
    'Created at:': 'Criado em:',
    'Sourcing Now': 'Obtenção em andamento',
    'Latest cooperation at:': 'Última cooperação em:',
    'How to add': 'Como adicionar',
    'Email Security Verification': 'Verificação de segurança do e-mail',
    'For security reason.We need to verify your email address.Please click': 'Por motivos de segurança, precisamos verificar seu e-mail. Por favor, clique',
    'Verify': 'Verificar',
    'My Wallet': 'Minha Carteira',
    'My Balance': 'Meu Saldo',
    'brokerage': 'Corretagem',
    'Please enter the withdrawal amount': 'Por favor, insira o valor de retirada',
    'tip': 'Dica',
    'Your Total Rewards': 'Suas recompensas totais',
    'orders QTY': 'Quantidade de pedidos',
    'We Accept': 'Aceitamos',
    'Charging Method': 'Método de carregamento',
    'Pay with Credit Card': 'Pagar com cartão de crédito',
    'Paypal Payment Amount': 'Valor do pagamento via Paypal',
    'The amount of each recharge must be more than 100 dollars.': 'O valor de cada recarga deve ser superior a 100 dólares.',
    'Please verify your email address here,': 'Por favor, verifique seu e-mail aqui,',
    'Withdraw Cash': 'Sacar Dinheiro',
    'I see': 'Entendi',
    'Trade status': 'Status da transação',
    'Enter Verification Code': 'Digite o código de verificação',
    'Verify Email': 'Verificar e-mail',
    'Bill Number': 'Número da fatura',
    'Transfer ID': 'ID da transferência',
    'wallet recharge': 'Recarga de carteira',
    'The minimum payment is $100.': 'O pagamento mínimo é $100.',
    'Powered by': 'Alimentado por',
    'All transactions are secure and encrypted.': 'Todas as transações são seguras e criptografadas.',
    'Account Balance': 'Saldo da conta',
    'Withdrawal amount': 'Valor de retirada',
    'We will charge you 5% fee when withdrawing.': 'Será cobrada uma taxa de 5% ao sacar.',
    'Send Verification Code': 'Enviar código de verificação',
    'The verification code will be sent to your email': 'O código de verificação será enviado para seu e-mail',
    'Please enter your withdrawal amount': 'Por favor, insira o valor de retirada',
    'Please enter your account': 'Por favor, insira sua conta',
    'Please enter your account name': 'Por favor, insira o nome da conta',
    'Please enter the code': 'Por favor, insira o código',
    'Please enter the recharge amount': 'Por favor, insira o valor da recarga',
    'The minimum payment is $100': 'O pagamento mínimo é $100',
    'The Code was sent successfully': 'O código foi enviado com sucesso',
    'Our app is now updating the page you are visiting, we will auto refresh this page in 10 seconds.': 'Nosso aplicativo está atualizando a página que você está visitando; ela será atualizada automaticamente em 10 segundos.',
    'I got it, please refresh it now': 'Entendi, por favor atualize agora',
    'Estimated start time:': 'Hora de início estimada:',
    'Security Verification': 'Verificação de segurança',
    'We noticed you haven': 'Notamos que você não',
    'For security reason.We need to verify your email address.': 'Por motivos de segurança, precisamos verificar seu endereço de e-mail.',
    'Send To:': 'Enviar para:',
    'Please click': 'Por favor, clique',
    'Work order number': 'Número da ordem de serviço',
    'Pending review': 'Revisão pendente',
    'After-sales work order': 'Ordem de serviço pós-venda',
    'Work order type': 'Tipo de ordem de serviço',
    'order number': 'Número do pedido',
    'client': 'Cliente',
    'shop': 'Loja',
    'creation time': 'Hora de criação',
    'question type': 'Tipo de questão',
    'afterSales': 'Pós-venda',
    'after sales': 'Pós-venda',

    '请输入': 'Por favor, entre',
    '工单号': 'Número da ordem de serviço',
    '同意': 'Aceitar',
    '已确认': 'Verificado',
    '售后工单': 'Ordem de serviço pós-venda',
    '工单类型': 'Tipo de ordem de serviço',
    '客户名称': 'Nome do cliente',
    '审批': 'Aprovação',
    '交易类型': 'Tipo de transação',
    '问题类型': 'Tipo de pergunta',
    '问题描述': 'Descrição do problema',
    '退款': 'Reembolso',
    '更换': 'Substituição',
    '修改客户相关信息': 'Modificar informações do cliente',
    '取消订单': 'Cancelar pedido',
    '无跟踪信息': 'Sem informações de rastreamento',
    '跟踪信息长时间未更新': 'As informações de rastreamento não foram atualizadas por muito tempo',
    '物品损坏': 'Danos no item',
    '物品丢失': 'Item faltando',
    '发送错误产品': 'Enviar produto errado',
    '发送错误地址': 'Enviar endereço errado',
    '订单暂停': 'Em espera',
    '选填': 'Opcional',
    '订单信息': 'Informações do pedido',
    '第三方订单编号': 'Número do pedido de terceiros',
    '订单编号': 'Número do pedido',
    '店铺': 'Lojas',
    '创建时间': 'Hora de criação',
    '开泰银行支付': 'Pagamento do Banco Kaieteur',
    '供应商已发货，但物流信息未同步到Shopify店铺。': 'O fornecedor enviou, mas as informações logísticas não foram sincronizadas com a loja Shopify.',
    '供应商已发货，物流信息已同步到Shopify店铺。': 'O fornecedor enviou e as informações logísticas foram sincronizadas com a loja Shopify.',
    '您还没有选择可导出的字段。请在下方选择。': 'Você ainda não selecionou os campos que podem ser exportados. Por favor, selecione abaixo.',
    '采购订单基础信息': 'Informações básicas do pedido de compra',
    '订单总数': 'Número total de pedidos',
    '订单商品项': 'Itens do pedido',
    '合计商品总数': 'Total de mercadorias',
    '合计采购金额': 'Valor total da compra',
    '发货情况统计': 'Estatísticas de envio',
    '已发货商品数': 'Número de itens enviados',
    '已发货商品额': 'Quantidade de mercadorias enviadas',
    '未发货商品数': 'Número de itens não enviados',
    '未发货商品额': 'Quantidade de mercadorias não enviadas',
    '发货率': 'Taxa de envio',
    '不发货商品数': 'Número de itens não entregues',
    '不发货商品额': 'Quantidade de itens não entregues',
    '当前发票页面仅供预览，如果发送给客户请使用发票编辑页面的\'发送发票\'功能！': 'A página atual da fatura é apenas para visualização; se estiver enviando para um cliente, use a função "Enviar Fatura" na página de edição.',
    '发票预览': 'Visualização da Fatura',
    '如图一所示:页面顶部“发送发票”按钮': 'Conforme mostrado na Figura 1: Botão "Enviar Fatura" no topo da página',
    '如图二所示:页面底部\'发送发票\'按钮': 'Conforme mostrado na Figura 2: Botão "Enviar Fatura" na parte inferior da página',
    '商品列表页': 'Página da lista de produtos',
    '底部': 'Parte inferior',
    '顶部': 'Topo',
    '请输入单号范围': 'Por favor, insira o intervalo de números do pedido',
    '起始单号必须小于结束单号': 'O número de pedido inicial deve ser menor que o número de pedido final',
    '确定删除该商品？': 'Tem certeza de que deseja excluir este item?',
    '确定': 'OK',
    '取消': 'Cancelar',
    '已取消': 'Cancelado',
    '选取文件': 'Selecionar arquivo',
    '点击下载': 'Clique para baixar',
    '订单导入模板': 'Modelo de importação de pedidos',
    '请按规范填写表格，仅支持xlsx格式文件': 'Por favor, preencha o formulário conforme as especificações; apenas arquivos xlsx são suportados',
    '上传的文件不能超过2M，只处理前99条数据': 'O arquivo enviado não pode exceder 2MB; apenas os primeiros 99 dados serão processados',
    '待审核': 'Não revisado',
    '通过': 'Aprovado',
    '拒绝': 'Rejeitado',
    '申诉': 'Apelo',
    '余额': 'Saldo',
    '线下': 'Offline',
    '提现方式': 'Método de retirada',
    '状态': 'Estado de aprovação',
    '警告提示': 'Avisos',
    '该分类下目前还没有商品': 'Atualmente não há produtos nesta categoria',
    '最大建议尺寸 200px * 200px, 图片可自适应': 'Tamanho máximo recomendado 200px * 200px; a imagem pode se ajustar automaticamente',
    '添加图片': 'Adicionar imagem',
    '更改': 'Alterar',
    '删除': 'Excluir',
    '请联系供应商，完善站长外部编号': 'Por favor, entre em contato com o fornecedor para completar o número externo do webmaster',
    '返回': 'Voltar',
    '上传图片大小不能超过 500kb!': 'O tamanho da imagem enviada não pode exceder 500kb!',
    '描述文字': 'Texto da descrição',
    '履行费用': 'Custos de cumprimento',
    '发货时效': 'Tempo de envio',

    "Pause": "Pausa",
    "productType": "Tipo de Produto",
    "platform": "Plataforma",
    "Operation": "Operação",
    "All Orders": "Todos os Pedidos",

    "Yes": "Sim",
    "No": "Não",
    "Are you sure?": "Tem certeza?",
    "Damaged Item": "Item danificado",
    "Wrong product": "Produto errado",
    "The client received the order?": "O cliente recebeu o pedido?",
    "Whats happend?": "O que aconteceu?",

    "Send To": "Enviar Para",
    "Split orders": "Dividir pedidos",
    "Reply date": "Data de resposta",

    "We noticed you haven't verified your email address. Go to verify now?": "Notamos que você não verificou seu endereço de e-mail. Ir verificar agora?",
    "We noticed you haven't bind your mobile phone. Go to complete now?": "Percebemos que você não vinculou seu celular. Ir concluir agora?",
    "Please click 'Send' to get the verification code in your inbox": "Por favor, clique em 'Enviar' para receber o código de verificação na sua caixa de entrada.",
    "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings'": "Você pode modificar suas regras de despacho de pedidos a qualquer momento no menu 'Meus Pedidos >> Configurações de Despacho'.",

    "Comexbcn Privacy Statement": "Declaração de privacidade da Comexbcn",
    "How Comexbcn Uses Your Data": "Como a Comexbcn utiliza seus dados",
    "This statement demonstrates how seriously and responsibly we handle user privacy.": "Esta declaração demonstra como tratamos de forma séria e responsável a privacidade do usuário.",
    "It details to the user how our company, COMEXBCN, collects, handles, shares, and processes their data and/or information.": "Detalha ao usuário como nossa empresa COMEXBCN coleta, trata, compartilha e processa seus dados e/ou informações.",
    "This page alerts and informs the user that by choosing our service and app/website,": "Esta página alerta e informa o usuário que, ao escolher nosso serviço e aplicativo/site,",
    "they agree to the use, collection, and processing of dropshipping by Comexbcn,": "ele concorda com o uso, coleta e processamento de dropshipping pela Comexbcn,",
    "and also that they accept all the “TERMS AND CONDITIONS”.": "e também que aceita todos os “TERMOS E CONDIÇÕES”.",
    "Any personal information may be used to help improve our app/website.": "Qualquer informação pessoal poderá ser usada para ajudar a melhorar nosso aplicativo/site.",

    "Collection and Use of Information": "Coleta e Uso de Informações",
    "If you use our app/website, we may request that you provide personal identification data.": "Se você utilizar nosso aplicativo/site, poderemos solicitar que forneça dados pessoais de identificação.",
    "This is not limited to the name for full use of our app/website's functions.": "Não se limita apenas ao nome para o uso completo das funções do nosso aplicativo/site.",
    "We also intend to use the data for “marketing activities” and for conducting general research and evaluations.": "Também pretendemos usar os dados para “atividades de marketing” e para realizar pesquisas e avaliações gerais.",

    "Values": "Valores",
    "Recognition of the nature of our business and your information": "Reconhecimento da natureza do nosso negócio e de suas informações",
    "We perform a legally authorized service to provide services.": "Prestamos um serviço legalmente autorizado para fornecer serviços.",
    "Our commitment is to integrity, transparency, and respect for privacy in all aspects.": "Nosso compromisso é com a integridade, transparência e respeito à privacidade em todos os aspectos.",
    "We will process and use only essential information for our business,": "Processaremos e utilizaremos apenas as informações essenciais para o nosso negócio,",
    "with personal data belonging solely and exclusively to the user,": "sendo os dados pessoais pertencentes única e exclusivamente ao usuário,",
    "thus respecting its nature and treating it sensitively in every detail.": "respeitando sua natureza e tratando-os de forma sensível em cada detalhe.",

    "Protecting Your Information": "Protegendo suas informações",
    "For any third-party requests requiring your information,": "Para quaisquer solicitações de terceiros que exijam suas informações,",
    "our company will only provide it with the user’s consent,": "nossa empresa só fornecerá com o consentimento do usuário,",
    "without any sharing with external sources,": "sem qualquer compartilhamento com fontes externas,",
    "unless obligated to comply with applicable laws and regulations,": "a menos que seja obrigada a cumprir as leis e regulamentos aplicáveis,",
    "responding to an official subpoena, or any other judicial request,": "responder a uma intimação oficial ou qualquer outra solicitação judicial,",
    "seeking to protect our user and also our rights.": "visando proteger nosso usuário e também os nossos direitos.",

    "Usability Rights": "Direitos de Usabilidade",

    "Comexbcn is focused on prevention, striving to avoid errors in its procedures as much as possible. However, if there is any situation where a cancellation and return are desired, our policy for taking appropriate actions is described below.":
        "A Comexbcn trabalha com com foco em prevenção, buscando ao máximo evitar que exista erros em seus procedimentos, porém caso exista qualquer condição no qual o desejo seja o cancelamento do pedido e devolução, a seguir descrevemos nossa política que possa tomar as devidas providências.",
    "Cancellation": "Cancelamento",
    "We accept cancellation requests before the product is shipped or produced. In this case, a full refund will be issued. If the product has already been shipped, it cannot be canceled.": "Recebemos o pedido de cancelamento antes que o produto seja enviado ou produzido. Neste caso o reembolso será em sua totalidade. Se o produto já estiver no envio, não haverá condições de ser cancelado.",
    "Returns": "Devoluções",
    "Respecting the consumer's right to request a return within 10 days after the product's delivery, we accept returns under the condition that the item or items are not in use and are in their original delivery packaging. Our customer service department will request the receipt or proof of purchase to certify the procedure so that the shipment can be made to the correct address.":
        "Respeitando o direito do consumidor em solicitar a devolução no prazo de até 10 dias após a entrega do produto, aceitamos a sua devolução. As condições para que isso ocorra é que o item ou itens não devem estar em uso, e devem estar com a embalagem original da entrega. Nosso departamento de atenção ao cliente irá solicitar o recibo ou comprovante de compra, certificando o procedimento para que a remessa seja realizada para o endereço correto.",
    "Items that are damaged or lost qualify for a full refund, or another item of the same order can be sent under the same conditions, or the corresponding value of the claimed item can be refunded.":
        "Item Danificado ou Extraviado possui reembolso integral, podendo ser enviado outro item do mesmo pedido, nas mesmas condições, ou o valor correspondente ao item reclamado.",
    "Refund Process": "Processo de Reembolso",
    "After receiving the item and performing the check as indicated above, we will notify you of the receipt and the processing time for the refund. A credit of the agreed amount will be issued as agreed between the parties via email, indicating the time frame to complete the process.":
        "Após recebermos o item e realizar a checagem conforme indicado anteriormente, iremos notificar o recebimento e o prazo para o processamento do reembolso, e um crédito do valor conforme acordado entre as partes por e-mail, indicando o tempo hábil para concluir o processo.",
    "For any clarifications, please contact our support at: contato@comexbcn.com with your contact information, indicating the purchased item.":
        "Para qualquer esclarecimento entre em contato com o nosso suporte: contato@comebcn.com , com seus dados para contato, indicando o item comprado.",

    'This application/site is managed by the Comexbcn team. They are responsible for all management, and whenever we use the words "we," "together," and "our," they refer to this team at app.comexbcn.com, including tools, information, and services. Any user who accesses our site and application is conditioned to accept our terms and conditions of use, company policies, and notices mentioned here.':
        'Este aplicativo/site é administrado pela equipe da Comexbcn. Sendo responsáveis por toda gestão, e sempre que utilizamos as palavras “nós”, “juntos” e “nosso” está se referindo a essa equipe app.comexbcn.com, incluindo ferramentas, informações e serviços. Qualquer usuário que acesse nosso site e aplicativo está condicionado à aceitar nossos termos e condições de uso, políticas da empresa e avisos aqui mencionados.',
    'By visiting our application and/or site, purchasing on our platform, you declare that you are engaging in our "Service" and agree to comply with our following terms and conditions of use ("TERMS AND CONDITIONS OF USE"), including additional terms, conditions, and policies referenced here or available via link. These TERMS AND CONDITIONS OF USE apply to users in their entirety on the site or application, without limitation, users who browse, suppliers, customers, merchants, and/or content collaborators.': 'Visitando nosso aplicativo e/ou site, comprando em nossa plataforma você declara que se envolve em nosso “Serviço” e está de acordo em obedecer a nossos seguintes termos e condições de uso (“TERMOS E CONDIÇÕES DE USO”), incluindo termos, condições e políticas adicionais referidas aqui ou disponíveis por link. Tais TERMOS E CONDIÇÕES DE USO se aplicam aos usuários em sua totalidade no site ou aplicativo, sem limitação, usuários que navegam, fornecedores, clientes, comerciantes e/ou colaboradores de conteúdo.',
    'Please read our TERMS AND CONDITIONS OF USE carefully before accessing or using our site/application. By accessing any content on our site/application, you agree to comply with these TERMS AND CONDITIONS OF USE. If you do not agree with our terms and conditions, you may not access our site/application or use any of our services. If these TERMS AND CONDITIONS OF USE are considered an offer, their acceptance is expressly limited to these TERMS AND CONDITIONS.': 'Leia nossos TERMOS E CONDIÇÕES DE USO atentamente antes de acessar ou utilizar nosso site/aplicativo. Acessando qualquer conteúdo do nosso site/aplicativo você concorda em obedecer a esses TERMOS E CONDIÇÕES DE USO. Se não houver concordância com os nossos termos e condições você não poderá acessar nosso site/aplicativo ou utiliza qualquer um dos nossos serviços. Se, portanto, esses TERMOS E CONDIÇÕES DE USO forem por acaso considerados uma oferta, a sua aceitação estará limitada a estes TERMOS E CONDIÇÕES.',
    "Any new feature or tool that is added will also be subject to our terms and conditions. The most recent version of this will always be available on this page. Comexbcn reserves the right to update, delete, or modify any part of the TERMS AND CONDITIONS OF USE by posting updates on our site/application. It is the user's responsibility to check this page to monitor our updates. Your access and use of our site/application constitute your acceptance of these changes.": 'Qualquer novo recurso ou ferramenta que forem adicionados também estarão sujeitos aos nossos termos e condições. Estará sempre disponível a versão mais recente deste nesta página. A Comexbcn se reserva no direito de atualizar, excluir ou modificar qualquer parte dos TERMOS E CONDIÇÕES DO USO publicando sempre em nosso site/aplicativo. É da responsabilidade do usuário verificar essa página para que possa checar nossas atualizações. Seu acesso e utilização do nosso site/aplicativo declara sua aceitação nestas alterações.',
    'SECTION 1 – APPLICATION/SITE TERMS OF USE': 'SEÇÃO 1 – TERMOS DE USO DA APLICAÇÃO/SITE',
    'By agreeing to these TERMS AND CONDITIONS, you may not use the products advertised on the application/site for any illegal or unauthorized purpose, nor may you, under any circumstances, violate any laws in your jurisdiction (including but not limited to copyright laws).': 'Ao concordar com estes TERMOS E CONDIÇÕES, você não pode usar os produtos divulgados no aplicativo/site para propósito ilegal ou não autorizado, nem pode, sobre nenhuma hipótese violar quaisquer leis em sua jurisdição (incluindo, mas não se limitando às leis de direitos autorais).',
    'You must not transmit any worms or viruses or any code of a destructive nature. Violation of any of the Terms will result in the immediate termination of your Services.': 'Você não deve transmitir worms ou vírus ou qualquer código de natureza destrutiva.A violação de qualquer um dos Termos resultará na rescisão imediata de seus Serviços.',
    'SECTION 2 – GENERAL CONDITIONS': 'SEÇÃO 2 – CONDIÇÕES GERAIS',
    'We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (excluding credit card information) may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.': 'Nós temos total direito e autonomia para recusar qualquer um dos nossos serviços, a qualquer pessoa ou por qualquer motivo, e também a qualquer momento. Você entende que seu conteúdo (não incluindo informações de cartão de crédito) pode ser transferido sem criptografia e envolver (a) transmissões em várias redes; e (b) alterações para conformidade e adaptação aos requisitos técnicos de conexão de redes ou dispositivos. As informações do cartão de crédito são sempre criptografadas durante a transferência pelas redes.',
    'You agree not to reproduce, duplicate, copy, sell, resell, or exploit any part of the Service, use of the Service, or access to the Service or any contact on the site/application through which the service is provided, without express written permission from us.': 'Você concorda em não reproduzir, duplicar, copiar, vender, revender ou explorar qualquer parte do Serviço, uso do Serviço ou acesso ao Serviço ou qualquer contato no site / aplicativo através do qual o serviço é fornecido, sem permissão expressa por escrito por nós.',
    'The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.': 'Os títulos usados neste contrato são incluídos apenas para conveniência e não irão limitar ou afetar estes Termos.',
    'SECTION 3 – ACCURACY AND COMPLETENESS OF INFORMATION': 'SEÇÃO 3 – INFORMAÇÕES E INTEGRIDADE',
    'We are not responsible if the information provided here is not accurate, complete, or current. All material provided is for general information purposes only and should not be relied upon for making decisions without consulting primary information sources. Any reliance on the content provided is at your own risk.': 'Nós não somos responsáveis se o fornecimento das informações aqui não forem reais, completas ou atualizadas. Todo material fornecido é de informação geral, portanto não deve ser tomado em conta para tomar decisões sem consultar fontes de informações primárias, checando sua coerência, completude e colaboração em qualquer caso. Toda e qualquer confiança no conteúdo aqui exposto é por sua própria conta.',
    'This site may contain historical information, which is provided for your reference. We reserve the right to modify any document or information on this application/site at any time, without obligation to update any information on this page, and you agree that it is your responsibility to monitor any changes.': 'Este site mantém informações históricas, no qualquer normalmente é feira para sua referência. Reservamos o direito de alterar qualquer documento ou informação exposta neste aplicativo/site, mesmo sabendo que não temos nenhuma obrigatoriedade em atualizar qualquer informação nesta página, e você concorda que é sua responsabilidade monitorar qualquer alteração aqui realizada.',
    'SECTION 4 – MODIFICATIONS TO PRICES AND SERVICES': 'SEÇÃO 4 - MODIFICAÇÕES EM PREÇOS OU SERVIÇO',
    'We reserve the right to change the prices of our products without notice at any time or to discontinue the service or any part of it without notice at any time. We shall not be liable to you or any third party for any modification, price change, or discontinuation of the service.': 'Reservamos o nosso direito de alterar sem aviso prévio os preços de nossos produtos, a qualquer momento ou inclusive deixar de oferecer o serviço ou parte dele, sem nenhum aviso prévio, em qualquer tempo. Nos isentamos da responsabilidade perante você ou terceiros para toda e qualquer modificação, alteração de preço, ou inexistencia da prestação do serviço.',
    'SECTION 5 – PRODUCTS OR SERVICES (if applicable)': 'SEÇÃO 5 - PRODUTOS OU SERVIÇOS (quando aplicável)',
    'Certain products or services may be available exclusively through the application/site. We also reserve the right to limit quantities and apply return and exchange policies in accordance with our policy.': 'Determinados produtos ou serviços podem estar disponíveis exclusivamente por um meio do aplicativo/site, portanto também nos reservamos o direito de aplicar quantidades limitadas e também políticas de devolução e troca conforme a nossa política.',
    'We strive to display products as accurately as possible in terms of sizes and colors, but we cannot guarantee that the display of any color on your computer monitor will be accurate. We reserve the right to limit our products to any person, geographic region, or jurisdiction. We do not warrant that the quality of any products, services, information, or other materials purchased by you will meet your expectations, or that any errors in the service will be corrected.': 'Trabalhamos para tornar visível apenas produtos que tenham a maior precisão possível nos tamanhos e cores, porém não podemos garantir que a exibição de qualquer cor específica devido ao monitor do computador que o usuário utiliza. Reservamos o direito de limitar nossos produtos para qualquer pessoa, em qualquer local e também jurisdição. Também não garantimos a qualidade de qualquer produto disponível, e serviços, informações ou outro material adquirido por você venha atender suas expectativas, ou eventuais erros que podem existir na prestação do serviço.',
    'SECTION 6 – BILLING AND ACCOUNT INFORMATION': 'SEÇÃO 6 - FATURAMENTO E INFORMAÇÕES DE CONTA',
    'We reserve the right to refuse any order you place with us. We may, at our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers, or distributors.': 'Nós nos reservamos o direito de recusar qualquer pedido que você fizer conosco. Podemos, a nosso exclusivo critério, limitar ou cancelar as quantidades compradas por pessoa, por família ou por pedido. Essas restrições podem incluir pedidos feitos por ou sob a mesma conta do cliente, o mesmo cartão de crédito e / ou pedidos que usam o mesmo faturamento e / ou endereço de entrega. No caso de fazermos uma alteração ou cancelar um pedido, podemos tentar notificá-lo entrando em contato com o e-mail e / ou endereço de cobrança / número de telefone fornecido no momento em que o pedido foi feito. Nós nos reservamos o direito de limitar ou proibir pedidos que, em nosso julgamento exclusivo, pareçam ser feitos por revendedores, revendedores ou distribuidores.',
    'You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed. For more details, please review our Return Policy.': 'Você concorda em fornecer informações de conta e compra atuais, completas e precisas para todas as compras feitas em nossa loja. Você concorda em atualizar imediatamente sua conta e outras informações, incluindo seu endereço de e-mail e números de cartão de crédito e datas de vencimento, para que possamos concluir suas transações e entrar em contato com você conforme necessário.Para obter mais detalhes, consulte nossa Política de Devolução',
    'SECTION 7 – OPTIONAL TOOLS': 'SEÇÃO 7 - FERRAMENTAS OPCIONAIS',
    'We may provide you with access to third-party tools over which we neither monitor nor have any control or input. You acknowledge and agree that we provide access to such tools "as is" and "as available" without any warranties, representations, or conditions of any kind and without any endorsement. Any use by you of optional tools offered through the site/application is entirely at your own risk and discretion, and you should ensure that you are familiar with and approve the terms on which tools are provided by the relevant third-party provider. We may also, in the future, offer new services and/or features through the site/application (including the release of new tools and resources). Such new features and/or services shall also be subject to these TERMS AND CONDITIONS.': 'Existe a possibilidade de fornecermos ferramentas de terceiros, e neste caso não temos autonomia para monitorar ou ter qualquer controle e acesso. Você está ciente e concorda que fornecemos essas ferramentas, como são disponibilizadas, em seu estado atual, e informações oferecidas, sendo sem quaisquer garantias, representações ou condições de qualquer tipo, em qualquer endosso. Qualquer ferramenta extra disponibilizada em nosso aplicativo/site é de inteira responsabilidade sua e você deve se certificar e aprovar os termos fornecidos por ela. Também ressaltamos que podemos oferecer outros serviços ou novos recursos, e todos estarão sujeitos a estes TERMOS E CONDIÇÕES.',
    'SECTION 8 – PERSONAL INFORMATION': 'SEÇÃO 8 - INFORMAÇÕES PESSOAIS',
    'Your submission of personal information is governed by our Privacy Policy, following all applicable laws and regulations.': 'O envio de informações pessoais está contemplado em nossa Política de Privacidade, seguindo todas as normais e legislações vigentes.',
    'SECTION 9 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY': 'SEÇÃO 9 - ISENÇÃO DE GARANTIAS; LIMITAÇÃO DE RESPONSABILIDADE',
    'We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free.': 'Não garantimos, representamos ou garantimos que o uso de nosso serviço será ininterrupto, oportuno, seguro ou livre de erros.',
    'We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.': 'Não garantimos que os resultados que podem ser obtidos com o uso do serviço sejam precisos.',
    'You agree that from time to time we may remove the service for indefinite periods or cancel the service at any time, without notice to you.': 'Você concorda que, de tempos em tempos, podemos remover o serviço por períodos indefinidos ou cancelar o serviço a qualquer momento, sem aviso prévio.',
    "You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties, or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.": 'Você concorda expressamente que o uso ou a incapacidade de usar o serviço é por sua conta e risco. O serviço e todos os produtos e serviços fornecidos a você por meio do serviço são (exceto conforme expressamente declarado por nós) fornecidos "como estão" e "conforme disponíveis" para seu uso, sem qualquer representação, garantias ou condições de qualquer tipo, expressas ou implícito, incluindo todas as garantias implícitas ou condições de comercialização, qualidade comercializável, adequação a uma finalidade específica, durabilidade, título e não violação.',
    'In no case shall we, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.': 'Em nenhum caso nós, nossos diretores, executivos, funcionários, afiliados, agentes, contratados, estagiários, fornecedores, prestadores de serviços ou licenciados seremos responsáveis ​​por qualquer lesão, perda, reclamação ou qualquer ação direta, indireta, incidental, punitiva, especial ou danos consequenciais de qualquer tipo, incluindo, sem limitação, lucros cessantes, receitas perdidas, economias perdidas, perda de dados, custos de substituição ou quaisquer danos semelhantes, seja com base em contrato, ato ilícito (incluindo negligência), responsabilidade objetiva ou de outra forma, decorrentes de seu uso de qualquer um dos serviços ou produtos adquiridos usando o serviço, ou para qualquer outra reclamação relacionada de qualquer forma ao seu uso do serviço ou de qualquer produto, incluindo, mas não se limitando a, quaisquer erros ou omissões em qualquer conteúdo, ou qualquer perda ou dano de qualquer tipo incorrido como resultado do uso do serviço ou de qualquer conteúdo (ou produto) postado, transmitido ou de outra forma disponibilizado por meio do serviço, mesmo se informado da possibilidade. Como alguns estados ou jurisdições não permitem a exclusão ou limitação de responsabilidade por danos conseqüentes ou incidentais, em tais estados ou jurisdições, nossa responsabilidade deve ser limitada à extensão máxima permitida por lei.',
    'SECTION 10 – TERMINATION OF SERVICE': 'SEÇÃO 10 – RESCISÃO DE SERVIÇO',
    'You may terminate this agreement at any time by notifying us that you no longer wish to use our services or when you cease using our site/application. Both parties may terminate this agreement at any time, and any charges or other information and pending procedures will be handled directly by the contract termination department.': 'Você poderá em qualquer momento rescindir este contrato, notificando que não deseja mais usar os nossos serviços ou quando deixar de utilizar nosso aplicativo/site. Ambas as partes poderão em qualquer ocasião rescindir este contrato a qualquer momento, e havendo encargos ou qualquer outra informação e procedimento pendente será tratado diretamente pelo departamento de rescisão de contratos.',
    'SECTION 11 – CUSTOMER SERVICE': 'SEÇÃO 11 – SERVIÇO DE ATENDIMENTO AO CLIENTE',
    'You will always have access to our customer service, whether by email, online chat on our site/application, or via our WhatsApp number. It is your responsibility to contact us whenever you have any questions or situations that may compromise your data or the processing of your information on our site/application. Response times vary depending on the inquiry sent, between 48 to 72 business hours.': 'Você sempre terá a sua disposição nosso serviço de atendimento ao cliente seja por e-mail, por chat online em nosso aplicativo/site, como também nossos atendimentos por número de WhatsApp, ficando na sua responsabilidade entrar em contato sempre que surgir qualquer dúvida ou situação que possa comprometer seus dados ou processamento da sua informação em nosso aplicativo/site. O tempo de resposta varia conforme a dúvida enviada, entre 48 a 72 horas úteis.',
    'SECTION 12 – SHIPPING': 'SEÇÃO 12 – ENVIOS',
    'Logistics and shipment policies are covered in our Shipping Policy, following all applicable laws and regulations.': 'A logística e envio de remessas está contemplado em nossa Política de Envio, seguindo todas as normais e legislações vigentes.',
    'SECTION 13 – GOVERNING LAW': 'SEÇÃO 13 - LEI APLICÁVEL',
    'These TERMS AND CONDITIONS and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of Hong Kong.': 'Estes TERMOS E CONDIÇÕES e quaisquer acordos separados pelos quais fornecemos os Serviços a você serão regidos e interpretados de acordo com as leis de Hong Kong.',
    'SECTION 14 – CHANGES TO TERMS AND CONDITIONS': 'SEÇÃO 14 - ALTERAÇÕES NOS TERMOS E CONDIÇÕES',
    'You can review the most current version of the TERMS AND CONDITIONS OF USE at any time on this page. We reserve the right to update, change, or replace any part of': 'Em qualquer momento poderá acessar nesta página a versão mais atual dos TERMOS E CONDIÇÕES DE USO. Temos e reservamos o exclusivo direito em modificar qualquer parte dos TERMOS E CONDIÇÕES publicando suas atualizações em nosso aplicativo/site. Lembrando que é da sua responsabilidade checar com frequência se existem modificações vigentes. Seu uso ou acesso ao nosso aplicativo/site após qualquer alteração comprova que você está de acordo com nossos TERMOS E CONDIÇÕES DE USO e suas alterações realizadas.',

    "Thank you for your interest in Comexbcn.": "Agradecemos seu interesse na Comexbcn.",
    "Our commitment is to deliver quality service with transparency and efficiency, offering various shipping options worldwide. We have a decade of experience in this field, with hundreds of satisfied customers.": "Nosso compromisso é entregar um serviço de qualidade, com transparência e eficiência, entregando várias opções de remessa em diversos lugares do mundo. Possuímos experiência de uma década nesta atividade, com centenas de clientes satisfeitos.",
    "Below are the terms and conditions of our shipping policy.": "Abaixo detalhamos nossas condições e termos da nossa política de envio.",
    "1. Processing and Shipping Time": "1 Processamento e tempo de envio",
    "Processing time is typically between 2 to 4 days after payment confirmation. During this period, we will prepare your order.": "O tempo de processamento normalmente é entre 2 a 4 dias após a confirmação do seu pagamento. Neste momento iremos preparar o seu pedido.",
    "If there are any irregularities, we will contact you.": "Caso exista qualquer irregularidade entraremos em contato.",
    "2.1 International Shipping": "2.1 Envio Internacional",
    "Comexbcn offers international shipping. For any questions, please contact us through [our website](https://www.comexbcn.com).": "A Comexbcn realiza remessas internacionais, para qualquer dúvida a respeito entre em contato conosco. https://www.comexbcn.com",
    "Delivery Estimates and Applicable Fees": "Estimativas de entrega e taxas aplicadas",
    "We understand the importance of knowing the best market practices to minimize costs without compromising service quality. Comexbcn operates with transparency, providing realistic deadlines to avoid surprises during the process. Before finalizing your order, all timelines and costs will be available for your review. The delivery period starts from the moment the shipment is dispatched, not the order date. It's important to note that delivery estimates are not guaranteed. We do our best to meet your order requirements, but unexpected situations such as weather changes, attacks, force majeure, and other external events can delay delivery.": "Sabemos que neste mercado é necessário conhecer as melhores práticas do mercado, buscando diminuir os custos sem perder a qualidade na oferta do serviço, neste caso a Comebcn trabalha com transparência, entregando prazos reais para que não existam surpresas durante o processo. Antes de finalizar seu pedido todos os prazos estarão disponíveis para conhecimento, assim como os custos praticados. O prazo de entrega inicia a partir do momento do envio da remessa, não na data em que o pedido foi efetivado. Importante ressaltar que as estimativas de chegada não são garantidas. Também que nosso compromisso é fazer o máximo que podemos para atender seu pedido, porém situações inesperadas podem atrasar a entrega, como por exemplo: mudanças climáticas, atentados, atividades de força maior, entre outras situações externas que impactam a logística direta ou indiretamente impossibilitando a entrega da remessa.",
    "3.1 Delivery Observations": "3.1 Observação sobre nossa entrega",
    "a. The delivery date may vary depending on the carrier, delivery method, location, and items ordered.": "a. data para a entrega pode ser variar conforme a transportadora, o método de entrega, local e inclusive os itens solicitados.",
    "b. Separate Product Deliveries": "b.Os produtos podem ser entregues separadamente",
    "Products may be delivered separately. When placing your order, please consider these factors for the estimated delivery date.": "Quando você realiza seu pedido importante considerar esses fatores para a data de entrega estimulada.",
    "Transit Time:The time it takes for your shipment to move from our distribution center to the local carrier.": "Tempo de trânsito:tempo para que a sua remessa saia do nosso centro de distribuição até a transportadora local.",
    "Shipment Weight:Shipping costs are based on the weight of your package and the chosen delivery method.": "Pesagem Remessa: Os valores aplicados no custo de envio são conforme o peso da sua encomenda e a forma de entrega estipulada.",
    "The final cost of your order can be seen after proceeding to the final checkout screen. Shipping costs will be displayed when you finalize your order.": "O valor final do seu pedido pode ser visto após prosseguir na tela final da sua compra. Quando for finalizar seu pedido aparecerá os custos de envio.",
    "Tracking": "Rastreamento",
    "As previously mentioned, Comexbcn operates transparently and always opts for tracked shipping to ensure peace of mind throughout the process. After completing a purchase with us, you will have access to tracking your order.": "A Comecbcn como já mencionamos anteriormente trabalha de forma transparente, e sempre opta por envio com rastreamento, para que assim todos tenham maior tranquilidade no processo. Assim que finalizar um pedido de compra conosco terá a sua disposição o rastreo do seu pedido.",
    "Damages": "Danificações",
    "If you notice any damage upon delivery, please contact us promptly through our WhatsApp support or via our [website](https://www.comexbcn.com).": "Se perceber qualquer dano na entrega do pedido, por gentileza entre em contato conosco rapidamente em nosso atendimento por WhatsApp ou em",
    "Lost Package": "Pacote Perdido",
    "While rare, if a package is lost, please check possible locations where the delivery person might have left it, including with neighbors. Before contacting us, we kindly ask you to check all possible locations to avoid unnecessary steps. If you still cannot locate the package, contact us via [our website](https://www.comexbcn.com) to report the lost package.": "São situações raras, porém se for a situação, verifique os possíveis lugares onde os entregadores deixam os pacotes, inclusive com o vizinho. Antes que entre em contato conosco solicitamos gentilmente que cheque todas as possiblidades para não termos retrabalhos. Se mesmo assim não localizou, entre em contato conosco em https://www.comexbcn.com para informar pacotes perdidos.",
    "Miscellaneous Questions": "Questões diversas",
    "For any questions not mentioned here, please do not hesitate to contact us. We also have a FAQ page that may be useful for your situation. Visit our website: [www.comexbcn.com](https://www.comexbcn.com).": "Qualquer dúvida referente a questões não mencionadas aqui, por gentileza não dúvide em entrar em contato conosco. Temos também uma página de dúvidas frequentes que talvez seja útil na sua situação. Acesse o nosso site: www.comexbcn.com",

    "正在处理中，请勿重复操作": "Processando em andamento, por favor, evite ações duplicadas.",

    "Please select type first.": "Selecione o tipo primeiro.",
    "After-sales Service": "Serviço pós-venda",
    "Deal Type": "Tipo de negócio",
    "Deliver Time": "Tempo de entrega",
    "Real Paid": "Valor pago",
    "SKU": "SKU",
    "待审批": "Pendente",
    "已审批": "Aprovado",
    "tradeAmount": "Valor da Transação",
    "itemAmount": "Valor dos Itens",
    "discountAmount": "Valor do Desconto",
    "refundAmount": "Valor do Reembolso",
    "Oops, no data found! Try a different search or check back later.": "Oops, nenhum dado encontrado! Tente uma busca diferente ou volte mais tarde.",

    "Item Amount": "Valor do Item",
    "Discount Amount": "Valor do Desconto",
    "CreatedAt": "Criado em",
    "PaidAt": "Pago em",
    "DeliverAt": "Entregue em",
    "Contact Information": "Informações de Contato",
    "Zipcode": "CEP",
    "Phone number": "Número de telefone",
    "E-mail": "E-mail",
    "Track Company": "Empresa de Rastreamento",
    "Notes": "Observações",
    "Apartment, sulte": "Apartamento, suíte",
    "Name": "Nome",
    "Contacts": "Contatos",
    "Time": "Tempo",

    "Re-quote": "Re-cotação",
    "Restore": "Restaurar",
    "Offline Order": "Pedido Offline",
    "Offline Orders": "Pedidos Offline",
    "Add New One": "Adicionar novo",
    "Dropshipping": "Dropshipping",
    "Cargo": "Carga",
    "Price Expect": "Preço esperado",
    "Pictures": "Fotos",
    "COMPLETED": "Concluído",
    "FAIL": "Falha",
    "Wait For Quote": "Aguardando cotação",
    "At least one image is required.": "Pelo menos uma imagem é necessária.",
    "Max 5 images allowed.": "Máximo de 5 imagens permitidas.",
    "Title is required.": "Título é obrigatório.",
    "Country is required.": "País é obrigatório.",
    "Minimum price is required.": "Preço mínimo é obrigatório.",
    "Maximum price is required.": "Preço máximo é obrigatório.",
    "Link": "Link",
    "Min": "Mínimo",
    "Max": "Máximo",
    "Collapse": "Recolher",
    "Machine & Accessories": "Máquina e Acessórios",
    "Machine Tool Spindle": "Eixo da Ferramenta da Máquina",
    "Magic Cubes": "Cubos Mágicos",
    "Magic Tricks": "Truques de Magia",
    "Magnetic Materials": "Materiais Magnéticos",
    "Make Up": "Maquiagem",
    "make up tools": "Ferramentas de Maquiagem",
    "Marble Runs": "Pistas de Mármores",
    "Martin Boots": "Botas Martin",
    "Mary Janes": "Sapatos Mary Jane",
    "Massage & Relaxation": "Massagem e Relaxamento",
    "Massage Roller": "Rolo de Massagem",
    "Mat": "Tapete",
    "Matching Sets": "Conjuntos Combinados",
    "Material": "Material",
    "Material Paper": "Papel de Material",
    "Math Toys": "Brinquedos de Matemática",
    "Mattress Cover": "Capa de Colchão",
    "Mattresses": "Colchões",
    "Measurement & Analysis Tools": "Ferramentas de Medição e Análise",
    "Mechanical Watches": "Relógios Mecânicos",
    "Medical Uniforms": "Uniformes Médicos",
    "Memorials & Funerary": "Memoriais e Fúnebres",
    "Men's Bags": "Bolsas Masculinas",
    "Men's Belts": "Cintos Masculinos",
    "Men's Boots": "Botas Masculinas",
    "Men's Causal Shoes": "Calçados Casuais Masculinos",
    "Men's Clothing": "Roupas Masculinas",
    "Men's Fold Wallet": "Carteira Dobrável Masculina",
    "Men's Leather Wallet": "Carteira de Couro Masculina",
    "Men's Necklace": "Colar Masculino",
    "Men's Sandals & Slippers": "Sandálias e Chinelos Masculinos",
    "Men's Underwear": "Roupa Íntima Masculina",
    "Men's Wallet with Zipper": "Carteira Masculina com Zíper",
    "Men's Watches": "Relógios Masculinos",
    "Menstrual Panties": "Calcinhas Absorventes",
    "Messenger Bag": "Bolsa Messenger",
    "Microscopes": "Microscópios",
    "Middle Heel": "Salto Médio",
    "Middle Size Luggage": "Mala de Tamanho Médio",
    "Midi Dresses": "Vestidos Midi",
    "Military Boots": "Botas Militares",
    "Minimizer Bras": "Sutiãs Redutores",
    "Mobile Phone Antennas": "Antenas para Celular",
    "Mobile Phone Batteries": "Baterias para Celular",
    "Mobile Phone Cables": "Cabos para Celular",
    "Mobile Phone Chargers": "Carregadores para Celular",
    "Mobile Phone Flex Cables": "Cabos Flexíveis para Celular",
    "Mobile Phone Housings & Frames": "Carcaças e Molduras para Celular",
    "Mobile Phone lcD Screens": "Telas LCD para Celular",
    "Mobile Phones": "Telefones Celulares",
    "Moissanite Bracelet": "Pulseira de Moissanita",
    "Money & Banking ToyS": "Brinquedos de Dinheiro e Banco",
    "Mosquito Nets": "Redes Contra Mosquitos",
    "Mossinate": "Musgo Sintético",
    "Mother Shoes": "Calçados de Mãe",
    "Motherboards": "Placas-Mãe",
    "Motorcycle & ATV": "Motocicleta e ATV",
    "Motorcycle Gear": "Equipamentos para Motocicleta",
    "Motorcycle ltems": "Itens para Motocicleta",
    "Motorcycle Pants": "Calças para Motociclista",
    "Motorcycle Parts": "Peças para Motocicleta",
    "Motorcycles": "Motocicletas",
    "MP3/MP4 Bags & Cases": "Bolsas e Estojos MP3/MP4",
    "Mug Thermos": "Garrafa Térmica",
    "Mules Sandals": "Sandálias Mule",
    "Multi-Purpose Bag": "Bolsa Multiuso",
    "Musical Instruments": "Instrumentos Musicais",
    "Mystery Box": "Caixa Surpresa",
    "Natural Stone Bracelet": "Pulseira de Pedra Natural",
    "Neck Fan": "Ventilador de Pescoço",
    "Neck Massage Instrument": "Aparelho de Massagem para Pescoço",
    "Necklaces": "Colares",
    "Needle": "Agulha",
    "Needle Arts & Craft": "Artesanato com Agulha",
    "New in": "Novidades",
    "New in Backpack": "Novidades em Mochilas",
    "New in Bracelets": "Novidades em Pulseiras",
    "New in Coats & Jackets": "Novidades em Casacos e Jaquetas",
    "New in Dresses": "Novidades em Vestidos",
    "New in Findings": "Novidades em Acabamentos",
    "New in Handbag": "Novidades em Bolsas",
    "New in Hoodies & Sweatshirts": "Novidades em Casacos e Suéteres",
    "New in Keychains": "Novidades em Chaveiros",
    "New in Knitwears": "Novidades em Roupas de Tricô",
    "New in Matching Sets": "Novidades em Conjuntos Combinados",
    "New in Men's Sets": "Novidades em Conjuntos Masculinos",
    "New in Men's Sleepwear": "Novidades em Pijamas Masculinos",
    "New in Men's Socks": "Novidades em Meias Masculinas",
    "New in Men's Underwear": "Novidades em Roupa Íntima Masculina",
    "New in Men's Watches": "Novidades em Relógios Masculinos",
    "New in Necklaces": "Novidades em Colares",
    "New in Outerwears": "Novidades em Roupas Externas",
    "New in Pants": "Novidades em Calças",
    "New in Pants & Capris": "Novidades em Calças e Capris",
    "New in Rings": "Novidades em Anéis",
    "New in Shorts": "Novidades em Bermudas",
    "New in Suits & Blazers": "Novidades em Ternos e Blazers",
    "New in Tops & Tees": "Novidades em Camisas e Blusas",
    "New in Women's Boots": "Novidades em Botas Femininas",
    "New in Women's Sleepwear": "Novidades em Pijamas Femininos",
    "New in Women's Socks": "Novidades em Meias Femininas",
    "New in Women's Underwear": "Novidades em Roupa Íntima Feminina",

    "Nightgowns": "Camisolas",
    "Nightstands": "Mesinhas de Cabeceira",
    "Nose Nail": "Unha de Nariz",
    "Notebooks & Papers": "Cadernos e Papéis",
    "Nursery & Baby Furniture": "Móveis para Berçário e Bebê",
    "O-Neck Pullovers": "Suéteres com Gola Careca",
    "Office Chairs": "Cadeiras de Escritório",
    "Office Furniture": "Móveis de Escritório",
    "One Piece Hats": "Chapéus de Uma Peça",
    "One Pieces": "Macacões",
    "Open Closets": "Armários Abertos",
    "Other": "Outros",
    "Other Apparel Accessories": "Outros Acessórios de Vestuário",
    "Other Bags & Accessories": "Outras Bolsas e Acessórios",
    "Other Jewalry": "Outras Jóias",
    "Other Kid's Bags": "Outras Bolsas Infantis",
    "Outdoor Backpack": "Mochila para Exterior",
    "Outdoor Bags": "Bolsas para Exterior",
    "Outdoor Belts": "Cintos para Exterior",
    "Outdoor cooler": "Resfriador Portátil",
    "Outdoor Drainage": "Drenagem Externa",
    "Outdoor Furniture": "Móveis Externos",
    "Outdoor Heaters": "Aquecedores Externos",
    "Outdoor Sandals": "Sandálias Externas",
    "Outerwear": "Roupa Externa",
    "Outerwears": "Roupas Externas",
    "Over Knee": "Acima do Joelho",
    "Oxfords": "Oxfords",
    "Pacifiers": "Chupetas",
    "Packing": "Embalagem",
    "Packing Box": "Caixa de Embalagem",
    "Padlocks": "Cadeados",
    "Painting By Numbers": "Pintura por Números",
    "Painting Canva": "Tela de Pintura",
    "Painting Supplies & Wall Treatments": "Suprimentos de Pintura e Revestimento de Parede",
    "Pajama Sets": "Conjuntos de Pijama",
    "Palette": "Paleta",
    "Panoramic Camera": "Câmera Panorâmica",
    "Pant Sets": "Conjuntos de Calça",
    "Panties": "Calcinhas",
    "Pants": "Calças",
    "Paper": "Papel",
    "Paper Holder": "Porta-Papel",
    "Paracord": "Corda Paracord",
    "Parkas": "Parkas",
    "Parking Lock": "Trava de Estacionamento",
    "Part Lace Wigs": "Perucas com Parte de Renda",
    "Party Dresses": "Vestidos de Festa",
    "Party Games": "Jogos de Festa",
    "Party Supplies": "Suprimentos para Festas",
    "Party Wigs": "Perucas de Festa",
    "Patio Umbrellas & Bases": "Sombrinhas e Bases para Pátio",
    "PC Power Supplies": "Fontes de Alimentação para PC",
    "Pearl": "Pérola",
    "Pearl Necklace": "Colar de Pérolas",
    "Peephole": "Olho Mágico",
    "Pen Cap": "Tampa de Caneta",
    "Pen Head": "Cabeça da Caneta",
    "Pencil Case": "Estojo de Lápis",
    "Pencil Pants": "Calças Lápis",
    "Pencil Pot": "Lata de Lápis",
    "Personal Care Appliances": "Eletrodomésticos de Cuidado Pessoal",
    "Pet Supplies": "Suprimentos para Animais de Estimação",
    "Phone Cases": "Capas para Telefone",
    "Phone Repair Tools": "Ferramentas de Reparo para Telefone",
    "Phones & Telecommunications": "Telefones e Telecomunicações",
    "Phones Accessories": "Acessórios para Telefones",
    "Phones Parts": "Peças para Telefones",
    "Photo Albums": "Álbuns de Fotos",
    "Photo Studio Kits": "Kits de Estúdio Fotográfico",
    "Picture Card": "Cartão de Imagem",
    "Piexi Cut Wigs": "Perucas com Corte Pixie",
    "Pigment": "Pigmento",
    "Pillow Shoulder Bag": "Bolsa de Ombro em Formato de Travesseiro",
    "Plaid Scarves": "Echarpes Xadrez",
    "Plain Shirt": "Camisa Lisa",
    "Play Mats": "Tapetes de Brincar",
    "Playing Cards": "Baralhos de Cartas",
    "Plumbing": "Encanamento",
    "Plumbing Hoses": "Mangueiras de Encanamento",
    "Plus Size Down Coats": "Casacos de Penas Plus Size",
    "Plus Size Dresses": "Vestidos Plus Size",
    "Plus Size Matching Sets": "Conjuntos Combinados Plus Size",
    "Plus Size Outwears": "Roupas Externas Plus Size",
    "Plus Size Panties": "Calcinhas Plus Size",
    "Plus Size Swimwears": "Roupas de Banho Plus Size",
    "Plus Size Tops": "Blusas Plus Size",
    "Plus Size Wedding Dress": "Vestido de Noiva Plus Size",
    "Pneumatic Parts": "Peças Pneumáticas",
    "Pointed Toe": "Bico Fino",
    "Polarized Sunglasses": "Óculos de Sol Polarizados",
    "Polisher": "Polidora",
    "Polo Shirts": "Camisas Polo",
    "Pools & Water Activities": "Piscinas e Atividades Aquáticas",
    "Portable Television": "Televisão Portátil",
    "Portable Washing Machine": "Máquina de Lavar Portátil",
    "Portfolio": "Portfólio",
    "Postcard": "Cartão Postal",
    "Poster": "Pôster",
    "Power Banks": "Bancos de Energia",
    "Power Filters": "Filtros de Energia",
    "Power Supplies": "Fontes de Alimentação",
    "Power Transmission Parts": "Peças de Transmissão de Energia",
    "Pre-Order": "Pré-venda",
    "Prescription Glasses": "Óculos de Grau",
    "Pressure Cookers": "Panelas de Pressão",
    "Priest Uniforms": "Uniformes de Padre",
    "Print Sweater": "Suéter Estampado",
    "Print Waist Pack": "Pochete Estampada",
    "Printed Shirt": "Camisa Estampada",
    "Programmable Toys": "Brinquedos Programáveis",
    "Prom Dresses": "Vestidos de Formatura",
    "Pullovers": "Suéteres",
    "Pump Accessories": "Acessórios para Bombas",
    "Pumps": "Bombas",
    "Puzzles": "Quebra-Cabeças",
    "Quartz Watches": "Relógios de Quartzo",
    "Quick Dry Towel": "Toalha de Secagem Rápida",
    "Quilts": "Edredons",
    "Quinceanera Dresses": "Vestidos de Quinceañera",

    "Racing Boats & Kayaking": "Barcos de Corrida e Caiaque",
    "Racing Drones": "Drones de Corrida",
    "Racquet Sports": "Esportes com Raquete",
    "Rail Systems": "Sistemas Ferroviários",
    "Rain Boots": "Botas de Chuva",
    "RC Airplanes": "Aviões RC",
    "RC Boats": "Barcos RC",
    "RC Motorcycles": "Motocicletas RC",
    "RC Stunt Cars": "Carros RC de Manobra",
    "RC Trains": "Trens RC",
    "Rear Bumper Lights Assembly": "Conjunto de Luzes do Para-choque Traseiro",
    "Reborn Dolls": "Bonecas Reborn",
    "Relaxation Treatment": "Tratamento de Relaxamento",
    "Remote Control Toys": "Brinquedos de Controle Remoto",
    "Replacement Parts": "Peças de Reposição",
    "Reptiles & Amphibians": "Répteis e Anfíbios",
    "Resin DIY": "Resina Faça Você Mesmo",
    "Resistance Bands": "Faixas Elásticas de Resistência",
    "Respirator": "Respirador",
    "Restaurant Tables": "Mesas para Restaurante",

    "Ring Clip": "Clipe de Anel",
    "Ripped Jeans": "Jeans Rasgados",
    "Rom Strap Shoes": "Sapatos com Tiras Romanas",
    "Round Toe": "Bico Redondo",
    "Rugged Smartphones": "Smartphones Resistentes",

    "Safes": "Cofres",
    "Safety Short Pants": "Shorts de Segurança",
    "Sandals": "Sandálias",
    "Sander": "Lixadeira",
    "Sashes": "Faixas",
    "Scarves & Gloves": "Cachecóis e Luvas",
    "School Supplies": "Material Escolar",
    "Scouting Uniforms": "Uniformes de Escoteiro",
    "Screen Protectors": "Películas Protetoras de Tela",

    "Sculptures & Figurine": "Esculturas e Figuras",
    "Sculptures & Figurines": "Esculturas e Figuras",
    "Seamless Bras": "Sutiãs Sem Costura",
    "Security & Protection": "Segurança e Proteção",
    "Self Defense": "Autodefesa",
    "Sets": "Conjuntos",
    "Sexy Panties": "Calcinhas Sensuais",
    "Shapers": "Modeladores",
    "Sharpener": "Apontador",
    "Sheet Sets": "Conjuntos de Lençóis",
    "Shelter": "Abrigo",

    "Shirt jacket": "Jaqueta Camisa",
    "Shirts": "Camisas",
    "Shirts & Blouses": "Camisas e Blusas",
    "Shock Absorbers": "Amortecedores",

    "Shoe Accessories": "Acessórios para Calçados",
    "Shoe Care Kit": "Kit de Cuidados para Calçados",
    "Shoe Decorations": "Decorações para Calçados",
    "Shoe Dryer": "Secador de Calçados",
    "Shoe Polishes": "Polidores para Calçados",
    "Shoelaces": "Cadarços",
    "Shoes": "Calçados",
    "Shoes Covers": "Capas para Calçados",

    "Shopping Bag": "Bolsa de Compras",
    "Short Down Coats": "Casacos Curtos de Plumas",
    "Short Down lacket": "Jaqueta Curta de Plumas",
    "Short Dresses": "Vestidos Curtos",
    "Short Sets": "Conjuntos Curtos",
    "Shorts": "Shorts",
    "Shoulder Bags": "Bolsas de Ombro",

    "Shower System": "Sistema de Chuveiro",
    "Signal Lamp Assemblies": "Conjuntos de Lâmpadas de Sinalização",

    "Silk Base Lace Wigs": "Perucas de Renda com Base de Seda",
    "Silk Scarves": "Lenços de Seda",
    "Silk Scarves & Ribbons": "Lenços e Fitas de Seda",

    "Silver 925": "Prata 925",
    "Silver Bracelet": "Pulseira de Prata",
    "Silver Earring": "Brinco de Prata",
    "Silver Necklace": "Colar de Prata",

    "Single Breasted Suits": "Ternos de Um Botão",
    "Sit Up Benches": "Bancos para Abdominais",
    "Skateboard": "Skate",
    "Sketch": "Esboço",
    "Skirts": "Saias",

    "Sleep & Lounge": "Dormir e Relaxar",
    "Sleeping Bags": "Sacos de Dormir",
    "Sleepwear": "Roupas de Dormir",

    "Slim Jeans": "Jeans Slim",
    "Small Animals": "Animais Pequenos",

    "Smart Bathroom": "Banheiro Inteligente",
    "Smart Curtains": "Cortinas Inteligentes",
    "Smart Dimmers": "Dimmers Inteligentes",
    "Smart Electronics": "Eletrônicos Inteligentes",
    "Smart Home": "Casa Inteligente",
    "Smart Remote Controls": "Controles Remotos Inteligentes",
    "Smart Smoke Detectors": "Detectores de Fumaça Inteligentes",
    "Smart Switches": "Interruptores Inteligentes",
    "Smart Thermostats": "Termostatos Inteligentes",
    "Smart Watches": "Relógios Inteligentes",
    "Smart Water Heaters": "Aquecedores de Água Inteligentes",
    "Smartphone 5g": "Smartphone 5G",
    "Smartphone Android": "Smartphone Android",
    "Sneaker": "Tênis",
    "Snooker & Billiard Accessories": "Acessórios para Sinuca e Bilhar",
    "Snow Boots": "Botas de Neve",
    "Snowmobile Gears": "Equipamentos para Motos de Neve",
    "Soccer Tables": "Mesas de Futebol",
    "Socks": "Meias",
    "Socks & Leg Warmers": "Meias e Polainas",
    "Soft Plastic Blocks": "Blocos de Plástico Macio",
    "Solar Inverters": "Inversores Solares",
    "Solar Panels": "Painéis Solares",
    "Solar Water Heaters": "Aquecedores Solares de Água",
    "Solid Color Scarves": "Echarpes de Cor Lisa",
    "Sound Cards": "Placas de Som",
    "Special Occasion Costume": "Fantasia para Ocasiões Especiais",
    "Special Occasion Dresses": "Vestidos para Ocasiões Especiais",
    "Spectrum Analyzers": "Analisadores de Espectro",
    "Spinning Top": "Pião",
    "Sport Hoops": "Aros Esportivos",
    "Sport Waist Pack": "Pochete Esportiva",
    "Sports & Entertainment": "Esportes e Entretenimento",
    "Sports & Outdoor Activities": "Esportes e Atividades ao Ar Livre",
    "Sports Suits": "Conjuntos Esportivos",
    "Sports Video Cameras": "Câmeras Esportivas",
    "Sports Video Cameras Accessories": "Acessórios para Câmeras Esportivas",
    "Spray Gun": "Pistola de Pintura",
    "Spy Family": "Família de Espiões",
    "Square Bag": "Bolsa Quadrada",
    "Stamp": "Selo",
    "Stamps Toys": "Brinquedos de Selos",
    "Stand Fan": "Ventilador de Coluna",
    "Stapler": "Grampeador",
    "Stationary": "Papelaria",
    "Steam Cleaner": "Limpador a Vapor",
    "Steering Covers": "Capas para Volante",
    "Steppers": "Step",
    "Sticker Book": "Livro de Adesivos",
    "Stickers": "Adesivos",
    "Stickers & Poster": "Adesivos e Pôsteres",
    "Sticky Notes": "Blocos Autoadesivos",
    "Stockings": "Meias-Calças",
    "Stowing Tidying": "Organização e Armazenamento",
    "Straight Pants": "Calças Retas",
    "Strapless Bras": "Sutiãs sem Alça",
    "Street Dance": "Dança Urbana",
    "Strength Training": "Treinamento de Força",
    "Striped Sweater": "Suéter Listrado",
    "Suit jackets": "Blazers",
    "Suit Pants": "Calças de Terno",
    "Suits": "Ternos",
    "Sun Hats": "Chapéus de Sol",
    "Sun Loungers": "Espreguiçadeiras",
    "Sunglasses": "Óculos de Sol",
    "Sunshades": "Sombrite e Toldos",
    "Super-High Heel": "Salto Super Alto",
    "Surfboard & Paddleboards": "Pranchas de Surfe e Stand Up Paddle",
    "Surfing & Beach Shorts": "Bermudas de Surfe e Praia",
    "Surfing & Kayaking": "Surfe e Caiaque",
    "Surfing Accessories": "Acessórios para Surfe",
    "Sweater Matching Sets": "Conjuntos de Suéter",
    "Sweater Vest": "Colete de Suéter",
    "Sweaters": "Suéteres",
    "Sweatpants": "Calças de Moletom",
    "Swimming Pools": "Piscinas",
    "Swimswears": "Roupas de Banho",
    "Synthetic Chignon": "Coque Sintético",
    "Synthetic Hair Lace": "Cabelo Sintético com Renda",
    "Synthetic Ponytails": "Rabos de Cavalo Sintéticos",
    "Table Decoration & Accessories": "Decoração e Acessórios de Mesa",
    "Table Linens": "Roupas de Mesa",
    "Table Tennis": "Tênis de Mesa",
    "Tap Dance": "Sapateado",
    "Tapered jeans": "Jeans Afunilados",
    "Tapestries": "Tapeçarias",
    "Tattoo & Body Art": "Tatuagem e Arte Corporal",
    "Tattoo Grips": "Empunhaduras para Tatuagem",
    "Tattoo Inks": "Tintas para Tatuagem",
    "Tattoo Kits": "Kits de Tatuagem",
    "Tattoo Machines": "Máquinas de Tatuagem",
    "Tattoo Needles": "Agulhas para Tatuagem",
    "Tattoo Power Supplies": "Fontes de Alimentação para Tatuagem",
    "Teeth Whitening Instrument": "Aparelho para Clareamento Dental",
    "Temperature Humidity Instruments": "Instrumentos de Temperatura e Umidade",
    "Temperature Sensor": "Sensor de Temperatura",
    "Tennis": "Tênis",
    "Terrarium Bedding, Sands & Substrates": "Forrações, Areias e Substratos para Terrário",
    "Terrarium Bowls": "Recipientes para Terrário",
    "Terrarium Heat Lamps & Mats": "Lâmpadas e Tapetes de Aquecimento para Terrário",
    "Test Tube": "Tubo de Ensaio",
    "Theodolites": "Teodolitos",

    "Thermal Underwear": "Roupa Íntima Térmica",
    "Thread Bracelet": "Pulseira de Linha",
    "Tie Clips & Cufflinks": "Prendedores de Gravata e Abotoaduras",
    "Ties": "Gravatas",
    "Tig Welders": "Soldadores TIG",
    "Tights": "Meias-Calças",
    "Tire Repair Tools": "Ferramentas para Reparo de Pneus",
    "Tires": "Pneus",
    "Titanium Frames": "Armações de Titânio",
    "Tools": "Ferramentas",
    "Tools & Industrial": "Ferramentas e Equipamentos Industriais",
    "Toothbrushes Head": "Cabeças de Escova de Dentes",
    "Top Hats": "Cartolas",
    "Tops": "Blusas",
    "Toupee": "Peruca Masculina",
    "Towel": "Toalha",
    "Toy Balls": "Bolas de Brinquedo",
    "Toy Cameras": "Câmeras de Brinquedo",
    "Toy Guns": "Armas de Brinquedo",
    "Toy Musical Instrument": "Instrumentos Musicais de Brinquedo",
    "Toy Sports": "Brinquedos Esportivos",
    "ToyS": "Brinquedos",
    "Toys": "Brinquedos",
    "Toys & Games": "Brinquedos e Jogos",
    "Training Head Kit": "Kit de Cabeça para Treinamento",
    "Trampolines": "Camas Elásticas",
    "Transformer Robot": "Robô Transformável",
    "Translator": "Tradutor",
    "Travel Bag": "Bolsa de Viagem",
    "Travel Bags & Luggage": "Bolsas e Malas de Viagem",
    "Travel Wallets": "Carteiras de Viagem",
    "Treadmills": "Esteiras",
    "Trench": "Trench Coat",
    "Trendy Claw Clips": "Presilhas de Garra da Moda",
    "Trendy Hair Clips": "Presilhas de Cabelo da Moda",
    "Trendy Sunglasses": "Óculos de Sol da Moda",
    "Trendy Wigs": "Perucas da Moda",
    "Turbos, Nitrous & Superchargers": "Turbos, Óxido Nitroso e Superchargers",
    "Turning Tool": "Ferramenta de Torneamento",
    "Turtleneck": "Gola Alta",
    "Turtlenecks": "Blusas de Gola Alta",
    "U-Part Wigs": "Perucas com Parte em U",
    "Ukulele": "Ukulele",
    "Ultrasonic Cleaner": "Limpador Ultrassônico",
    "Ultrasonic Scaler": "Removedor Ultrassônico",
    "Undershirts": "Camisetas Internas",
    "Used Phones": "Celulares Usados",
    "Utensils": "Utensílios",
    "Vacuum Mite Remover": "Removedor de Ácaros a Vácuo",
    "Valves": "Válvulas",
    "Vents": "Ventiladores",
    "Vest": "Colete",
    "Vests & Waistcoats": "Coletes e Coletes Sociais",
    "Video Game Consoles": "Consoles de Videogame",
    "Video Intercom": "Interfone com Vídeo",
    "Access Control": "Controle de Acesso",
    "Access Control Cards": "Cartões de Controle de Acesso",
    "Access Control Kits": "Kits de Controle de Acesso",
    "Accessories": "Acessórios",
    "Accessories & Others": "Acessórios e Outros",
    "Accessories & Parts": "Acessórios e Peças",
    "Acetate Frames": "Armações de Acetato",
    "Action & Toy Figures": "Figuras de Ação e Brinquedos",
    "Action Figure": "Figura de Ação",
    "Active Bras": "Sutiãs Esportivos",
    "Activity & Gear": "Atividades e Equipamentos",
    "Add On Cards & Controller Panels": "Placas Adicionais e Painéis de Controle",
    "Adhesive Paper": "Papel Adesivo",
    "Adhesives": "Adesivos",
    "Advanced Storage & RAM": "Armazenamento Avançado e Memória RAM",
    "Africa Clothing": "Roupas Africanas",
    "African American Wigs": "Perucas Afro-Americanas",
    "Air Cooler": "Climatizador de Ar",
    "Air Intake & Fuel Delivery": "Admissão de Ar e Alimentação de Combustível",
    "Air Intake Systems": "Sistemas de Admissão de Ar",
    "Air Purifier": "Purificador de Ar",
    "Air Quality": "Qualidade do Ar",
    "Alarm Sensor": "Sensor de Alarme",
    "Alarm System Kit": "Kit de Sistema de Alarme",
    "Animal Figure": "Figura de Animal",
    "Animal Print Shoulder Bag": "Bolsa de Ombro com Estampa Animal",
    "Ankle Boots": "Botas de Cano Curto",
    "Anti-Theft Backpack": "Mochila Antifurto",
    "Apparels": "Vestuário",
    "Aquarium Accessories & Equipment": "Acessórios e Equipamentos para Aquário",
    "Aquarium Decors": "Decorações para Aquário",
    "Aquarium Lights": "Iluminação para Aquário",
    "Aquarium Pumps & Filters": "Bombas e Filtros para Aquário",
    "Aquariums & Fish Bowls": "Aquários e Tigelas para Peixes",
    "Art Supplies": "Materiais de Arte",
    "Artificial Flower": "Flor Artificial",
    "Asia & Pacific Islands Clothing": "Roupas da Ásia e Ilhas do Pacífico",
    "ATV & UTV Accessories": "Acessórios para ATV e UTV",
    "Auto Fasteners & Clips": "Fixadores e Clipes Automotivos",
    "Automatic Feeders": "Alimentadores Automáticos",
    "Automatic Irrigation Equipment": "Equipamentos de Irrigação Automática",
    "Automatic Irrigation System": "Sistema de Irrigação Automática",
    "Automation Kits": "Kits de Automação",
    "Automobile Filter": "Filtro Automotivo",
    "Automotive & Motorcycle": "Automotivo e Motocicletas",
    "Aviator jacket": "Jaqueta Aviador",
    "Axe": "Machado",
    "Babies & Kids": "Bebês e Crianças",
    "Baby & Kids' Floats": "Boias para Bebês e Crianças",
    "Baby Bottoms": "Roupas Inferiores para Bebê",
    "Baby Care": "Cuidados com o Bebê",
    "Baby Care Tools": "Acessórios para Cuidados com o Bebê",
    "Baby Clothing": "Roupas para Bebê",
    "Baby Cribs": "Berços",
    "Baby Dresses": "Vestidos para Bebê",
    "Baby Food Mills": "Trituradores de Alimentos para Bebê",
    "Baby Food Storage": "Armazenamento de Alimentos para Bebê",
    "Baby Health Care": "Cuidados com a Saúde do Bebê",
    "Baby Monitor": "Babá Eletrônica",
    "Baby Pillow & Cases": "Travesseiros e Capas para Bebê",
    "Baby Playpens": "Cercadinhos para Bebê",
    "Baby Seats & Sofas": "Assentos e Sofás para Bebê",
    "Baby Shoes": "Calçados para Bebê",
    "Baby Soap": "Sabonete para Bebê",
    "Baby Swimwears": "Roupas de Banho para Bebê",
    "Baby Toothbrushes": "Escovas de Dente para Bebê",
    "Baby Tops": "Blusas para Bebê",
    "Baby Wet Wipes": "Lenços Umedecidos para Bebê",
    "Backpacks": "Mochilas",
    "Backpacks & Carriers": "Mochilas e Cangurus",
    "Badminton": "Badminton",
    "Bag Accessories": "Acessórios para Bolsas",
    "Baggy Jeans": "Jeans Largos",
    "Baggy Pants": "Calças Largas",
    "Bags": "Bolsas",
    "Bagutte Bag": "Bolsa Baguete",
    "Bandanas & Nightcaps": "Bandanas e Toucas de Dormir",
    "Bangs": "Franja",
    "Bar Stools": "Banquetas de Bar",
    "Bar Tables": "Mesas de Bar",
    "Barebone & Mini Pc": "Barebone e Mini PC",
    "Baseball Caps": "Bonés de Beisebol",
    "Baseball Uniform": "Uniforme de Beisebol",
    "Basket": "Cesta",
    "Bath Toys": "Brinquedos de Banho",
    "Bathroom": "Banheiro",
    "Bathroom Fixtures": "Louças para Banheiro",
    "Bathroom Hardwares": "Ferragens para Banheiro",
    "Bathroom Sinks": "Pias para Banheiro",
    "Bathtub Faucets": "Torneiras para Banheira",
    "Bathtubs & Accessories": "Banheiras e Acessórios",
    "Batteries": "Baterias",
    "Beach Chairs": "Cadeiras de Praia",
    "Beach Sand Toys": "Brinquedos de Areia para Praia",
    "Beaded Necklace": "Colar de Contas",
    "Beard": "Barba",
    "Beauty & Health": "Beleza e Saúde",
    "Bed Linens": "Roupas de Cama",
    "Bedding Basics": "Itens Básicos de Cama",
    "Bedding Sets": "Conjuntos de Roupa de Cama",
    "Bedroom": "Quarto",
    "Bedroom Furniture": "Móveis para Quarto",
    "Beds & Furnitures": "Camas e Móveis",
    "Bedspreads & Coverlets": "Colchas e Cobre-leitos",
    "Belly Button Ring": "Piercing no Umbigo",
    "Belly Dancing": "Dança do Ventre",
    "Belt Accessories": "Acessórios para Cintos",
    "Belts": "Cintos",
    "Bending Machinery": "Máquinas de Dobra",
    "Bespoke Occasion Dresses": "Vestidos Sob Medida para Ocasiões",
    "Bespoke Wedding Dress": "Vestido de Noiva Sob Medida",
    "Bicycle Bottle Holder": "Suporte para Garrafa de Bicicleta",
    "Bicycle Protective Gear": "Equipamentos de Proteção para Bicicleta",
    "Bicycle Sticker": "Adesivo para Bicicleta",
    "Bikinis Sets": "Conjuntos de Biquíni",
    "Binder Paper": "Papel para Encadernação",
    "Bird Diapers": "Fraldas para Aves",
    "Birdcage Accessories": "Acessórios para Gaiolas de Aves",
    "Birds": "Aves",
    "Birthday & Balloon": "Festas de Aniversário e Balões",
    "BJD Dolls": "Bonecas BJD",
    "Blankets & Swaddles": "Mantas e Cueiros",
    "Blazer & Suits": "Blazers e Ternos",
    "Blazers": "Blazers",
    "Blocks": "Blocos",
    "Blue Light Blocking Glasses": "Óculos com Filtro de Luz Azul",
    "Board Card": "Placa de Circuito",
    "Board Game": "Jogo de Tabuleiro",
    "Board Shorts": "Bermudas de Surf",
    "Boat Accessories": "Acessórios para Barcos",
    "Boat Shoes": "Sapatos Náuticos",
    "Body & Frames": "Corpo e Estrutura",
    "Body Jewelry": "Joias Corporais",
    "Body Shaping Massage Equipment": "Equipamentos de Massagem Modeladora",
    "Body Worn Camera": "Câmera Corporal",
    "Bodychain": "Corrente Corporal",
    "Bodysuits": "Bodies",
    "Book Cover": "Capa de Livro",
    "Boots": "Botas",
    "Boston Bag": "Bolsa Boston",
    "Bottles": "Garrafas",
    "Bottoms": "Peças Inferiores",
    "Boxers & Briefs": "Cuecas Boxer e Slip",
    "Boxes": "Caixas",
    "Bracelet & Bangles": "Pulseiras e Braceletes",
    "Bras": "Sutiãs",
    "Breifcases": "Pastas Executivas",
    "Briefs": "Cuecas Slip",
    "Brooches": "Broches",
    "Brushed jeans": "Jeans Escovados",
    "Bucket Bag": "Bolsa Saco",
    "Bug Zappers": "Mata-Insetos Elétricos",
    "Building & Construction Toys": "Brinquedos de Construção",
    "Bulletproof Protection": "Proteção Balística",
    "Bumpers": "Para-choques",
    "Business Backpack": "Mochila Executiva",
    "Business Garment Bag": "Capa para Roupas Executivas",
    "Business Shoes": "Calçados Sociais",
    "Business Supplies": "Suprimentos para Escritório",
    "Bustiers & Corsets": "Bustiês e Espartilhos",
    "Cable Winder": "Organizador de Cabos",
    "Cables Assemblies": "Conjuntos de Cabos",
    "Cages & Accessories": "Gaiolas e Acessórios",
    "Camcorders": "Filmadoras",
    "Camera & Photo": "Câmeras e Fotografia",
    "Camera Power": "Fontes de Energia para Câmeras",
    "Camisoles & Tanks": "Camisolas e Regatas",
    "Camping": "Camping",
    "Camping Cookware": "Utensílios de Cozinha para Camping",
    "Camping Light": "Iluminação para Camping",
    "Camping Trolley": "Carrinho para Camping",
    "Candle Making": "Fabricação de Velas",
    "Candles & Holders": "Velas e Suportes",
    "Canvas": "Lona",
    "Canvas Shoulder Bag": "Bolsa de Ombro em Lona",
    "Canvas Waist Pack": "Pochete de Lona",
    "Car Body Films": "Películas para Carroceria",
    "Car Body Repair Tools": "Ferramentas para Reparo de Carroceria",
    "Car Covers": "Capas para Carro",
    "Car Disassembly Tools": "Ferramentas para Desmontagem Automotiva",
    "Car DVR": "Câmera Veicular (DVR)",
    "Car Electrical Appliances": "Eletrodomésticos Automotivos",
    "Car Electronic Accessories": "Acessórios Eletrônicos Automotivos",
    "Car Electronics": "Eletrônicos Automotivos",
    "Car Headlight Assembly": "Conjunto de Farol Automotivo",
    "Car Headlight Bulbs": "Lâmpadas de Farol",
    "Car Intelligent Systems": "Sistemas Inteligentes Automotivos",
    "Car Jacks & Lifting Equipment": "Macacos e Equipamentos de Elevação",
    "Car Light Assemblies": "Conjuntos de Iluminação Automotiva",
    "Car Lights": "Luzes Automotivas",
    "Car Repair Tools": "Ferramentas para Reparo Automotivo",
    "Car Seat Covers": "Capas para Bancos de Carro",
    "Car Stickers": "Adesivos Automotivos",
    "Card Cutter": "Cortador de Cartões",
    "Cardigan": "Cardigã",
    "Cardigans": "Cardigãs",
    "Cardio Training": "Treino Cardiovascular",
    "Cargo Shirt": "Camisa Cargo",
    "Cargo Shorts": "Bermudas Cargo",
    "Carriers": "Transportadores",
    "Carriers & Strollers": "Cangurus e Carrinhos de Bebê",
    "Carry-Ons Luggage": "Bagagem de Mão",
    "Case": "Estojo / Caixa",
    "Cashmere Wool Scarves": "Cachecóis de Lã Cashmere",
    "Casual Business": "Executivo Casual",
    "Casual Pants": "Calças Casuais",
    "Casual Shoes": "Calçados Casuais",
    "Casual Sneaker": "Tênis Casual",
    "Cat Doors, Steps, Nets & Pens": "Portas, Degraus, Redes e Cercados para Gatos",
    "Cats": "Gatos",
    "CD Cases": "Capas para CD",
    "CD Racks": "Suportes para CDs",
    "Ceramics & Pottery": "Cerâmica e Olaria",
    "Chain Bag": "Bolsa com Corrente",
    "Chain Bracelet": "Pulseira de Corrente",
    "Chain Waist Pack": "Pochete com Corrente",
    "Chains": "Correntes",
    "Chair Leg Cove!": "Protetor para Pernas de Cadeira",
    "Chaise Lounges": "Chaises Reclináveis",
    "Charger Cable": "Cabo de Carregamento",
    "Charms": "Pingentes",
    "Cheongsams": "Qipao (Vestido Chinês)",
    "Children's Bookcases": "Estantes Infantis",
    "Children's Flats": "Sapatilhas Infantis",
    "Children's Shoes": "Calçados Infantis",
    "Chinese Folk Dance": "Dança Folclórica Chinesa",
    "Chinese Style": "Estilo Chinês",
    "Christmas Supplies": "Artigos de Natal",
    "Clamp Clip": "Clipe de Fixação",
    "Clamp Holder": "Suporte com Presilha",
    "Clamps": "Grampos",
    "Clarinet": "Clarinete",
    "Classical Dance Costume": "Fantasia de Dança Clássica",
    "Cleaning Appliances": "Eletrodomésticos de Limpeza",
    "Clearance Lights Assembly": "Conjunto de Luzes de Posição",
    "Clothes": "Roupas",
    "Clip-In Extensions": "Extensões de Cabelo com Clipe",
    "Cloth Dryer": "Secadora de Roupas",
    "Coffee Grinders": "Moedores de Café",
    "Coffee Tables": "Mesas de Centro",
    "Cold Room Systems": "Sistemas de Câmara Fria",
    "Collars, Harnesses & Leashes": "Coleiras, Peitorais e Guias",
    "Communications": "Comunicações",
    "Communications Antennas": "Antenas de Comunicação",
    "Computer Components": "Componentes de Computador",
    "Computer Desks": "Mesas para Computador",
    "Computer,Office & Education": "Computadores, Escritório e Educação",
    "Conference Tables": "Mesas de Reunião",
    "Connectors": "Conectores",
    "Consumer Electronics": "Eletrônicos de Consumo",
    "Control Panties": "Calcinhas Modeladoras",
    "Cooler Bag": "Bolsa Térmica",
    "Cooling Systems": "Sistemas de Refrigeração",
    "Cosmetic Bag & Case": "Necessaire e Estojos de Cosméticos",
    "Cosplay Costumes": "Fantasias de Cosplay",
    "Cotton Linen Shirt": "Camisa de Algodão e Linho",
    "Cotton Linen Shorts": "Bermuda de Algodão e Linho",
    "Cover-Ups": "Saídas de Praia",
    "Cow Mastitis Detectors": "Detectores de Mastite Bovina",
    "Cradles": "Berços",
    "Craft Toys": "Brinquedos Artesanais",
    "Crates, Houses & Pens": "Caixas, Casinhas e Cercados",
    "Credit Card Holder": "Porta-Cartões",
    "Curly Wigs": "Perucas Cacheadas",
    "Curve & Plus Size": "Moda Curve e Plus Size",
    "Cushions": "Almofadas",
    "Cycling": "Ciclismo",
    "Cycling Bib Short": "Bermuda de Ciclismo com Bretelle",
    "Cycling Sunglasses": "Óculos para Ciclismo",
    "Cycling Vest": "Colete de Ciclismo",
    "Dancewear": "Roupas de Dança",
    "Decorative Mirrors": "Espelhos Decorativos",
    "Deep Wave Wigs": "Perucas Onduladas Profundas",
    "Dehumidifier": "Desumidificador",
    "Demon Slayer": "Demon Slayer (Kimetsu no Yaiba)",
    "Denim Jacket": "Jaqueta Jeans",
    "Denim Shirt": "Camisa Jeans",
    "Denim Shorts": "Bermuda Jeans",
    "Denim Shoulder Bag": "Bolsa de Ombro Jeans",
    "Densitometers": "Densitômetros",
    "Dental Chair Cover": "Capa para Cadeira Odontológica",
    "Dental Consumable": "Consumíveis Odontológicos",
    "Dental Drills & Brush": "Brocas e Escovas Odontológicas",
    "Dental Grill": "Grillz Dental",
    "Dental Supplies": "Materiais Odontológicos",
    "Dentist Seat": "Banco Odontológico",
    "Derby Shoes": "Sapatos Derby",
    "Desktops": "Computadores de Mesa",
    "Desktops & AIO": "Computadores de Mesa e All-in-One",
    "Diagnostic Tools": "Ferramentas de Diagnóstico",
    "Diamond Painting": "Pintura com Diamantes",
    "Diaper Bags": "Bolsas para Fraldas",
    "Dice": "Dados",
    "Diffuser Aromatherapy": "Difusor de Aromaterapia",
    "Digital Cameras": "Câmeras Digitais",
    "Digital Watches": "Relógios Digitais",
    "Dining Chairs": "Cadeiras de Jantar",
    "Dining Room": "Sala de Jantar",
    "Dining Room Furniture": "Móveis para Sala de Jantar",
    "Dining Room Sets": "Conjuntos para Sala de Jantar",
    "Dining Tables": "Mesas de Jantar",
    "DIY Bags": "Bolsas Faça Você Mesmo (DIY)",
    "DIY Accessories": "Acessórios Faça Você Mesmo (DIY)",
    "DIY Gaming Computer": "Computador Gamer Montável (DIY)",
    "Dogs": "Cães",
    "Doll Houses": "Casas de Boneca",
    "Dolls": "Bonecas",
    "Dolls & Accessories": "Bonecas e Acessórios",
    "Dolls Accessories": "Acessórios para Bonecas",
    "Domino": "Dominó",
    "Door Remote Controls": "Controles Remotos para Portões",
    "Door Screen": "Tela Mosquiteira para Porta",
    "Doorbell": "Campainha",
    "Double Breasted Suits": "Ternos de Abotoamento Duplo",
    "Down Coats": "Casacos de Pluma",
    "Down Jackets": "Jaquetas de Pluma",
    "Drawing": "Desenho",
    "Drawing Tablet": "Mesa Digitalizadora",
    "Drawing Toys": "Brinquedos de Desenho",
    "Drawstring Bag": "Bolsa com Cordão",
    "Dress Sets": "Conjuntos de Vestido",
    "Dressers": "Cômodas",
    "Dresses": "Vestidos",
    "Drop & Dangle Earring": "Brincos Pendentes",
    "Dropper": "Conta-gotas",
    "Drum": "Tambor",
    "Dumbbells": "Halteres",
    "Duvets": "Edredons",
    "Ear Piercing": "Piercing de Orelha",
    "Ear Protection": "Proteção Auricular",
    "Ear Tags": "Brincos de Identificação Animal",
    "Earbuds": "Fones de Ouvido Intra-auriculares",
    "earbuds": "Fones de Ouvido Intra-auriculares",
    "Earring Set": "Conjunto de Brincos",
    "Earrings": "Brincos",
    "Eas Kits": "Kits EAS (Antifurto)",
    "Easel": "Cavalete de Pintura",
    "Electric Beverage Warmer": "Aquecedor Elétrico de Bebidas",
    "Electric Cleaning Brush": "Escova Elétrica de Limpeza",
    "Electric Espresso Pots": "Cafeteiras Elétricas de Espresso",
    "Electric Fireplace": "Lareira Elétrica",
    "Electric Floor Mop": "Mop Elétrico",
    "Electric Heater": "Aquecedor Elétrico",
    "Electric Scooter": "Patinete Elétrico",
    "Electric Screwdriver": "Chave de Fenda Elétrica",
    "Electric Sweeper": "Vassoura Elétrica",
    "Electric Toothbrushes": "Escovas de Dente Elétricas",
    "Electric Water Heaters": "Aquecedores Elétricos de Água",
    "Electric Wrench": "Chave de Impacto Elétrica",
    "Electrical & Ignitions": "Sistema Elétrico e Ignição",
    "Electrical Equipment & Supplies": "Equipamentos e Materiais Elétricos",
    "Electronic Blocks": "Blocos Eletrônicos",
    "Electronic Mosquito Killer": "Repelente Eletrônico de Mosquitos",
    "Electronic Pets": "Pets Eletrônicos",
    "Electronic Toys": "Brinquedos Eletrônicos",
    "Electronic Watches": "Relógios Eletrônicos",
    "Emergency Kits & Defense": "Kits de Emergência e Defesa",
    "End Tables": "Mesas Laterais",
    "Endoscope Camera": "Câmera Endoscópica",
    "Engine Oil": "Óleo de Motor",
    "Engine Parts": "Peças de Motor",
    "Engines & Components": "Motores e Componentes",
    "Engines & Engine Parts": "Motores e Peças",
    "Entertainment": "Entretenimento",
    "European Clothing": "Moda Europeia",
    "EVA Slippers": "Chinelos de EVA",
    "Eve Massage Instrument": "Aparelho de Massagem",
    "Exercise Wheels": "Rodas de Exercício",
    "Exhaust Fan": "Exaustor",
    "Exhaust Systems": "Sistemas de Exaustão",
    "Exotic Pants": "Calças Estilo Exótico",
    "Exterior Accessories": "Acessórios Externos",
    "Eyeglass Lenses": "Lentes para Óculos",
    "Fabric & Lace": "Tecidos e Rendas",
    "Face Recognition Locks": "Fechaduras com Reconhecimento Facial",
    "Family Intelligence System": "Sistema Inteligente Residencial",
    "Fantasy Figurine": "Estatueta Fantástica",
    "Farm Animals": "Animais de Fazenda",
    "Fascia Gun": "Pistola de Massagem (Fáscia)",
    "Fashion Belts": "Cintos Fashion",
    "Fashion Quartz Wristwatches": "Relógios de Pulso de Quartzo Fashion",
    "Fashion Suits": "Ternos Fashion",
    "Fashionable Canes": "Bengalas Fashion",
    "Fasteners": "Fixadores",
    "Faucet Replacement Parts": "Peças de Reposição para Torneiras",
    "Feeding": "Alimentação",
    "Feeding & Watering Supplies": "Suprimentos para Alimentação e Hidratação",
    "Festive & Party Supplies": "Artigos Festivos e para Festa",
    "Fiber Optic Equipment": "Equipamentos de Fibra Óptica",
    "Filing & Binding Products": "Produtos para Arquivamento e Encadernação",
    "Filing Cabinets": "Arquivos e Gaveteiros",
    "Films & Instant Photo Paper": "Filmes e Papel Fotográfico Instantâneo",
    "Fingerprint Locks": "Fechaduras Biométricas",
    "Fireplaces & Stoves": "Lareiras e Fogões",
    "First Aid Kits": "Kits de Primeiros Socorros",
    "Fish & Aquatic Pets": "Peixes e Animais Aquáticos",
    "Fish Finders": "Localizadores de Peixes (Sonar)",
    "Fish Toe": "Sandália Peep Toe",
    "Fishing": "Pesca",
    "Fishing Bags": "Bolsas para Pesca",
    "Fishing Floats": "Boias de Pesca",
    "Fishing Jerseys": "Camisetas de Pesca",
    "Fishing Tools": "Ferramentas de Pesca",
    "Fitness Pedals": "Pedais para Exercícios",
    "Flamenco": "Flamenco",
    "Flashlight": "Lanterna",
    "Flat Sandals": "Sandálias Rasteiras",
    "Flats": "Calçados Sem Salto",
    "Flea & Tick Controls": "Controle de Pulgas e Carrapatos",
    "Flip Flops": "Chinelos",
    "Floor Heating Systems": "Sistemas de Aquecimento de Piso",
    "Floor Socks": "Meias Antiderrapantes",
    "Flute": "Flauta",
    "Fomer": "Espuma Moldável",
    "Food Service": "Serviço de Alimentação",
    "Formal Occasion Dresses": "Vestidos para Ocasiões Formais",
    "Four Wheel Electric Car": "Carro Elétrico de Quatro Rodas",
    "Fresh Air Ventilator": "Ventilador de Renovação de Ar",
    "Fuel Supply Systems": "Sistemas de Abastecimento de Combustível",
    "Fun Hats": "Chapéus Divertidos",
    "Fun Sunglasses": "Óculos de Sol Divertidos",
    "Funiture": "Móveis",
    "Funny Masks": "Máscaras Divertidas",
    "Fur Shoulder Bag": "Bolsa de Ombro em Pelúcia",
    "G-String": "Calcinha Fio Dental",
    "Game Collection Cards": "Cartas Colecionáveis de Jogos",
    "Game Deals": "Ofertas de Jogos",
    "Games & Accessories": "Jogos e Acessórios",
    "Gaming Hardware": "Hardware Gamer",
    "Gaming Keyboard": "Teclado Gamer",
    "Gaming Motherboard": "Placa-mãe Gamer",
    "Gaming Mouse": "Mouse Gamer",
    "Gaming PC Case": "Gabinete Gamer",
    "Garden & Balcony": "Jardim e Varanda",
    "Garden Buildings": "Estruturas para Jardim",
    "Garden Furniture Sets": "Conjuntos de Móveis para Jardim",
    "Garden Pots & Planters": "Vasos e Jardineiras",
    "Garden Shredder": "Triturador de Jardim",
    "Garden Water Timers": "Temporizadores de Irrigação",
    "Gardening Supplies": "Suprimentos para Jardinagem",
    "Gardening Tools": "Ferramentas de Jardinagem",
    "Garment Steamer": "Vaporizador de Roupas",
    "Gems": "Pedras Preciosas",
    "Genshin Impact": "Genshin Impact",
    "Genuine Leather Sandals": "Sandálias de Couro Genuíno",
    "Gift & Gift Bag": "Presentes e Sacolas para Presente",
    "Glasses": "Óculos",
    "Gloves & Handwear": "Luvas e Acessórios para as Mãos",
    "Glow Supplies": "Artigos Luminosos",
    "GPS & Accessories": "GPS e Acessórios",
    "GPS Accessories": "Acessórios para GPS",
    "GPS Tracker": "Rastreador GPS",
    "Graphics Cards": "Placas de Vídeo",
    "Grooming": "Cuidados Pessoais",
    "Guitar": "Guitarra",
    "Gym Shorts": "Shorts de Academia",
    "Gyms & Playmats": "Tapetes de Atividades e Brinquedos",
    "Habitat Decors": "Decoração para Habitat",
    "Habitat Lights": "Iluminação para Habitat",
    "Hair Bundles with Closures": "Mechas de Cabelo com Fechamento",
    "Hair Care": "Cuidados com o Cabelo",
    "Hair Dryer": "Secador de Cabelo",
    "Hair Dryers": "Secadores de Cabelo",
    "Hair Elastics & Ties": "Elásticos e Prendedores de Cabelo",
    "Hair Extensions": "Extensões de Cabelo",
    "Hair Extensions & Wigs": "Extensões de Cabelo e Perucas",
    "Hair jewelry": "Acessórios para Cabelo",
    "Hair Pieces": "Peças Capilares",
    "Hair Tools & Accessories": "Ferramentas e Acessórios para Cabelo",
    "Hair Toppers For Women": "Topper Capilar Feminino",
    "Hair Towel": "Toalha para Cabelo",
    "Hair Weaving": "Alongamento Capilar",
    "Hairnets": "Redes para Cabelo",
    "Hammocks": "Redes de Descanso",
    "Hand Dryer": "Secador de Mãos",
    "Hand Grips": "Fortalecedor de Mãos",
    "Hand Protection": "Proteção para as Mãos",
    "Hand Tools": "Ferramentas Manuais",
    "Hand Towel": "Toalha de Mão",
    "Hand Washer": "Lavatório",
    "Handbags": "Bolsas",
    "Handheld Game Players": "Consoles Portáteis",
    "Handkerchief Towels": "Toalhas Tipo Lenço",
    "Handkerchiefs": "Lenços",
    "Hanfu": "Hanfu",
    "Hard Baits": "Iscas Artificiais",
    "Hardware": "Ferramentas e Ferragens",
    "Hats": "Chapéus",
    "Hats, Scarves & Gloves": "Chapéus, Cachecóis e Luvas",
    "Headband Wigs": "Perucas com Faixa",
    "Headbands": "Faixas de Cabelo",
    "Headboards": "Cabeceiras",
    "Headwear": "Acessórios para Cabeça",
    "Heating & Cooling": "Aquecimento e Refrigeração",
    "Heating,Venting & Cooling": "Aquecimento, Ventilação e Refrigeração",
    "Heeled Sandals": "Sandálias de Salto",
    "Helmets": "Capacetes",
    "Hidden Heel": "Salto Interno",
    "High Boots": "Botas de Cano Alto",
    "High Density Lace Wigs": "Perucas Lace de Alta Densidade",
    "High-Capacity Backpack": "Mochila de Alta Capacidade",
    "Highchairs": "Cadeiras de Alimentação",
    "Hiking": "Trilhas e Caminhadas",
    "Hiking Scarves": "Cachecóis para Trilha",
    "Hiking Shoes": "Calçados para Trilha",
    "Hiking Vests": "Coletes de Trilha",
    "Hippop Necklace": "Colar Hip Hop",
    "Hobby & Collectibles": "Hobbies e Colecionáveis",
    "Hobo Bags": "Bolsas Hobo",
    "Holders & Stands": "Suportes e Bases",
    "Home & Garden": "Casa e Jardim",
    "Home Appliances": "Eletrodomésticos",
    "Home Brewing & Wine Making Barware": "Utensílios para Produção de Cerveja e Vinho",
    "Home Fragrance": "Aromas para Casa",
    "Home Improvenment & Lighting": "Melhorias para Casa e Iluminação",
    "Home Office": "Home Office",
    "Home Safes & Safe Accessories": "Cofres Residenciais e Acessórios",
    "Homecoming Dresses": "Vestidos para Baile",
    "Hooded Down Jacket": "Jaqueta de Pluma com Capuz",
    "Hooks": "Ganchos",
    "Hoop Earring": "Brincos de Argola",
    "Horizontal Bars": "Barras Horizontais",
    "Hotel Uniforms": "Uniformes para Hotelaria",
    "Household Appliances": "Eletrodomésticos",
    "Houses & Habitats": "Casas e Habitats",
    "Human Hair 360 Lace": "Perucas 360 Lace de Cabelo Humano",
    "Human Hair Extensions": "Extensões de Cabelo Humano",
    "Human Hair Full Lace": "Perucas Full Lace de Cabelo Humano",
    "Human Hair Ponytails": "Rabos de Cavalo de Cabelo Humano",
    "Human Hair T-Part": "Perucas T-Part de Cabelo Humano",
    "Humidifier": "Umidificador",
    "Hvac Systems & Parts": "Sistemas HVAC e Peças",
    "Indoor Cycling Bikes": "Bicicletas de Spinning",
    "Induction Cookers": "Cooktops por Indução",
    "Inflatable Toys": "Brinquedos Infláveis",
    "Infrared Alarm Detector": "Detector de Alarme Infravermelho",
    "Ink Bottle": "Frasco de Tinta",
    "Ink Supplies": "Suprimentos de Tinta",
    "Insoles": "Palmilhas",
    "Inspection Tools": "Ferramentas de Inspeção",
    "Instruments & Gauges": "Instrumentos e Medidores",
    "Intercom": "Interfone",
    "Interior Accessories": "Acessórios Internos",
    "Invisible Bras": "Sutiãs Invisíveis",
    "iPhone": "iPhone",
    "Jackets": "Jaquetas",
    "jackets": "Jaquetas",
    "Jeams": "Jeans",
    "Jeans": "Jeans",
    "Jewelry & Watches": "Joias e Relógios",
    "Jewelry Findings": "Componentes para Joias",
    "Jewelry Making": "Fabricação de Joias",
    "Jewelry Packaging": "Embalagens para Joias",
    "Jewelry Sets": "Conjuntos de Joias",
    "Jewish Wigs": "Perucas Judaicas",
    "JK Socks": "Meias Estilo JK",
    "Jumbo Braids": "Tranças Jumbo",
    "Jump Starters": "Auxiliares de Partida",
    "Jumpsuits": "Macacões",
    "K Gold": "Ouro K",
    "K Gold Bracelet": "Pulseira de Ouro K",
    "K Gold Earring": "Brinco de Ouro K",
    "Kalimba": "Kalimba",
    "Kebaya": "Kebaya",
    "Key Box": "Caixa de Chaves",
    "Key Chains": "Chaveiros",
    "Kid's Accessories": "Acessórios Infantis",
    "Kid's Clothing": "Roupas Infantis",
    "Kid's Luggage": "Malas Infantis",
    "Kids Canvas Shoe": "Tênis Infantil de Lona",
    "Kids Gifts": "Presentes Infantis",
    "Kids' Balance Bikes": "Bicicletas de Equilíbrio",
    "Kids' Frames": "Armações Infantis",
    "Kids' Hair Accessories": "Acessórios de Cabelo Infantil",
    "Kids' Sun Hats": "Chapéus de Sol Infantis",
    "Kids' sunglasses": "Óculos de Sol Infantis",
    "Kids' Swing Car": "Carros de Balanço Infantis",
    "Kitchen": "Cozinha",
    "Kitchen Appliances": "Eletrodomésticos de Cozinha",
    "Kitchen Cabinet Storage": "Organizadores de Armário de Cozinha",
    "Kitchen Faucets": "Torneiras de Cozinha",
    "Kitchen Fixtures": "Itens de Cozinha",
    "Kitchen Hardware": "Ferragens de Cozinha",
    "Kitchen Sinks": "Pias de Cozinha",
    "Kitchen Soap Dispensers": "Dispenser de Sabão de Cozinha",
    "Knitted Dresses": "Vestidos de Tricô",
    "Knitted Gloves": "Luvas de Tricô",
    "Knitwears": "Roupas de Tricô",
    "Lab Supplies": "Suprimentos de Laboratório",
    "Lace Braided Wigs": "Perucas Trançadas com Renda",
    "Lace Wigs": "Perucas com Renda",
    "lar": "Lar",
    "Large Size Luggage": "Malas Grandes",
    "Laser Cutting Machine": "Máquina de Corte a Laser",
    "Laser Engraving Machine": "Máquina de Gravação a Laser",
    "Laser Levels": "Níveis a Laser",
    "Laundry Appliances": "Eletrodomésticos de Lavanderia",
    "Layered Necklace": "Colar em Camadas",
    "Ice Crushers": "Trituradores de Gelo",
    "Ice Shorts": "Shorts para Gelo",
    "Leakage Detector": "Detector de Vazamento",
    "Learning & Education": "Aprendizado e Educação",
    "Leather Boots": "Botas de Couro",
    "Leather Casual": "Calçados Casuais de Couro",
    "Leather Coat": "Casaco de Couro",
    "Leather Pants": "Calças de Couro",
    "Leather Shoes": "Sapatos de Couro",
    "Leather Waist Pack": "Pochete de Couro",
    "Leggings": "Leggings",
    "Ignition Systems": "Sistemas de Ignição",
    "License Plate Recognition Camera": "Câmera de Reconhecimento de Placa",
    "Light Bulbs": "Lâmpadas",
    "Lighting Bulbs & Tubes": "Lâmpadas e Tubos",
    "Lightweight Down Jacket": "Jaqueta Leve de Penas",
    "Linear Guides": "Guias Lineares",
    "Lingerie & Loungewear": "Lingerie e Roupas Confortáveis",
    "Links, Rings & Tubes": "Conectores, Anéis e Tubos",
    "Lint Remover": "Removedor de Pelos",
    "Liquid Chalk": "Giz Líquido",
    "Litter & Housebreaking": "Areia Higiênica e Treinamento",
    "Living Room": "Sala de Estar",
    "Living Room Cabinets": "Armários para Sala de Estar",
    "Living Room Chairs": "Cadeiras para Sala de Estar",
    "Living Room Furniture": "Móveis para Sala de Estar",
    "Living Room Sofas": "Sofás para Sala de Estar",
    "Loafers": "Mocassins",
    "Lolita": "Lolita",
    "Long Down Coats": "Casacos Longos de Penas",
    "Long Down Jacket": "Jaqueta Longa de Penas",
    "Long Dresses": "Vestidos Longos",
    "Long Sleeve Dresses": "Vestidos de Manga Longa",
    "Long Sleeve Tees": "Camisetas de Manga Longa",
    "Low Cut Socks": "Meias de Cano Baixo",
    "Iron": "Ferro de Passar",
    "Luggage Covers": "Capas para Malas",
    "Luggage Tags": "Etiquetas para Malas",
    "Luggages & Bags": "Malas e Bolsas",
    "Lunch Bag": "Bolsa Térmica para Almoço",
    "Video Surveillance": "Vigilância por Vídeo",
    "Waist Chain": "Corrente de Cintura",
    "Waist Cinchers": "Cintos Modeladores",
    "Waist Packs": "Pochetes",
    "Waiter Uniforms": "Uniformes de Garçom",
    "Waiting Chairs": "Cadeiras de Espera",
    "Walkers": "Andadores",
    "Walkie Talkie": "Rádio Comunicador",
    "Walkie Talkie Accessories": "Acessórios para Rádio Comunicador",
    "Wall Panels": "Painéis de Parede",
    "Wallet & ID Holder": "Carteira e Porta-Identidade",
    "Wallpapers": "Papéis de Parede",
    "Warm Boots": "Botas Aquecidas",
    "Washed jeans": "Jeans Desbotados",
    "Watch Cases": "Estojos para Relógios",
    "Watch Winders": "Carregadores Automáticos para Relógios",
    "Watchbands": "Pulseiras para Relógios",
    "Watches": "Relógios",
    "Water Dispenser": "Dispensador de Água",
    "Water Filters": "Filtros de Água",
    "Water Filtration": "Sistemas de Filtração de Água",
    "Water Guns, Blasters & Soakers": "Armas de Água",
    "Water Play Equipment": "Brinquedos de Água",
    "Water Purifier": "Purificador de Água",
    "Watering & Irrigation": "Rega e Irrigação",
    "Waterproof Backpack": "Mochila Impermeável",
    "Waterproof Wall Sticker": "Adesivo de Parede Impermeável",
    "Wax Heater": "Aquecedor de Cera",
    "Wear Parts": "Peças de Uso",
    "Wedding Accessories": "Acessórios de Casamento",
    "Wedding Dress": "Vestido de Noiva",
    "Wedding Dresses": "Vestidos de Noiva",
    "Wedding Party Dress": "Vestidos para Festa de Casamento",
    "Wedge Heel": "Salto Bloco",
    "Weight Benches": "Bancos para Musculação",
    "Welding Equipment": "Equipamento de Soldagem",
    "Wheel Parts": "Peças de Roda",
    "Wheels & Flight Joysticks": "Rodas e Joysticks de Voo",
    "Wig Stands": "Suportes para Perucas",
    "Wigs": "Perucas",
    "Wildlife Camera": "Câmera para Vida Selvagem",
    "Winches": "Guinchos",
    "Window Door Sensor": "Sensor de Porta e Janela",
    "Window Foils & Solar Protection": "Filmes para Janelas e Proteção Solar",
    "Windshield Wipers": "Limpa-Para-Brisa",
    "Winter Home Shoes": "Calçados Internos de Inverno",
    "Winter Socks": "Meias de Inverno",
    "Winter Warm Sleepwear": "Pijamas de Inverno",
    "Wiring Accessories": "Acessórios de Fiação",
    "Wok": "Panela Wok",
    "Womens Belts": "Cintos Femininos",
    "Womens Boots": "Botas Femininas",
    "Womens Casual Shoes": "Calçados Casuais Femininos",
    "Womens Clothing": "Roupas Femininas",
    "Womens Fold Wallet": "Carteira Dobrável Feminina",
    "Womens Necklace": "Colar Feminino",
    "Womens Pants": "Calças Femininas",
    "Womens Sandals & Slippers": "Sandálias e Chinelos Femininos",
    "Womens Sunglasses": "Óculos de Sol Femininos",
    "Wooden Blocks": "Blocos de Madeira",
    "Wool & Blends Coats": "Casacos de Lã e Misturas",
    "Work & Safety Shoes": "Calçados de Trabalho e Segurança",
    "Work Wear & Uniforms": "Roupas de Trabalho e Uniformes",
    "Workplace Safety Supplies": "Suprimentos de Segurança no Trabalho",
    "Writing & Correction Supplies": "Material de Escrita e Correção",
    "Writing Pad": "Bloco de Anotações",
    "Yoyo": "Ioiô",
    "Zipper Bag": "Bolsa com Zíper",
    "Phone is not bind": "Telefone não vinculado",
    "English": "Inglês",
    "Portuguese": "Português",
    "Arabic": "Árabe",
    "Supplier Team": "Equipe de Fornecedores",
    "Hosting": "Hospedagem",

    "Upload file header line error": "Erro na linha de cabeçalho do arquivo de upload",
    "Data is empty": "Os dados estão vazios",
    "ResetPassword": "Redefinir Senha",
    "Accesses": "Acessos",
    "Client Name": "Nome do Cliente",
    "Initial password": "Senha Inicial",

    "Store type": "Tipo de Loja",
    "Store URL": "URL da Loja",
    "Token": "Token",
    "Secret key": "Chave Secreta",
    "Reauthorization": "Reautorização",
    "Clients": "Clientes",
    "Adm access": "Acesso de Adm",

    "REGISTER": "REGISTRE-SE",
    "Please enter your email address": "Por favor, insira seu endereço de e-mail",
    "Please input password": "Por favor, insira a senha",
    "Slide to get your CAPTCHA": "Deslize para obter o CAPTCHA",
    "Please fill in email address as your username": "Por favor, preencha o endereço de e-mail como nome de usuário",
    "Captcha": "Captcha",
    "Please fill in the CAPTCHA you received": "Por favor, preencha o CAPTCHA recebido",
    "Please set your password": "Por favor, defina sua senha",
    "Please confirm your password": "Por favor, confirme sua senha",
    "Password confirm": "Confirmação de Senha",
    "Please fill in the name": "Por favor, preencha o nome",
    "Mobile": "Celular",
    "Please Select": "Por favor, selecione",
    "Please set your mobile": "Por favor, configure seu celular",
    "Invitation Code": "Código de Convite",
    "Please confirm your code": "Por favor, confirme seu código",
    "CREATE AN ACCOUNT": "CRIE UMA CONTA",
    "Already had an account?": "Já tem uma conta?",

    "Change password": "Alterar Senha",
    "Please fill in your email address": "Por favor, preencha seu endereço de e-mail",
    "Please set your new password": "Por favor, defina sua nova senha",
    "Please confirm your new password": "Por favor, confirme sua nova senha",
    "New password": "Nova Senha",
    "Confirm password must be filled in": "Confirmação de senha deve ser preenchida",
    "Mobile must be filled in": "O celular deve ser preenchido",
    "The password and confirm password must be the same": "A senha e a confirmação devem ser iguais",
    "Please select the country first": "Selecione o país primeiro",
    "Please fill in the mobile": "Por favor, preencha o celular",
    "pre-order item inventory": "Inventário de itens de pré-encomenda",
    "packing inventory": "Inventário de embalagem",

    "Recharge Application": "Solicitação de Recarga",
    "View History": "Ver Histórico",
    "Recharge Records": "Registros de Recarga",
    "Payment-link Request": "Solicitação de Link de Pagamento",
    "Please select the payment method first": "Selecione primeiro o método de pagamento",
    "Please fill in the amount.": "Por favor, preencha o valor.",

    "Channel": "Canal",
    "Top-up Request": "Solicitação de Recarga",
    "Upload Evidence": "Enviar Evidências",
    "Evidence": "Evidência",
    "createdAt": "Criado em",
    "updatedAt": "Atualizado em",
    "Too many pictures upload!": "Muitas fotos carregadas!",
    "Put payment evidence": "Enviar Evidência de Pagamento",
    "Pay difference for order": "Pagar Diferença do Pedido",
    "Pay for CPF checking": "Pagar por Consulta de CPF",
    "Add bonus": "Adicionar Bônus",
    "Pay for other reason": "Pagar por Outro Motivo",
    "Please fill the reason": "Por favor, preencha o motivo",

    "Wait for payment link": "Aguardando Link de Pagamento",
    "Wait for payment evidence": "Aguardando Comprovante de Pagamento",
    "Wait for review": "Aguardando Revisão",
    "Evidence Pass": "Evidência Aprovada",
    "Evidence Reject": "Evidência Rejeitada",
    "Ticket Done": "Concluído",
    "Closed": "Fechado",
    "待复核": "Revisão Pendente",
    "待确认": "Aguardando Confirmação",

    "Detail": "Detalhe",
    "Wholesale": "Atacado",
    "Wholesale Products": "Produtos",
    "Wholesale Favorites": "Favoritos",
    "Wholesale Cart": "Carrinho de Atacado",
    "Wholesale Orders": "Pedidos",
    "Add to cart": "Adicionar ao carrinho",
    "Cart": "Carrinho",

    "BatchRestore": "Restauração em Lote",
    "RestoreALL": "Restaurar Tudo",

    "Add Cart": "Adicionar ao Carrinho",
    "Welcome": "Bem-vindo",
    "Quit": "Sair",
    "Member Center": "Centro de Membros",
    "My order": "Meus Pedidos",
    "My favorites": "Meus Favoritos",
    "Hot": "Em Destaque",
    "search": "procurar",
    "Search": "Procurar",
    "Shopping Cart": "Carrinho de Compras",
    "Select by subcategory": "Selecionar por Subcategoria",
    "whole": "tudo",
    "stock": "estoque",
    "sort": "ordenar",
    "Integrated": "Integrado",
    "Barcode": "Código de Barras",
    "barcode": "código de barras",
    "code": "código",
    "Code": "Código",
    "Only look at availability": "Verificar apenas disponibilidade",
    "Recently purchased": "Comprados Recentemente",
    "Favorites": "Favoritos",
    "No related products found": "Nenhum produto relacionado encontrado",
    "Minimum purchase for each spec": "Compra mínima por especificação",
    "multiply": "multiplicar",
    "shopping cart": "carrinho de compras",
    "My shopping cart": "Meu Carrinho de Compras",
    "Fill in and verify order information": "Preencha e verifique as informações do pedido",
    "Successfully submitted order": "Pedido enviado com sucesso",
    "Search for items (number/name) in the shopping cart": "Buscar itens (número/nome) no carrinho",
    "No.": "Nº",
    "commodity": "Produto",
    "quantity": "Quantidade",
    "Auxiliary Quantity": "Quantidade Auxiliar",
    "operation": "Ação",
    "price": "Preço",
    "Minimum": "Mínimo",
    "Select All": "Selecionar Tudo",
    "items": "Unid.",
    "total price": "Preço Total",
    "Continue purchasing": "Continuar Comprando",
    "Go settle": "Finalizar Compra",
    "Go Home": "Ir para a Página Inicial",
    "Receiving information": "Informações de Recebimento",
    "Add shipping address": "Adicionar Endereço de Entrega",
    "No default address": "Nenhum endereço padrão",
    "edit": "Editar",
    "More addresses": "Mais Endereços",
    "Collapse address": "Ocultar Endereço",
    "Remarks": "Observações",
    "Co subtract": "Subtrair Co",
    "The payment is for reference only, and the final invoice data from the merchant shall prevail": "O pagamento é apenas para referência; os dados finais da fatura fornecidos pelo comerciante prevalecerão.",
    "Return to shopping cart": "Voltar ao Carrinho de Compras",
    "Place order": "Fazer Pedido",
    "Order submitted successfully, please make payment as soon as possible": "Pedido enviado com sucesso. Por favor, efetue o pagamento o mais rápido possível.",
    "Payable amount": "Valor a Pagar",
    "Order details": "Detalhes do Pedido",
    "There is currently no available payment method. Please contact the merchant for payment": "Atualmente, não há método de pagamento disponível. Contate o comerciante.",
    "Go order center": "Ir para a Central de Pedidos",
    "Edit shipping address": "Editar Endereço de Entrega",
    "Consignee": "Destinatário",
    "Language": "Idioma",
    "more": "Mais",
    "View large images": "Ver Imagens em Tamanho Grande",
    "Add fav": "Adicionar aos Favoritos",
    "Cancel Favorite": "Cancelar Favorito",
    "I've seen it again and again": "Já vi isso várias vezes",
    "Please log in": "Por favor, faça login",
    "Product details": "Detalhes do Produto",
    "Related products": "Produtos Relacionados",
    "Volume": "Volume",
    "Stock": "Estoque",
    "No product details currently available": "Nenhum detalhe do produto disponível no momento",
    "Payment page": "Página de Pagamento",
    "Settlement page": "Página de Liquidação",
    "My Addresses": "Meus Endereços",
    "Add a new one": "Adicionar Novo",
    "Telephone": "Telefone",
    "Attachment": "Anexo",
    "Detailed address": "Endereço Detalhado",
    "Invoice": "Fatura",
    "Ceate time": "Data de Criação",
    "Paid time": "Data de Pagamento",
    "Thumbnail": "Miniatura",
    "Logistics number": "Número de Logística",
    "Product Unit": "Unidade do Produto",
    "Purchase Qty": "Quantidade Comprada",
    "Supply unit price(USD)": "Preço Unitário de Fornecimento (USD)",
    "Subtotal(USD)": "Subtotal (USD)",
    "OrderNumber": "Número do Pedido",
    "TaxAmount": "Valor do Imposto",
    "Download PDF": "Baixar PDF",
    "Shipped": "Enviado",
    "To be shipped": "A Ser Enviado",
    "All orders": "Todos os Pedidos",
    "Frequent purchased list": "Lista de Compras Frequentes",
    "My bonus": "Meu Bônus",
    "Your shopping cart is still empty": "Seu carrinho de compras ainda está vazio",

    "Minimum purchase ": "Compra mínima ",
    "The quantity must be a multiple of ": "A quantidade deve ser um múltiplo de ",
    "Topest you can buy is: ": "O máximo que você pode comprar é: ",
    "Add to Cart Success": "Adicionado ao carrinho com sucesso",
    "Please confirm whether to remove this product?": "Por favor, confirme se deseja remover este produto",
    "Edit Address successful!": "Endereço editado com sucesso!",
    "Order submitted successfully!": "Pedido enviado com sucesso!",
    "Are you sure want to delete this address?": "Tem certeza de que deseja excluir este endereço?",
    "Removed successfully.": "Removido com sucesso.",
    "Please select at least one product item": "Por favor, selecione pelo menos um produto",
    "Are you sure to abandon it?": "Tem certeza de que deseja abandoná-lo?",
    "Cancel the payment": "Cancelar Pagamento",
    "Balance is not enough": "Saldo insuficiente",
    "Full Name required": "Nome Completo Obrigatório",
    "Successfully saved": "Salvo com sucesso",
    "User Phone modified successfully": "Telefone do usuário alterado com sucesso",
    "Leave a message to the merchant": "Deixe uma mensagem para o vendedor",
    "Total of ": "Total de ",
    "products payable": "produtos a pagar",
    "Order Center": "Central de Pedidos",
    "Orders": "Pedidos",
    "Receiving Address": "Endereço de Entrega",
    "Account Center": "Central da Conta",
    "Recharge request": "Solicitação de Recarga",
    "Browsing history": "Histórico de Navegação",
    "Pending shipping": "Envio Pendente",
    "ALL": "TODOS",
    "Default": "Padrão",
    "City and Street": "Cidade e Rua",
    "View Invoice": "Ver Fatura",
    "Enter remark": "Insira uma Observação",
}